import {storeSet} from "@/mixins/Auth.js";

export default [
    {
        path: "/",
        component: () => import('../views/Home.vue'),
        name: "Home",
        meta: {name: "Home", title: "홈"},
        redirect: '/myinfo'
    },
    {
        path: "/auth",
        component: () => import('../views/auth/Login.vue'),
        name: "Login",
        meta: {title: '로그인',},
    },
    {
        path: "/member",
        component: () => import('../views/RouteView.vue'),
        name: "Member",
        beforeEnter: storeSet,
        meta: {
            name: "Member",
            title: "회원관리",
            storeConfig: {userInfo: true, checkAccess: true},
            authRequired: true,
            storeRequired: true,
            sideMenu: true,
            log: {depth: 2, access: "회원관리->이웃고객관리"},
            accessIdx: "MEMBER"
        },
        children: [
            {
                path: 'partner',
                component: () => import('../views/partner/PartnerRouteView.vue'),
                beforeEnter: storeSet,
                meta: {
                    name: "PartnerMediaMain",
                    title: "이웃파트너 관리",
                    sideName: "이웃파트너 관리",
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'partner',
                    storeConfig: {userInfo: true, checkAccess: true},
                    log: {depth: 2, access: "회원관리->이웃파트너관리"},
                    accessIdx: "MEMBER_PARTNERMGMT"
                },
                children: [
                    {
                        path: "media",
                        component: () => import('../views/partner/PartnerMedia.vue'),
                        name: "PartnerMedia",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerMedia",
                            title: "이웃파트너 관리",
                            sideName: "이웃파트너 관리",
                            authRequired: true,
                            storeRequired: true,
                            side: 'partner',
                            storeConfig: {userInfo: true, checkAccess: true},
                            log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너"},
                            accessIdx: "MEMBER_PARTNERMGMT_VIDEOPARTNER"
                        },
                    },
                    {
                        path: "media/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerMediaDetail.vue'),
                        name: "PartnerMediaDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerMediaDetail",
                            title: "영상 이웃파트너 상세",
                            authRequired: true,
                            storeConfig: { userInfo: true, checkAccess: true },
                            storeRequired: true,
                            sideMenu: false,
                            side: 'partner',
                            log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너->상세"},
                            accessIdx: "MEMBER_PARTNERMGMT_VIDEOPARTNER_DETAIL",
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerMediaDetailMain.vue'),
                                name: "PartnerMediaDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerMediaDetailMain",
                                    title: "영상 이웃파트너 상세",
                                    authRequired: true,
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너->상세->기본정보"},
                                    accessIdx: "MEMBER_PARTNERMGMT_VIDEOPARTNER_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerMediaDetailUpload.vue'),
                                name: "PartnerMediaDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerMediaDetailUpload",
                                    title: "영상 이웃파트너 상세",
                                    authRequired: true,
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너->상세->업로드 콘텐츠"},
                                    accessIdx: "MEMBER_PARTNERMGMT_VIDEOPARTNER_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerMediaDetailPayment.vue'),
                                name: "PartnerMediaDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerMediaDetailPayment",
                                    title: "영상 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너->상세->결제 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_VIDEOPARTNER_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerMediaDetailPoint.vue'),
                                name: "PartnerMediaDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerMediaDetailPoint",
                                    title: "영상 이웃파트너 상세",
                                    authRequired: true,
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    storeRequired: true,
                                    sideMenu: false,
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너->상세->(구) 포인트 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_VIDEOPARTNER_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerMediaDetailCoin.vue'),
                                name: "PartnerMediaDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerMediaDetailCoin",
                                    title: "영상 이웃파트너 상세",
                                    authRequired: true,
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너->상세->(구) 코인 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_VIDEOPARTNER_DETAIL_COINHIST",
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerMediaDetailGold.vue'),
                                name: "PartnerMediaDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerMediaDetailGold",
                                    title: "영상 이웃파트너 상세",
                                    authRequired: true,
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너->상세->골드 코인 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_VIDEOPARTNER_GOLDCOINHISTORY",
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerMediaDetailTrade.vue'),
                                name: "PartnerMediaDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerMediaDetailPrize",
                                    title: "영상 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너->상세->경품 교환 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_VIDEOPARTNER_DETAIL_GIFTHIST"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerMediaDetailAgainTrade.vue'),
                                name: "PartnerMediaDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerMediaDetailAgainTrade",
                                    title: "영상 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너->상세->또바몰 경품 교환 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_VIDEOPARTNER_AGAINHISTORY",
                                },
                            },
                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerMediaDetailGiftBoxIssue.vue'),
                                name: "PartnerMediaDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerMediaDetailGiftBoxIssue",
                                    title: "영상 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너->상세->선물상자 지급 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_VIDEOPARTNER_GIFTHISTORY",
                                },
                            },
                            {
                                path: "zone",
                                component: () => import('../views/partner/PartnerZone.vue'),
                                name: "PartnerMediaZone",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerMediaZone",
                                    title: "영상 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너->상세->이웃파트너존게시물"},
                                    accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_DETAIL_GIFTHIST"
                                },
                            },
                        ]
                    },

                    {
                        path: "ad",
                        component: () => import('../views/partner/PartnerAd.vue'),
                        name: "PartnerAd",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerAd",
                            title: "이웃파트너 관리",
                            sideName: "이웃파트너 관리",

                            sideMenu: false,
                            side: 'partner',
                            storeConfig: { userInfo: true, checkAccess: true },
                            authRequired: true,
                            storeRequired: true,
                            log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너"},
                            accessIdx: "MEMBER_PARTNERMGMT_ADPARTNER"
                        },
                    },
                    {
                        path: "ad/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerAdDetail.vue'),
                        name: "PartnerAdDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerAdDetail",
                            title: "광고 이웃파트너 상세",

                            side: 'partner',
                            storeConfig: { userInfo: true, checkAccess: true },
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_PARTNERMGMT_ADPARTNER_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerAdDetailMain.vue'),
                                name: "PartnerAdDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailMain",
                                    title: "광고 이웃파트너 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->기본정보"},
                                    accessIdx: "MEMBER_PARTNERMGMT_ADPARTNER_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerAdDetailUpload.vue'),
                                name: "PartnerAdDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailUpload",
                                    title: "광고 이웃파트너 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->업로드 광고"},
                                    accessIdx: "MEMBER_PARTNERMGMT_ADPARTNER_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerAdDetailPayment.vue'),
                                name: "PartnerAdDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailPayment",
                                    title: "광고 이웃파트너 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->결제 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_ADPARTNER_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerAdDetailPoint.vue'),
                                name: "PartnerAdDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailPoint",
                                    title: "광고 이웃파트너 상세",

                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->(구) 포인트 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_ADPARTNER_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerAdDetailCoin.vue'),
                                name: "PartnerAdDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailCoin",
                                    title: "광고 이웃파트너 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->(구) 코인 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_ADPARTNER_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerAdDetailGold.vue'),
                                name: "PartnerAdDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailGold",
                                    title: "광고 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: { depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->골드 코인 내역" },
                                    accessIdx: "MEMBER_PARTNERMGMT_ADPARTNER_GOLDCOINHISTORY",
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerAdDetailTrade.vue'),
                                name: "PartnerAdDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailTrade",
                                    title: "광고 이웃파트너 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->경품 교환 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_ADPARTNER_DETAIL_GIFTHIST"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerAdDetailAgainTrade.vue'),
                                name: "PartnerAdDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailAgainTrade",
                                    title: "광고 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: { depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->또바몰 경품 교환 내역" },
                                    accessIdx: "MEMBER_PARTNERMGMT_ADPARTNER_AGAINHISTORY",
                                },
                            },
                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerAdDetailGiftBoxIssue.vue'),
                                name: "PartnerAdDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailGiftBoxIssue",
                                    title: "광고 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: { depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->선물상자 지급 내역" },
                                    accessIdx: "MEMBER_PARTNERMGMT_ADPARTNER_GIFTHISTORY",
                                },
                            },
                            {
                                path: "zone",
                                component: () => import('../views/partner/PartnerZone.vue'),
                                name: "PartnerAdZone",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdZone",
                                    title: "광고 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->이웃파트너존게시물"},
                                    accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_DETAIL_GIFTHIST"
                                },
                            },
                        ]
                    },
                    {
                        path: "shopping",
                        component: () => import('../views/partner/PartnerShopping.vue'),
                        name: "PartnerShopping",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerShopping",
                            title: "이웃파트너 관리",
                            sideName: "이웃파트너 관리",
                            sideMenu: false,
                            side: 'partner',
                            storeConfig: { userInfo: true, checkAccess: true },
                            authRequired: true,
                            storeRequired: true,
                            log: {depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너"},
                            accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER"
                        },
                    },
                    {
                        path: "shopping/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerShoppingDetail.vue'),
                        name: "PartnerShoppingDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerShoppingDetail",
                            title: "쇼핑 이웃파트너 상세",
                            side: 'partner',
                            storeConfig: { userInfo: true, checkAccess: true },
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너->상세"},
                            accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerShoppingDetailMain.vue'),
                                name: "PartnerShoppingDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerShoppingDetailMain",
                                    title: "쇼핑 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너->상세->기본정보"},
                                    accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerShoppingDetailUpload.vue'),
                                name: "PartnerShoppingDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerShoppingDetailUpload",
                                    title: "쇼핑 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너->상세->업로드 쇼핑"},
                                    accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerShoppingDetailPayment.vue'),
                                name: "PartnerShoppingDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerShoppingDetailPayment",
                                    title: "쇼핑 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너->상세->결제 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerShoppingDetailPoint.vue'),
                                name: "PartnerShoppingDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerShoppingDetailPoint",
                                    title: "쇼핑 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너->상세->(구) 포인트 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerShoppingDetailCoin.vue'),
                                name: "PartnerShoppingDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerShoppingDetailCoin",
                                    title: "쇼핑 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너->상세->(구) 코인 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerShoppingDetailGold.vue'),
                                name: "PartnerShoppingDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerShoppingDetailGold",
                                    title: "쇼핑 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: { depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너->상세->골드 코인 내역" },
                                    accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_GOLDCOINHISTORY",
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerShoppingDetailTrade.vue'),
                                name: "PartnerShoppingDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailTrade",
                                    title: "쇼핑 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너->상세->경품 교환 내역"},
                                    accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_DETAIL_GIFTHIST"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerShoppingDetailAgainTrade.vue'),
                                name: "PartnerShoppingDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerShoppingDetailAgainTrade",
                                    title: "쇼핑 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: { depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너->상세->또바몰 경품 교환 내역" },
                                    accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_AGAINHISTORY",
                                },
                            },
                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerShoppingDetailGiftBoxIssue.vue'),
                                name: "PartnerShoppingDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerShoppingDetailGiftBoxIssue",
                                    title: "쇼핑 이웃파트너 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: { depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너->상세->선물상자 지급 내역" },
                                    accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_GIFTHISTORY",
                                },
                            },
                            {
                                path: "zone",
                                component: () => import('../views/partner/PartnerZone.vue'),
                                name: "PartnerShoppingZone",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerShoppingZone",
                                    title: "쇼핑 이웃파트너 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너->상세->이웃파트너존게시물"},
                                    accessIdx: "MEMBER_PARTNERMGMT_SHOPPARTNER_DETAIL_GIFTHIST"
                                },
                            },

                        ],
                    },
                ]
            },
            {
                path: "partner/sleep",
                component: () => import('../views/partner/SleepPartnerRouteView.vue'),
                name: "PartnerSleepMain",
                beforeEnter: storeSet,
                meta: {
                    name: "PartnerSleepMedia",
                    title: "계정 정지 고객 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'sleep',
                    log: {depth: 2, access: "회원관리->계정 정지 고객 관리"},
                    accessIdx: "MEMBER_SUSPENDSLEEP"
                },
                children: [
                    {
                        path: "media",
                        component: () => import('../views/partner/PartnerSleepMedia.vue'),
                        name: "PartnerSleepMedia",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerSleepMedia",
                            title: "계정 정지 고객 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'sleep',
                            log: {depth: 2, access: "회원관리->계정 정지 고객 관리->영상 이웃파트너"},
                            accessIdx: "MEMBER_SUSPENDSLEEP_VIDEOPARTNER"
                        },
                    },
                    {
                        path: "media/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerSleepMediaDetail.vue'),
                        name: "PartnerSleepMediaDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerSleepMediaDetail",
                            title: "계정 정지 고객 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'sleep',
                            log: {depth: 2, access: "회원관리->계정 정지 고객 관리->영상 이웃파트너->상세"},
                            accessIdx: "MEMBER_SUSPENDSLEEP_VIDEOPARTNER_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerSleepMediaDetailMain.vue'),
                                name: "PartnerSleepMediaDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepMediaDetailMain",
                                    title: "계정 정지 고객 상세",
                                    authRequired: true,
                                    storeRequired: true,
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_VIDEOPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerSleepMediaDetailUpload.vue'),
                                name: "PartnerSleepMediaDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepMediaDetailUpload",
                                    title: "계정 정지 고객 상세",
                                    authRequired: true,
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_VIDEOPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerSleepMediaDetailPayment.vue'),
                                name: "PartnerSleepMediaDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepMediaDetailPayment",
                                    title: "계정 정지 고객 상세",
                                    authRequired: true,
                                    storeRequired: true,
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    sideMenu: false,
                                    side: 'partner',
                                    accessIdx: "MEMBER_SUSPENDSLEEP_VIDEOPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerSleepMediaDetailPoint.vue'),
                                name: "PartnerSleepMediaDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepMediaDetailPoint",
                                    title: "계정 정지 고객 상세",
                                    authRequired: true,
                                    storeRequired: true,
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_VIDEOPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerSleepMediaDetailCoin.vue'),
                                name: "PartnerSleepMediaDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepMediaDetailCoin",
                                    title: "계정 정지 고객 상세",
                                    authRequired: true,
                                    storeRequired: true,
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_VIDEOPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerSleepMediaDetailGold.vue'),
                                name: "PartnerSleepMediaDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepMediaDetailGold",
                                    title: "계정 정지 고객 상세",
                                    authRequired: true,
                                    storeRequired: true,
                                    side: "sleep",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    sideMenu: false,
                                    log: { depth: 2, access: "회원관리->계정 정지 고객 관리->영상 이웃파트너->상세->골드 코인 내역" },
                                    accessIdx: "MEMBER_SUSPENDSLEEP_VIDEOPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerSleepMediaDetailTrade.vue'),
                                name: "PartnerSleepMediaDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailTrade",
                                    title: "계정 정지 고객 상세",
                                    authRequired: true,
                                    storeRequired: true,
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    sideMenu: false,
                                    side: 'sleep',
                                    accessIdx: "MEMBER_SUSPENDSLEEP_VIDEOPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerSleepMediaDetailAgainTrade.vue'),
                                name: "PartnerSleepMediaDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepMediaDetailAgainTrade",
                                    title: "계정 정지 고객 상세",
                                    authRequired: true,
                                    storeRequired: true,
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    sideMenu: false,
                                    side: "sleep",
                                    log: { depth: 2, access: "회원관리->계정 정지 고객 관리->영상 이웃파트너->상세->또바몰 경품 교환 내역" },
                                    accessIdx: "MEMBER_SUSPENDSLEEP_VIDEOPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerSleepMediaDetailGiftBoxIssue.vue'),
                                name: "PartnerSleepMediaDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepMediaDetailGiftBoxIssue",
                                    title: "계정 정지 고객 상세",
                                    authRequired: true,
                                    storeRequired: true,
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    sideMenu: false,
                                    side: "sleep",
                                    log: { depth: 2, access: "회원관리->계정 정지 고객 관리->영상 이웃파트너->상세->선물상자 지급 내역" },
                                    accessIdx: "MEMBER_SUSPENDSLEEP_VIDEOPARTNER_DETAIL",
                                },
                            },
                        ]
                    },
                    {
                        path: "ad",
                        component: () => import('../views/partner/PartnerSleepAd.vue'),
                        name: "PartnerSleepAd",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerSleepAd",
                            title: "계정 정지 고객 관리",
                            side: 'sleep',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 2, access: "회원관리->계정 정지 고객 관리->광고 이웃파트너"},
                            accessIdx: "MEMBER_SUSPENDSLEEP_ADPARTNER"
                        },
                    },
                    {
                        path: "ad/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerSleepAdDetail.vue'),
                        name: "PartnerSleepAdDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerSleepAdDetail",
                            title: "계정 정지 고객 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'sleep',
                            log: {depth: 2, access: "회원관리->계정 정지 고객 관리->광고 이웃파트너->상세"},
                            accessIdx: "MEMBER_SUSPENDSLEEP_ADPARTNER_DETAIL",

                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerSleepAdDetailMain.vue'),
                                name: "PartnerSleepAdDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepAdDetailMain",
                                    title: "계정 정지 고객 상세",
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_ADPARTNER_DETAIL"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerSleepAdDetailUpload.vue'),
                                name: "PartnerSleepAdDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepAdDetailUpload",
                                    title: "계정 정지 고객 상세",
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_ADPARTNER_DETAIL"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerSleepAdDetailPayment.vue'),
                                name: "PartnerSleepAdDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepAdDetailPayment",
                                    title: "광고 이웃파트너 상세",
                                    authRequired: true,
                                    storeRequired: true,
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->결제 내역"},
                                    accessIdx: "MEMBER_SUSPENDSLEEP_ADPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerSleepAdDetailPoint.vue'),
                                name: "PartnerSleepAdDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepAdDetailPoint",
                                    title: "계정 정지 고객 상세",
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_ADPARTNER_DETAIL"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerSleepAdDetailCoin.vue'),
                                name: "PartnerSleepAdDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepAdDetailCoin",
                                    title: "계정 정지 고객 상세",
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_ADPARTNER_DETAIL"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerSleepAdDetailGold.vue'),
                                name: "PartnerSleepAdDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepAdDetailGold",
                                    title: "계정 정지 고객 상세",
                                    side: "sleep",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    log: { depth: 2, access: "회원관리->계정 정지 고객 관리->광고 이웃파트너->상세->골드 코인 내역" },
                                    accessIdx: "MEMBER_SUSPENDSLEEP_ADPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerSleepAdDetailTrade.vue'),
                                name: "PartnerSleepAdDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailTrade",
                                    title: "계정 정지 고객 상세",
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,

                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_ADPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerSleepAdDetailAgainTrade.vue'),
                                name: "PartnerSleepAdDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepAdDetailAgainTrade",
                                    title: "계정 정지 고객 상세",
                                    side: "sleep",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    log: { depth: 2, access: "회원관리->계정 정지 고객 관리->광고 이웃파트너->상세->또바몰 경품 교환 내역" },
                                    accessIdx: "MEMBER_SUSPENDSLEEP_ADPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerSleepAdDetailGiftBoxIssue.vue'),
                                name: "PartnerSleepAdDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepAdDetailGiftBoxIssue",
                                    title: "계정 정지 고객 상세",
                                    side: "sleep",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    log: { depth: 2, access: "회원관리->계정 정지 고객 관리->광고 이웃파트너->상세->선물상자 지급 내역" },
                                    accessIdx: "MEMBER_SUSPENDSLEEP_ADPARTNER_DETAIL",
                                },
                            },
                        ]
                    },
                    {
                        path: "shopping",
                        component: () => import('../views/partner/PartnerSleepShopping.vue'),
                        name: "PartnerSleepShopping",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerSleepShopping",
                            title: "계정 정지 고객 관리",
                            side: 'sleep',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 2, access: "회원관리->계정 정지 고객 관리->쇼핑 이웃파트너"},
                            accessIdx: "MEMBER_SUSPENDSLEEP_SHOPPARTNER"
                        },
                    },
                    {
                        path: "shopping/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerSleepShoppingDetail.vue'),
                        name: "PartnerSleepShoppingDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerSleepShoppingDetail",
                            title: "계정 정지 고객 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'sleep',
                            log: {depth: 2, access: "회원관리->계정 정지 고객 관리->쇼핑 이웃파트너->상세"},
                            accessIdx: "MEMBER_SUSPENDSLEEP_SHOPPARTNER_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerSleepShoppingDetailMain.vue'),
                                name: "PartnerSleepShoppingDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepShoppingDetailMain",
                                    title: "계정 정지 고객 상세",
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_SHOPPARTNER_DETAIL"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerSleepShoppingDetailUpload.vue'),
                                name: "PartnerSleepShoppingDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepShoppingDetailUpload",
                                    title: "계정 정지 고객 상세",
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_SHOPPARTNER_DETAIL"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerSleepShoppingDetailPayment.vue'),
                                name: "PartnerSleepShoppingDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepShoppingDetailPayment",
                                    title: "쇼핑 이웃파트너 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->결제 내역"},
                                    accessIdx: "MEMBER_SUSPENDSLEEP_SHOPPARTNER_DETAIL"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerSleepShoppingDetailPoint.vue'),
                                name: "PartnerSleepShoppingDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepShoppingDetailPoint",
                                    title: "계정 정지 고객 상세",
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_SHOPPARTNER_DETAIL"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerSleepShoppingDetailCoin.vue'),
                                name: "PartnerSleepShoppingDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepShoppingDetailCoin",
                                    title: "계정 정지 고객 상세",
                                    side: 'sleep',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_SUSPENDSLEEP_SHOPPARTNER_DETAIL"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerSleepShoppingDetailGold.vue'),
                                name: "PartnerSleepShoppingDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepShoppingDetailGold",
                                    title: "계정 정지 고객 상세",
                                    side: "sleep",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    log: { depth: 2, access: "회원관리->계정 정지 고객 관리->쇼핑 이웃파트너->상세->골드 코인 내역" },
                                    accessIdx: "MEMBER_SUSPENDSLEEP_SHOPPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerSleepShoppingDetailTrade.vue'),
                                name: "PartnerSleepShoppingDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailTrade",
                                    title: "계정 정지 고객 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                    accessIdx: "MEMBER_SUSPENDSLEEP_SHOPPARTNER_DETAIL"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerSleepShoppingDetailAgainTrade.vue'),
                                name: "PartnerSleepShoppingDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepShoppingDetailAgainTrade",
                                    title: "계정 정지 고객 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: "sleep",
                                    log: { depth: 2, access: "회원관리->계정 정지 고객 관리->쇼핑 이웃파트너->상세->또바몰 경품 교환 내역" },
                                    accessIdx: "MEMBER_SUSPENDSLEEP_SHOPPARTNER_DETAIL",
                                },
                            },
                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerSleepShoppingDetailGiftBoxIssue.vue'),
                                name: "PartnerSleepShoppingDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerSleepShoppingDetailGiftBoxIssue",
                                    title: "계정 정지 고객 상세",
                                    storeConfig: { userInfo: true, checkAccess: true },
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: "sleep",
                                    log: { depth: 2, access: "회원관리->계정 정지 고객 관리->쇼핑 이웃파트너->상세->선물상자 지급 내역" },
                                    accessIdx: "MEMBER_SUSPENDSLEEP_SHOPPARTNER_DETAIL",
                                },
                            },
                        ]
                    },
                ]
            },


            {
                path: "terminate",
                component: () => import('../views/member/TerminateRouteView.vue'),
                name: "MemberTerminateMain",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberTerminateMain",
                    title: "해지고객관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'terminate',
                    log: {depth: 2, access: "회원관리->해지&탈퇴 회원"},
                    accessIdx: "MEMBER_TERMINATED"
                },
                children: [
                    {
                        path: "dispose",
                        component: () => import('../views/member/MemberTerminate.vue'),
                        name: "MemberTerminate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MemberTerminate",
                            title: "해지고객관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'terminate',
                            log: {depth: 2, access: "회원관리->해지&탈퇴 회원->파기"},
                            accessIdx: "MEMBER_TERMINATED_DESTROY"
                        },
                    },
                    {
                        path: "day",
                        component: () => import('../views/member/MemberTerminateDay.vue'),
                        name: "MemberTerminateDay",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MemberTerminateDay",
                            title: "해지고객관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'terminate',
                            log: {depth: 2, access: "회원관리->해지&탈퇴 회원->해지 후 5일"},
                            accessIdx: "MEMBER_TERMINATED_TERM5D"
                        },
                    },
                    {
                        path: "threeYear",
                        component: () => import('../views/member/MemberTerminateThreeYear.vue'),
                        name: "MemberTerminateThreeYear",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MemberTerminateThreeYear",
                            title: "해지고객관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'terminate',
                            log: {depth: 2, access: "회원관리->해지&탈퇴 회원->해지 후 3년(민원)"},
                            accessIdx: "MEMBER_TERMINATED_TERM3Y"
                        },
                    },
                    {
                        path: "fiveYear",
                        component: () => import('../views/member/MemberTerminateFiveYear.vue'),
                        name: "MemberTerminateFiveYear",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MemberTerminateFiveYear",
                            title: "해지고객관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'terminate',
                            log: {depth: 2, access: "회원관리->해지&탈퇴 회원->해지 후 5년(결제)"},
                            accessIdx: "MEMBER_TERMINATED_TERM5Y"
                        },
                    },
                    {
                        path: "media/day/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerTerminateDayMediaDetail.vue'),
                        name: "PartnerTerminateDayMediaDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerTerminateDayMediaDetail",
                            title: "해지고객관리 상세",
                            side: 'terminate',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerTerminateDayMediaDetailMain.vue'),
                                name: "PartnerTerminateDayMediaDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayMediaDetailMain",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerTerminateDayMediaDetailUpload.vue'),
                                name: "PartnerTerminateDayMediaDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayMediaDetailUpload",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerTerminateDayMediaDetailPayment.vue'),
                                name: "PartnerTerminateDayMediaDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayMediaDetailPayment",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerTerminateDayMediaDetailPoint.vue'),
                                name: "PartnerTerminateDayMediaDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayMediaDetailPoint",
                                    title: "해지고객관리 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerTerminateDayMediaDetailCoin.vue'),
                                name: "PartnerTerminateDayMediaDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayMediaDetailCoin",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerTerminateDayMediaDetailTrade.vue'),
                                name: "PartnerTerminateDayMediaDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayMediaDetailTrade",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_GIFTHIST"
                                },
                            },
                        ]
                    },
                    {
                        path: "advertisement/day/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerTerminateDayAdDetail.vue'),
                        name: "PartnerTerminateDayAdDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerTerminateDayAdDetail",
                            title: "해지고객관리 상세",
                            side: 'terminate',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerTerminateDayAdDetailMain.vue'),
                                name: "PartnerTerminateDayAdDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayAdDetailMain",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerTerminateDayAdDetailUpload.vue'),
                                name: "PartnerTerminateDayAdDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayAdDetailUpload",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerTerminateDayAdDetailPayment.vue'),
                                name: "PartnerTerminateDayAdDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayAdDetailPayment",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerTerminateDayAdDetailPoint.vue'),
                                name: "PartnerTerminateDayAdDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayAdDetailPoint",
                                    title: "해지고객관리 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerTerminateDayAdDetailCoin.vue'),
                                name: "PartnerTerminateDayAdDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayAdDetailCoin",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerTerminateDayAdDetailTrade.vue'),
                                name: "PartnerTerminateDayAdDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayAdDetailTrade",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_GIFTHIST"
                                },
                            },
                        ]
                    },
                    {
                        path: "shopping/day/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerTerminateDayShoppingDetail.vue'),
                        name: "PartnerTerminateDayShoppingDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerTerminateDayShoppingDetail",
                            title: "해지고객관리 상세",
                            side: 'terminate',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerTerminateDayShoppingDetailMain.vue'),
                                name: "PartnerTerminateDayShoppingDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayShoppingDetailMain",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerTerminateDayShoppingDetailUpload.vue'),
                                name: "PartnerTerminateDayShoppingDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayShoppingDetailUpload",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: 'MEMBER_TERMINATED_TERM5D_DETAIL_UPLOADCONTENTS'
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerTerminateDayShoppingDetailPayment.vue'),
                                name: "PartnerTerminateDayShoppingDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayShoppingDetailPayment",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerTerminateDayShoppingDetailPoint.vue'),
                                name: "PartnerTerminateDayShoppingDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayShoppingDetailPoint",
                                    title: "해지고객관리 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerTerminateDayShoppingDetailCoin.vue'),
                                name: "PartnerTerminateDayShoppingDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayShoppingDetailCoin",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerTerminateDayShoppingDetailTrade.vue'),
                                name: "PartnerTerminateDayShoppingDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateDayAdDetailTrade",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5D_DETAIL_GIFTHIST"
                                },
                            },
                        ]
                    },
                    {
                        path: "media/threeYear/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerTerminateThreeYearMediaDetail.vue'),
                        name: "PartnerTerminateThreeYearMediaDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerTerminateThreeYearMediaDetail",
                            title: "해지고객관리 상세",
                            side: 'terminate',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerTerminateThreeYearMediaDetailMain.vue'),
                                name: "PartnerTerminateThreeYearMediaDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearMediaDetailMain",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerTerminateThreeYearMediaDetailUpload.vue'),
                                name: "PartnerTerminateThreeYearMediaDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearMediaDetailUpload",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_UPLOADCONTENTS",
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerTerminateThreeYearMediaDetailPayment.vue'),
                                name: "PartnerTerminateThreeYearMediaDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearMediaDetailPayment",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerTerminateThreeYearMediaDetailPoint.vue'),
                                name: "PartnerTerminateThreeYearMediaDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearMediaDetailPoint",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerTerminateThreeYearMediaDetailCoin.vue'),
                                name: "PartnerTerminateThreeYearMediaDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearMediaDetailCoin",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerTerminateThreeYearMediaDetailTrade.vue'),
                                name: "PartnerTerminateThreeYearMediaDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearMediaDetailTrade",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_GIFTHIST"
                                },
                            },
                        ]
                    },
                    {
                        path: "advertisement/threeYear/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerTerminateThreeYearAdDetail.vue'),
                        name: "PartnerTerminateThreeYearAdDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerTerminateThreeYearAdDetail",
                            title: "해지고객관리 상세",
                            side: 'terminate',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerTerminateThreeYearAdDetailMain.vue'),
                                name: "PartnerTerminateThreeYearAdDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearAdDetailMain",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerTerminateThreeYearAdDetailUpload.vue'),
                                name: "PartnerTerminateThreeYearAdDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearAdDetailUpload",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_UPLOADCONTENTS",
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerTerminateThreeYearAdDetailPayment.vue'),
                                name: "PartnerTerminateThreeYearAdaDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerAdDetailPayment",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerTerminateThreeYearAdDetailPoint.vue'),
                                name: "PartnerTerminateThreeYearAdDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearAdDetailPoint",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerTerminateThreeYearAdDetailCoin.vue'),
                                name: "PartnerTerminateThreeYearAdDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearAdDetailCoin",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerTerminateThreeYearAdDetailTrade.vue'),
                                name: "PartnerTerminateThreeYearAdDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearAdDetailTrade",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_GIFTHIST"
                                },
                            },
                        ]
                    },
                    {
                        path: "shopping/threeYear/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerTerminateThreeYearShoppingDetail.vue'),
                        name: "PartnerTerminateThreeYearShoppingDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerTerminateThreeYearShoppingDetail",
                            title: "해지고객관리 상세",
                            side: 'terminate',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerTerminateThreeYearShoppingDetailMain.vue'),
                                name: "PartnerTerminateThreeYearShoppingDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearShoppingDetailMain",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerTerminateThreeYearShoppingDetailUpload.vue'),
                                name: "PartnerTerminateThreeYearShoppingDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearShoppingDetailUpload",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->쇼핑 이웃파트너->상세->결제 내역"},
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerTerminateThreeYearShoppingDetailPayment.vue'),
                                name: "PartnerTerminateThreeYearShoppingaDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerShoppingDetailPayment",
                                    title: "해지고객관리 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'partner',
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerTerminateThreeYearShoppingDetailPoint.vue'),
                                name: "PartnerTerminateThreeYearShoppingDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearShoppingDetailPoint",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerTerminateThreeYearShoppingDetailCoin.vue'),
                                name: "PartnerTerminateThreeYearShoppingDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearShoppingDetailCoin",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerTerminateThreeYearShoppingDetailTrade.vue'),
                                name: "PartnerTerminateThreeYearShoppingDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateThreeYearAdDetailTrade",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM3Y_DETAIL_GIFTHIST"
                                },
                            },
                        ]
                    },
                    {
                        path: "media/fiveYear/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerTerminateFiveYearMediaDetail.vue'),
                        name: "PartnerTerminateFiveYearMediaDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerTerminateFiveYearMediaDetail",
                            title: "해지고객관리 상세",
                            side: 'terminate',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerTerminateFiveYearMediaDetailMain.vue'),
                                name: "PartnerTerminateFiveYearMediaDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearMediaDetailMain",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerTerminateFiveYearMediaDetailUpload.vue'),
                                name: "PartnerTerminateFiveYearMediaDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearMediaDetailUpload",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerTerminateFiveYearMediaDetailPayment.vue'),
                                name: "PartnerTerminateFiveYearMediaDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearMediaDetailPayment",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerTerminateFiveYearMediaDetailPoint.vue'),
                                name: "PartnerTerminateFiveYearMediaDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearMediaDetailPoint",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerTerminateFiveYearMediaDetailCoin.vue'),
                                name: "PartnerTerminateFiveYearMediaDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearMediaDetailCoin",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerTerminateFiveYearMediaDetailTrade.vue'),
                                name: "PartnerTerminateFiveYearMediaDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearMediaDetailTrade",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_GIFTHIST"
                                },
                            },
                        ]
                    },
                    {
                        path: "advertisement/fiveYear/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerTerminateFiveYearAdDetail.vue'),
                        name: "PartnerTerminateFiveYearAdDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerTerminateFiveYearAdDetail",
                            title: "해지고객관리 상세",
                            side: 'terminate',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerTerminateFiveYearAdDetailMain.vue'),
                                name: "PartnerTerminateFiveYearAdDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearAdDetailMain",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerTerminateFiveYearAdDetailUpload.vue'),
                                name: "PartnerTerminateFiveYearAdDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearAdDetailUpload",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerTerminateFiveYearAdDetailPayment.vue'),
                                name: "PartnerTerminateFiveYearAdDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearAdDetailPayment",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerTerminateFiveYearAdDetailPoint.vue'),
                                name: "PartnerTerminateFiveYearAdDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearAdDetailPoint",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerTerminateFiveYearAdDetailCoin.vue'),
                                name: "PartnerTerminateFiveYearAdDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearAdDetailCoin",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerTerminateFiveYearAdDetailTrade.vue'),
                                name: "PartnerTerminateFiveYearAdDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearAdDetailTrade",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_GIFTHIST"
                                },
                            },
                        ]
                    },
                    {
                        path: "shopping/fiveYear/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerTerminateFiveYearShoppingDetail.vue'),
                        name: "PartnerTerminateFiveYearShoppingDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerTerminateFiveYearAdDetail",
                            title: "해지고객관리 상세",
                            side: 'terminate',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerTerminateFiveYearShoppingDetailMain.vue'),
                                name: "PartnerTerminateFiveYearShoppingDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearShoppingDetailMain",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerTerminateFiveYearShoppingDetailUpload.vue'),
                                name: "PartnerTerminateFiveYearShoppingDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearShoppingDetailUpload",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerTerminateFiveYearShoppingDetailPayment.vue'),
                                name: "PartnerTerminateFiveYearShoppingDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearShoppingDetailPayment",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerTerminateFiveYearShoppingDetailPoint.vue'),
                                name: "PartnerTerminateFiveYearShoppingDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearShoppingDetailPoint",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerTerminateFiveYearShoppingDetailCoin.vue'),
                                name: "PartnerTerminateFiveYearShoppingDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearShoppingDetailCoin",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerTerminateFiveYearShoppingDetailTrade.vue'),
                                name: "PartnerTerminateFiveYearShoppingDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerTerminateFiveYearShoppingDetailTrade",
                                    title: "해지고객관리 상세",
                                    side: 'terminate',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_TERMINATED_TERM5Y_DETAIL_GIFTHIST"
                                },
                            },
                        ]
                    },
                ]
            },

            //계정 정지/휴면 고객 관리 끝

            {
                path: "quit",
                component: () => import('../views/member/QuitRouteView.vue'),
                name: "MemberQuitMain",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberQuitMain",
                    title: "탈퇴고객관리",
                    side: 'quit',
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    log: {depth: 2, access: "회원관리->해지&탈퇴 회원"},
                    accessIdx: "MEMBER_WITHDRAWN"
                },
                children: [
                    {
                        path: "dispose",
                        component: () => import('../views/member/MemberQuit.vue'),
                        name: "MemberQuit",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MemberQuit",
                            title: "탈퇴고객관리",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 2, access: "회원관리->해지&탈퇴 회원->파기"},
                            accessIdx: "MEMBER_WITHDRAWN_DESTROY"
                        },
                    },
                    {
                        path: "day",
                        component: () => import('../views/member/MemberQuitDay.vue'),
                        name: "MemberQuitDay",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MemberQuitDay",
                            title: "탈퇴고객관리",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 2, access: "회원관리->해지&탈퇴 회원->탈퇴 후 5일"},
                            accessIdx: "MEMBER_WITHDRAWN_OUT5D"
                        },
                    },
                    {
                        path: "threeYear",
                        component: () => import('../views/member/MemberQuitThreeYear.vue'),
                        name: "MemberQuitThreeYear",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MemberQuitThreeYear",
                            title: "탈퇴고객관리",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 2, access: "회원관리->해지&탈퇴 회원->탈퇴 후 3년(민원)"},
                            accessIdx: "MEMBER_WITHDRAWN_OUT3Y"
                        },
                    },
                    {
                        path: "fiveYear",
                        component: () => import('../views/member/MemberQuitFiveYear.vue'),
                        name: "MemberQuitFiveYear",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MemberQuitFiveYear",
                            title: "탈퇴고객관리",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 2, access: "회원관리->해지&탈퇴 회원->탈퇴 후 5년(결제)"},
                            accessIdx: "MEMBER_WITHDRAWN_OUT5Y"
                        },
                    },
                    {
                        path: "media/day/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerQuitDayMediaDetail.vue'),
                        name: "PartnerQuitDayMediaDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerQuitDayMediaDetail",
                            title: "탈퇴회원 상세",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerQuitDayMediaDetailMain.vue'),
                                name: "PartnerQuitMediaDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitMediaDetailMain",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerQuitDayMediaDetailUpload.vue'),
                                name: "PartnerQuitDayMediaDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitMediaDetailUpload",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerQuitDayMediaDetailPayment.vue'),
                                name: "PartnerQuitDayMediaDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayMediaDetailPayment",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerQuitDayMediaDetailPoint.vue'),
                                name: "PartnerQuitMediaDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitMediaDetailPoint",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerQuitDayMediaDetailCoin.vue'),
                                name: "PartnerQuitMediaDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitMediaDetailCoin",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerQuitDayMediaDetailTrade.vue'),
                                name: "PartnerQuitDayMediaDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayMediaDetailTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_GIFTHIST"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerQuitDayMediaDetailGold.vue'),
                                name: "PartnerQuitDayMediaDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayMediaDetailGold",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_GOLDCOINHISTORY"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerQuitDayMediaDetailAgainTrade.vue'),
                                name: "PartnerQuitDayMediaDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayMediaDetailAgainTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_AGAINHISTORY"
                                },
                            },

                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerQuitDayMediaDetailGiftBoxIssue.vue'),
                                name: "PartnerQuitDayMediaDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayMediaDetailGiftBoxIssue",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_GIFTHISTORY"
                                },
                            },
                        ]
                    },
                    {
                        path: "advertisement/day/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerQuitDayAdDetail.vue'),
                        name: "PartnerQuitDayAdDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerQuitDayAdDetail",
                            title: "탈퇴회원 상세",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerQuitAdDetailMain.vue'),
                                name: "PartnerQuitAdDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitAdDetailMain",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerQuitDayAdDetailUpload.vue'),
                                name: "PartnerQuitDayAdDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitAdDetailUpload",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerQuitDayAdDetailPayment.vue'),
                                name: "PartnerQuitDayAdDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayAdDetailPayment",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerQuitDayAdDetailPoint.vue'),
                                name: "PartnerQuitDayAdDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitMediaDetailPoint",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerQuitDayAdDetailCoin.vue'),
                                name: "PartnerQuitAdDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitMediaDetailCoin",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerQuitDayAdDetailTrade.vue'),
                                name: "PartnerQuitDayAdDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayAdDetailTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_GIFTHIST"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerQuitDayAdDetailGold.vue'),
                                name: "PartnerQuitDayAdDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayAdDetailGold",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_GOLDCOINHISTORY"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerQuitDayAdDetailAgainTrade.vue'),
                                name: "PartnerQuitDayAdDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayAdDetailAgainTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_AGAINHISTORY"
                                },
                            },

                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerQuitDayAdDetailGiftBoxIssue.vue'),
                                name: "PartnerQuitDayAdDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayAdDetailGiftBoxIssue",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_GIFTHISTORY"
                                },
                            },
                        ]
                    },
                    {
                        path: "shopping/day/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerQuitDayShoppingDetail.vue'),
                        name: "PartnerQuitDayShoppingDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerQuitDayShoppingDetail",
                            title: "탈퇴회원 상세",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerQuitDayShoppingDetailMain.vue'),
                                name: "PartnerQuitDayShoppingDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayShoppingDetailMain",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerQuitDayShoppingDetailUpload.vue'),
                                name: "PartnerQuitDayShoppingDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitShoppingDetailUpload",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerQuitDayShoppingDetailPayment.vue'),
                                name: "PartnerQuitDayShoppingDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayShoppingDetailPayment",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_PAYHIST"

                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerQuitDayShoppingDetailPoint.vue'),
                                name: "PartnerQuitDayShoppingDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitMediaDetailPoint",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerQuitDayShoppingDetailCoin.vue'),
                                name: "PartnerQuitShoppingDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitMediaDetailCoin",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerQuitDayShoppingDetailTrade.vue'),
                                name: "PartnerQuitDayShoppingDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayShoppingDetailTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_GIFTHIST"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerQuitDayShoppingDetailGold.vue'),
                                name: "PartnerQuitDayShoppingDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayShoppingDetailGold",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_GOLDCOINHISTORY"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerQuitDayShoppingDetailAgainTrade.vue'),
                                name: "PartnerQuitDayShoppingDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayShoppingDetailAgainTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_AGAINHISTORY"
                                },
                            },

                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerQuitDayShoppingDetailGiftBoxIssue.vue'),
                                name: "PartnerQuitDayShoppingDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitDayShoppingDetailGiftBoxIssue",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5D_DETAIL_GIFTHISTORY"
                                },
                            },
                        ]
                    },


                    {
                        path: "media/threeYear/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerQuitThreeYearMediaDetail.vue'),
                        name: "PartnerQuitThreeYearMediaDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerQuitThreeYearMediaDetail",
                            title: "탈퇴회원 상세",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerQuitThreeYearMediaDetailMain.vue'),
                                name: "PartnerQuitThreeYearMediaDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailMain",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerQuitThreeYearMediaDetailUpload.vue'),
                                name: "PartnerQuitThreeYearMediaDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailUpload",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_UPLOADCONTENTS",
                                },
                            },

                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerQuitThreeYearMediaDetailPayment.vue'),
                                name: "PartnerQuitThreeYearMediaDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailPayment",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->영상 이웃파트너->상세->결제 내역"},
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerQuitThreeYearMediaDetailPoint.vue'),
                                name: "PartnerQuitThreeYearMediaDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailPoint",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerQuitThreeYearMediaDetailCoin.vue'),
                                name: "PartnerQuitThreeYearMediaDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailCoin",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerQuitThreeYearMediaDetailTrade.vue'),
                                name: "PartnerQuitThreeYearMediaDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_GIFTHIST"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerQuitThreeYearMediaDetailGold.vue'),
                                name: "PartnerQuitThreeYearMediaDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailGold",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_GOLDCOINHISTORY"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerQuitThreeYearMediaDetailAgainTrade.vue'),
                                name: "PartnerQuitThreeYearMediaDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailAgainTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_AGAINHISTORY"
                                },
                            },

                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerQuitThreeYearMediaDetailGiftBoxIssue.vue'),
                                name: "PartnerQuitThreeYearMediaDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailGiftBoxIssue",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_GIFTHISTORY"
                                },
                            },
                        ]
                    },
                    {
                        path: "advertisement/threeYear/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerQuitThreeYearAdDetail.vue'),
                        name: "PartnerQuitThreeYearAdDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerQuitThreeYearMediaDetail",
                            title: "탈퇴회원 상세",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerQuitThreeYearAdDetailMain.vue'),
                                name: "PartnerQuitThreeYearAdDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailMain",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerQuitThreeYearAdDetailUpload.vue'),
                                name: "PartnerQuitThreeYearAdDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearAdDetailUpload",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_UPLOADCONTENTS",
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerQuitThreeYearAdDetailPayment.vue'),
                                name: "PartnerQuitThreeYearAdDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearAdDetailPayment",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_PAYHIST"
                                },
                            },

                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerQuitThreeYearAdDetailPoint.vue'),
                                name: "PartnerQuitThreeYearAdDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailPoint",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerQuitThreeYearAdDetailCoin.vue'),
                                name: "PartnerQuitThreeYearAdDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailCoin",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerQuitThreeYearAdDetailTrade.vue'),
                                name: "PartnerQuitThreeYearAdDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearAdDetailTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_GIFTHIST"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerQuitThreeYearAdDetailGold.vue'),
                                name: "PartnerQuitThreeYearAdDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearAdDetailGold",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_GOLDCOINHISTORY"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerQuitThreeYearAdDetailAgainTrade.vue'),
                                name: "PartnerQuitThreeYearAdDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearAdDetailAgainTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_AGAINHISTORY"
                                },
                            },

                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerQuitThreeYearAdDetailGiftBoxIssue.vue'),
                                name: "PartnerQuitThreeYearAdDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearAdDetailGiftBoxIssue",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_GIFTHISTORY"
                                },
                            },
                        ]
                    },
                    {
                        path: "shopping/threeYear/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerQuitThreeYearShoppingDetail.vue'),
                        name: "PartnerQuitThreeYearShoppingDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerQuitThreeYearMediaDetail",
                            title: "탈퇴고객관리 상세",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerQuitThreeYearShoppingDetailMain.vue'),
                                name: "PartnerQuitThreeYearShoppingDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailMain",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerQuitThreeYearShoppingDetailUpload.vue'),
                                name: "PartnerQuitThreeYearShoppingDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearShoppingDetailUpload",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_UPLOADCONTENTS",
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerQuitThreeYearShoppingDetailPayment.vue'),
                                name: "PartnerQuitThreeYearShoppingDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearShoppingDetailPayment",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->결제 내역"},
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_PAYHIST"
                                },
                            },

                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerQuitThreeYearShoppingDetailPoint.vue'),
                                name: "PartnerQuitThreeYearShoppingDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailPoint",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerQuitThreeYearShoppingDetailCoin.vue'),
                                name: "PartnerQuitThreeYearShoppingDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearMediaDetailCoin",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerQuitThreeYearShoppingDetailTrade.vue'),
                                name: "PartnerQuitThreeYearShoppingDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearShoppingDetailTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_GIFTHIST"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerQuitThreeYearShoppingDetailGold.vue'),
                                name: "PartnerQuitThreeYearShoppingDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearShoppingDetailGold",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_GOLDCOINHISTORY"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerQuitThreeYearShoppingDetailAgainTrade.vue'),
                                name: "PartnerQuitThreeYearShoppingDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearShoppingDetailAgainTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_AGAINHISTORY"
                                },
                            },

                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerQuitThreeYearShoppingDetailGiftBoxIssue.vue'),
                                name: "PartnerQuitThreeYearShoppingDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitThreeYearShoppingDetailGiftBoxIssue",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT3Y_DETAIL_GIFTHISTORY"
                                },
                            },
                        ]
                    },
                    {
                        path: "media/fiveYear/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerQuitFiveYearMediaDetail.vue'),
                        name: "PartnerQuitFiveYearMediaDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerQuitFiveYearMediaDetail",
                            title: "탈퇴회원 상세",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerQuitFiveYearMediaDetailMain.vue'),
                                name: "PartnerQuitFiveYearMediaDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearMediaDetailMain",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerQuitFiveYearMediaDetailUpload.vue'),
                                name: "PartnerQuitFiveYearMediaDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearMediaDetailUpload",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerQuitFiveYearMediaDetailPayment.vue'),
                                name: "PartnerQuitFiveYearMediaDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearMediaDetailPayment",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    authRequired: true,
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    sideMenu: false,
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->결제 내역"},
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerQuitFiveYearMediaDetailPoint.vue'),
                                name: "PartnerQuitFiveYearMediaDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearMediaDetailPoint",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerQuitFiveYearMediaDetailCoin.vue'),
                                name: "PartnerQuitFiveYearMediaDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearMediaDetailCoin",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerQuitFiveYearMediaDetailTrade.vue'),
                                name: "PartnerQuitFiveYearMediaDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearMediaDetailTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_GIFTHIST"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerQuitFiveYearMediaDetailGold.vue'),
                                name: "PartnerQuitFiveYearMediaDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearMediaDetailGold",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_GOLDCOINHISTORY"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerQuitFiveYearMediaDetailAgainTrade.vue'),
                                name: "PartnerQuitFiveYearMediaDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearMediaDetailAgainTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_AGAINHISTORY"
                                },
                            },

                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerQuitFiveYearMediaDetailGiftBoxIssue.vue'),
                                name: "PartnerQuitFiveYearMediaDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearMediaDetailGiftBoxIssue",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_GIFTHISTORY"
                                },
                            },
                        ]
                    },
                    {
                        path: "advertisement/fiveYear/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerQuitFiveYearAdDetail.vue'),
                        name: "PartnerQuitFiveYearAdDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerQuitFiveYearAdDetail",
                            title: "탈퇴회원 상세",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerQuitFiveYearAdDetailMain.vue'),
                                name: "PartnerQuitFiveYearAdDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearAdDetailMain",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerQuitFiveYearAdDetailUpload.vue'),
                                name: "PartnerQuitFiveYearAdDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearAdDetailUpload",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerQuitFiveYearAdDetailPayment.vue'),
                                name: "PartnerQuitFiveYearAdDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearAdDetailPayment",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->결제 내역"},
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerQuitFiveYearAdDetailPoint.vue'),
                                name: "PartnerQuitFiveYearAdDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearAdDetailPoint",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerQuitFiveYearAdDetailCoin.vue'),
                                name: "PartnerQuitFiveYearAdDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearAdDetailCoin",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerQuitFiveYearAdDetailTrade.vue'),
                                name: "PartnerQuitFiveYearAdDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearAdDetailTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_GIFTHIST"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerQuitFiveYearAdDetailGold.vue'),
                                name: "PartnerQuitFiveYearAdDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearAdDetailGold",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_GOLDCOINHISTORY"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerQuitFiveYearAdDetailAgainTrade.vue'),
                                name: "PartnerQuitFiveYearAdDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearAdDetailAgainTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_AGAINHISTORY"
                                },
                            },

                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerQuitFiveYearAdDetailGiftBoxIssue.vue'),
                                name: "PartnerQuitFiveYearAdDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearAdDetailGiftBoxIssue",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_GIFTHISTORY"
                                },
                            },
                        ]
                    },
                    {
                        path: "shopping/fiveYear/detail/:idx/:mbidx",
                        component: () => import('../views/partner/PartnerQuitFiveYearShoppingDetail.vue'),
                        name: "PartnerQuitFiveYearShoppingDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PartnerQuitFiveYearShoppingDetail",
                            title: "탈퇴회원 상세",
                            side: 'quit',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/partner/PartnerQuitFiveYearShoppingDetailMain.vue'),
                                name: "PartnerQuitFiveYearShoppingDetailMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearShoppingDetailMain",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_INFO"
                                },
                            },
                            {
                                path: "upload",
                                component: () => import('../views/partner/PartnerQuitFiveYearShoppingDetailUpload.vue'),
                                name: "PartnerQuitFiveYearShoppingDetailUpload",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearShoppingDetailUpload",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_UPLOADCONTENTS"
                                },
                            },
                            {
                                path: "payment",
                                component: () => import('../views/partner/PartnerQuitFiveYearShoppingDetailPayment.vue'),
                                name: "PartnerQuitFiveYearShoppingDetailPayment",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearShoppingDetailPayment",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    log: {depth: 2, access: "회원관리->이웃파트너관리->광고 이웃파트너->상세->결제 내역"},
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_PAYHIST"
                                },
                            },
                            {
                                path: "point",
                                component: () => import('../views/partner/PartnerQuitFiveYearShoppingDetailPoint.vue'),
                                name: "PartnerQuitFiveYearShoppingDetailPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearShoppingDetailPoint",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_POINTHIST"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/partner/PartnerQuitFiveYearShoppingDetailCoin.vue'),
                                name: "PartnerQuitFiveYearShoppingDetailCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearShoppingDetailCoin",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_COINHIST"
                                },
                            },
                            {
                                path: "trade",
                                component: () => import('../views/partner/PartnerQuitFiveYearShoppingDetailTrade.vue'),
                                name: "PartnerQuitFiveYearShoppingDetailTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearAdDetailTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_GIFTHIST"
                                },
                            },
                            {
                                path: "gold",
                                component: () => import('../views/partner/PartnerQuitFiveYearShoppingDetailGold.vue'),
                                name: "PartnerQuitFiveYearShoppingDetailGold",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearShoppingDetailGold",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_GOLDCOINHISTORY"
                                },
                            },
                            {
                                path: "again-trade",
                                component: () => import('../views/partner/PartnerQuitFiveYearShoppingDetailAgainTrade.vue'),
                                name: "PartnerQuitFiveYearShoppingDetailAgainTrade",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearShoppingDetailAgainTrade",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_AGAINHISTORY"
                                },
                            },

                            {
                                path: "giftbox-issue",
                                component: () => import('../views/partner/PartnerQuitFiveYearShoppingDetailGiftBoxIssue.vue'),
                                name: "PartnerQuitFiveYearShoppingDetailGiftBoxIssue",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PartnerQuitFiveYearShoppingDetailGiftBoxIssue",
                                    title: "탈퇴회원 상세",
                                    side: 'quit',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "MEMBER_WITHDRAWN_OUT5Y_DETAIL_GIFTHISTORY"
                                },
                            },
                        ]
                    },
                ]
            },
            //끝

            {
                path: "quit/media/:idx/:mbidx",
                component: () => import('../views/member/MemberQuitDetail.vue'),
                name: "MemberQuitDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberQuitDetail",
                    title: "탈퇴회원 상세",
                    authRequired: true,
                    side: 'quit',
                    storeConfig: {userInfo: true},
                    sideMenu: false,
                },
            },

            {
                path: "quit/advertisement/:idx/:mbidx",
                component: () => import('../views/member/MemberQuitAdvertisementDetail.vue'),
                name: "MemberQuitAdvertisementDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "MemberQuitAdvertisementDetail",
                    title: "탈퇴회원 상세",
                    authRequired: true,
                    side: 'quit',
                    storeConfig: {userInfo: true},
                    sideMenu: false,
                },
            },

            {
                path: "admin",
                component: () => import('../views/admin/AdminRouteView.vue'),
                name: "adminMain",
                beforeEnter: storeSet,
                meta: {
                    name: "adminMain",
                    title: "관리자회원관리",
                    side: 'super',
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    log: {depth: 2, access: "회원관리->관리자 회원관리"},
                    accessIdx: "MEMBER_ADMINMEMBER",
                },
                children: [
                    {
                        path: "super/list",
                        component: () => import('../views/admin/AdminSuperList.vue'),
                        name: "AdminSuperList",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AdminSuperList",
                            title: "관리자회원관리",
                            side: 'super',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 2, access: "회원관리->관리자 회원관리->슈퍼관리자"},
                            accessIdx: "MEMBER_ADMINMEMBER_SUPERADMIN"
                        },
                    },
                    {
                        path: "super/list/detail/:idx",
                        component: () => import('../views/admin/AdminDetail.vue'),
                        name: "AdminSuperDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AdminSuperDetail",
                            title: "관리자 상세",
                            side: 'super',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 2, access: "회원관리->관리자 회원관리->슈퍼관리자->상세"},
                            accessIdx: "MEMBER_ADMINMEMBER_SUPERADMIN_DETAIL"
                        },
                    },

                    {
                        path: "normal/list",
                        component: () => import('../views/admin/AdminNormalList.vue'),
                        name: "AdminNormalList",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AdminNormalList",
                            title: "관리자회원관리",
                            side: 'super',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 2, access: "회원관리->관리자 회원관리->일반관리자"},
                            accessIdx: "MEMBER_ADMINMEMBER_NORMALADMIN"
                        },
                    },
                    {
                        path: "normal/list/create",
                        component: () => import('../views/admin/AdminCreate.vue'),
                        name: "AdminCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AdminCreate",
                            title: "관리자 등록",
                            authRequired: true,
                            storeConfig: {userInfo: true,checkAccess: true},
                            sideMenu: false,
                            side: 'super',
                            log: {depth: 2, access: "회원관리->관리자 회원관리->일반관리자->등록"},
                            accessIdx: 'MEMBER_ADMINMEMBER_NORMALADMIN_DETAIL_EDIT'
                        },
                    },
                    {
                        path: "normal/list/detail/:idx",
                        component: () => import('../views/admin/AdminNormalDetail.vue'),
                        name: "AdminNormalDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AdminNormalDetail",
                            title: "관리자 상세",
                            authRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: false,
                            side: 'super',
                            log: {depth: 2, access: "회원관리->관리자 회원관리->일반관리자->상세"},
                            accessIdx: "MEMBER_ADMINMEMBER_NORMALADMIN_DETAIL"
                        },
                    },
                    {
                        path: "longterm/list",
                        component: () => import('../views/admin/AdminLongtermList.vue'),
                        name: "AdminLongtermList",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AdminLongtermList",
                            title: "관리자회원관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'super',
                            log: {depth: 2, access: "회원관리->관리자 회원관리->장기 미접속 관리자"},
                            accessIdx: "MEMBER_ADMINMEMBER_LONGINACTIVE",
                        },
                    },
                    {
                        path: "longterm/list/detail/:idx",
                        component: () => import('../views/admin/AdminLongtermDetail.vue'),
                        name: "AdminLongtermDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AdminLongtermDetail",
                            title: "관리자 상세",
                            authRequired: true,
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                            side: 'super',
                            log: {depth: 2, access: "회원관리->관리자 회원관리->장기 미접속 관리자->상세"}
                        },
                    },
                    {
                        path: "quit/list",
                        component: () => import('../views/admin/AdminQuitList.vue'),
                        name: "AdminQuitList",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AdminQuitList",
                            title: "관리자회원관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'super',
                            log: {depth: 2, access: "회원관리->관리자 회원관리->탈퇴 관리자"},
                            accessIdx: "MEMBER_ADMINMEMBER_WITHDRAWNADMIN"
                        },
                    },
                    {
                        path: "quit/list/detail/:idx",
                        component: () => import('../views/admin/AdminQuitDetail.vue'),
                        name: "AdminQuitDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AdminQuitDetail",
                            title: "관리자 상세",
                            side: 'super',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "MEMBER_ADMINMEMBER_WITHDRAWNADMIN_DETAIL"
                        },
                    },
                    {
                        path: "adminAuth",
                        component: () => import('../views/admin/AdminAuth.vue'),
                        name: "AdminAuth",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AdminAuth",
                            title: "관리자회원관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            forbidden: true,
                            side: 'super',
                            log: {depth: 2, access: "회원관리->관리자 회원관리->권한 포멧 설정"},
                            accessIdx: "MEMBER_ADMINMEMBER_AUTHFORMAT"
                        },
                    },
                    {
                        path: "adminAuth/create",
                        component: () => import('../views/admin/AdminAuthCreate.vue'),
                        name: "AdminAuthCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AdminAuthCreate",
                            title: "권한 포멧 등록",
                            authRequired: true,
                            side: 'super',
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                        },
                    },
                    {
                        path: "adminAuth/list/detail/:idx",
                        component: () => import('../views/admin/AdminAuthDetail.vue'),
                        name: "AdminAuthDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AdminAuthDetail",
                            title: "권한 포멧 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'super',
                            log: {depth: 3, access: "회원관리->관리자 회원관리->권한 포멧 설정->상세"},
                            accessIdx: "MEMBER_ADMINMEMBER_AUTHFORMAT_DETAIL"
                        },
                    },

                ]

            },

        ]
    },
    {
        path: "/content",
        component: () => import('../views/RouteView.vue'),
        name: "Content",
        beforeEnter: storeSet,
        meta: {
            name: "Content",
            title: "콘텐츠관리",
            storeConfig: {userInfo: true, checkAccess: true,},
            authRequired: true,
            storeRequired: true,
            sideMenu: true,
            side: 'content',
            log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리"},
            accessIdx: "CONTENT"
        },
        children: [
            {
                path: 'home/mobile',
                component: () => import('../views/content/ContentHomeMobile.vue'),
                name: "ContentHomeMobile",
                beforeEnter: storeSet,
                meta: {
                    name: "ContentHomeMobile",
                    title: "홈화면 상단 노출 관리",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'content',
                    log: {depth: 3, access: "콘텐츠관리->홈화면 상단 노출관리->레모"},
                    accessIdx: "CONTENT_HOMETOP"
                },
            },
            {
                path: 'home/tv',
                component: () => import('../views/content/ContentHomeTv.vue'),
                name: "ContentHomeTv",
                beforeEnter: storeSet,
                meta: {
                    name: "ContentHomeTv",
                    title: "홈화면 상단 노출 관리",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'content',
                    log: {depth: 3, access: "콘텐츠관리->홈화면 상단 노출관리->레T,레tb"},
                    accessIdx: "CONTENT_HOMETOP"
                },
            },
            {
                path: 'media',
                component: () => import('../views/content/MediaRouteView.vue'),
                meta: {
                    name: "Content",
                    title: "영상 콘텐츠관리",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'content',
                    log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리"},
                    accessIdx: "CONTENT_VIDEOCONTENT"
                },
                children: [
                    {
                        path: "manage",
                        component: () => import('../views/content/Media.vue'),
                        name: "ContentMedia",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentMedia",
                            title: "영상 콘텐츠관리",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'content',
                            log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리->영상목록"},
                            accessIdx: "CONTENT_VIDEOCONTENT_VIDEOLIST"
                        }
                    },
                    {
                        path: "create",
                        component: () => import('../views/content/MediaCreate.vue'),
                        name: "ContentMediaCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentMediaCreate",
                            title: "영상 콘텐츠생성",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리->영상목록->상세"},
                            accessIdx: "CONTENT_VIDEOCONTENT_VIDEOLIST_DETAIL_EDIT"
                        },
                    },
                    {
                        path: "ready",
                        component: () => import('../views/content/MediaReady.vue'),
                        name: "ContentMediaReady",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentMediaReady",
                            title: "영상 콘텐츠관리",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리->승인대기영상"},
                            accessIdx: "CONTENT_VIDEOCONTENT_WAITVIDEO"
                        }
                    },

                    {
                        path: "ready/:idx",
                        component: () => import('../views/content/MediaReadyDetail.vue'),
                        name: "ContentMediaReadyDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentMediaReadyDetail",
                            title: "승인대기 영상 콘텐츠 상세",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리->승인대기영상->상세"},
                            accessIdx: "CONTENT_VIDEOCONTENT_WAITVIDEO_DETAIL"
                        }
                    },
                    {
                        path: "ready/meta/:idx",
                        component: () => import('../views/content/MediaReadyMeta.vue'),
                        name: "ContentMediaReadyMeta",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentMediaReadyMeta",
                            title: "승인대기 영상 메타데이터",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리->승인대기영상->상세->메타데이터"},
                            accessIdx: "CONTENT_VIDEOCONTENT_META"
                        }
                    },
                    {
                        path: "delete",
                        component: () => import('../views/content/MediaDelete.vue'),
                        name: "ContentMediaDelete",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentMediaDelete",
                            title: "영상 콘텐츠관리",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리->삭제영상"},
                            accessIdx: "CONTENT_VIDEOCONTENT_DELVIDEO"
                        }
                    },
                    {
                        path: 'comment/:idx',
                        component: () => import('../views/content/MediaComment.vue'),
                        name: "ContentMediaComment",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentMediaComment",
                            title: "영상 상세 댓글",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리->영상목록->댓글"},
                            accessIdx: "CONTENT_VIDEOCONTENT_VIDEOLIST_DETAIL_COMMENT"
                        },
                    },
                    {
                        path: 'comment/detail/:idx',
                        component: () => import('../views/content/MediaCommentDetail.vue'),
                        name: "ContentMediaCommentDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentMediaCommentDetail",
                            title: "댓글 상세",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리->영상목록->댓글->상세"},
                            accessIdx: "CONTENT_VIDEOCONTENT_VIDEOLIST_DETAIL_COMMENT_DETAIL"
                        },
                    },
                    {
                        path: 'meta/:idx',
                        component: () => import('../views/content/MediaMeta.vue'),
                        name: "ContentMediaMeta",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentMediaMeta",
                            title: "메타데이터",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리->영상목록->메타데이터"},
                            accessIdx: "CONTENT_VIDEOCONTENT_META"
                        },
                    },
                    {
                        path: ':idx',
                        component: () => import('../views/content/MediaDetail.vue'),
                        name: "ContentMediaDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentMediaDetail",
                            title: "영상 상세",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리->영상목록->상세"},
                            accessIdx: "CONTENT_VIDEOCONTENT_VIDEOLIST_DETAIL_VIEW"
                        },
                    },
                ]
            },
            {
                path: 'series',
                component: () => import('../views/content/SeriesRouteView.vue'),
                name: "ContentSeries",
                beforeEnter: storeSet,
                meta: {
                    name: "ContentSeries",
                    title: "영상 시리즈관리",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'series',
                    log: {depth: 3, access: "콘텐츠관리->영상 시리즈 관리"},
                    accessIdx: "CONTENT_VIDEOSERIES"
                },
                children: [
                    {
                        path: 'manage',
                        component: () => import('../views/content/Series.vue'),
                        name: "ContentSeries",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentSeries",
                            title: "영상 시리즈관리",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'series',
                            log: {depth: 3, access: "콘텐츠관리->영상 시리즈 관리->시리즈 목록"},
                            accessIdx: "CONTENT_VIDEOSERIES_SERIESLIST"
                        }
                    },
                    {
                        path: 'create',
                        component: () => import('../views/content/SeriesCreate.vue'),
                        name: "ContentSeriesCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentSeriesCreate",
                            title: "시리즈 등록",
                            side: 'series',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->영상 시리즈 관리->시리즈 목록->상세"},
                            accessIdx: "CONTENT_VIDEOSERIES_SERIESLIST_DETAIL_SERIESDETAIL_EDIT"
                        },
                    },
                    {
                        path: ':idx',
                        component: () => import('../views/content/SeriesDetail.vue'),
                        name: "ContentSeriesDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentSeriesDetail",
                            title: "시리즈 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'series',
                            log: {depth: 3, access: "콘텐츠관리->영상 시리즈 관리->시리즈 목록->상세->시리즈상세"},
                            accessIdx: "CONTENT_VIDEOSERIES_SERIESLIST_DETAIL_COMPOSECONTENTS"
                        },
                    },
                    {
                        path: ':idx/episode',
                        component: () => import('../views/content/SeriesDetailEpisode.vue'),
                        name: "ContentSeriesDetailEpisode",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentSeriesDetailEpisode",
                            title: "시리즈 상세",
                            authRequired: true,
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                            side: 'series',
                            log: {depth: 3, access: "콘텐츠관리->영상 시리즈 관리->시리즈 목록->구성 콘텐츠->리스트"}
                        },
                    },
                    {
                        path: 'delete',
                        component: () => import('../views/content/SeriesDelete.vue'),
                        name: "SeriesDelete",
                        beforeEnter: storeSet,
                        meta: {
                            name: "SeriesDelete",
                            title: "영상 시리즈관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'series',
                            log: {depth: 3, access: "콘텐츠관리->영상 시리즈 관리->삭제 시리즈"},
                            accessIdx: "CONTENT_VIDEOSERIES_DELSERIES"
                        },
                    },
                ]
            },
            {
                path: 'package',
                name: 'Package',
                component: () => import('../views/content/Package.vue'),
                meta: {
                    name: "Package",
                    title: "VOD 패키지관리",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'content',
                    log: {depth: 3, access: "콘텐츠관리->VOD 패키지관리"},
                    accessIdx: "CONTENT_VODPKMGMT"
                },
                children: [
                    {
                        path: "create",
                        component: () => import('../views/content/PackageCreate.vue'),
                        name: "PackageCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PackageCreate",
                            title: "VOD패키지 생성",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->VOD 패키지관리->상세"},
                            accessIdx: "CONTENT_VODPKMGMT_DETAIL_EDIT"
                        },
                    },
                    {
                        path: ":idx",
                        component: () => import('../views/content/PackageDetail.vue'),
                        name: "PackageDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PackageDetail",
                            title: "VOD 패키지 상세",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->VOD 패키지관리->상세"},
                            accessIdx: "CONTENT_VODPKMGMT_DETAIL"
                        }
                    },

                ]
            },
            {
                path: 'bundle-package',
                name: 'Bundle-Package',
                component: () => import('../views/content/BundlePackage.vue'),
                meta: {
                    name: "BundlePackage",
                    title: "묶음패키지관리",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'content',
                    log: {depth: 3, access: "콘텐츠관리->묶음패키지관리"},
                    accessIdx: "CONTENT_BUNDLEPKGMGMT"
                },
                children: [
                    {
                        path: "create",
                        component: () => import('../views/content/BundlePackageCreate.vue'),
                        name: "BundlePackageCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PackageCreate",
                            title: "묶음패키지관리 생성",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->묶음패키지관리->상세"},
                            accessIdx: "CONTENT_BUNDLEPKGMGMT_LIST_DETAIL_EDIT"
                        },
                    },
                    {
                        path: ":idx",
                        component: () => import('../views/content/BundlePackageDetail.vue'),
                        name: "BundlePackageDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "BundlePackageDetail",
                            title: "묶음패키지관리상세",
                            side: 'content',
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->묶음패키지관리->상세"},
                            accessIdx: "CONTENT_BUNDLEPKGMGMT_LIST_DETAIL"
                        }
                    },

                ]
            },
            {
                path: 'advertisement',
                component: () => import('../views/content/AdvertisementRouteView.vue'),
                name: "ContentAdvertisementMain",
                beforeEnter: storeSet,
                meta: {
                    name: "ContentAdvertisementMain",
                    title: "광고 콘텐츠관리",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'advertisement',
                    log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리"},
                    accessIdx: "CONTENT_ADCONTENT",
                },
                children: [
                    {
                        path: "manage",
                        component: () => import('../views/content/advertisement.vue'),
                        name: "ContentAdvertisement",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisement",
                            title: "광고 콘텐츠관리",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'advertisement',
                            log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리->광고 목록"},
                            accessIdx: "CONTENT_ADCONTENT_ADLIST"
                        },
                    },
                    {
                        path: "pending",
                        component: () => import('../views/content/AdvertisementPending.vue'),
                        name: "ContentAdvertisementPending",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementPending",
                            title: "광고 콘텐츠관리",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'advertisement',
                            log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리->승인대기광고"},
                            accessIdx: "CONTENT_ADCONTENT_WAITAD"
                        },
                    },
                    {
                        path: "payment",
                        component: () => import('../views/content/AdvertisementPay.vue'),
                        name: "ContentAdvertisementPay",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementPay",
                            title: "광고 콘텐츠관리",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'advertisement',
                            log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리->결제대기"},
                            accessIdx: "CONTENT_ADCONTENT_WAITPAY"
                        },
                    },
                    {
                        path: "delete",
                        component: () => import('../views/content/advertisementDelete.vue'),
                        name: "ContentAdvertisementDelete",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementDelete",
                            title: "광고 콘텐츠관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'advertisement',
                            log: {
                                depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리->삭제광고->리스트"
                            },
                            accessIdx: "CONTENT_ADCONTENT_DELAD"
                        },
                    },
                    {
                        path: "popup/create",
                        component: () => import('../views/content/advertisementPopupCreate.vue'),
                        name: "ContentAdvertisementPopupCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementPopupCreate",
                            title: "광고 콘텐츠 등록",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'advertisement',
                            log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리->광고목록->상세"},
                        },
                    },
                    {
                        path: "popup/:idx/:type",
                        component: () => import('../views/content/advertisementPopupUpdate.vue'),
                        name: "ContentAdvertisementPopupUpdate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementPopupUpdate",
                            title: "광고 콘텐츠 상세",
                            authRequired: true,
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                            side: 'advertisement',
                            log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리->광고목록->상세"}
                        },
                    },
                    {
                        path: "instream/create",
                        component: () => import('../views/content/advertisementInstreamCreate.vue'),
                        name: "ContentAdvertisementInstreamCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementInstreamCreate",
                            title: "광고 콘텐츠 등록",
                            authRequired: true,
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                            side: 'advertisement',
                            log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리->광고목록->상세"}
                        },
                    },
                    {
                        path: "instream/:idx/:type",
                        component: () => import('../views/content/advertisementInstreamUpdate.vue'),
                        name: "ContentAdvertisementInstreamUpdate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementInstreamUpdate",
                            title: "광고 콘텐츠 상세",
                            authRequired: true,
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                            side: 'advertisement',
                            log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리"}
                        },
                    },

                    {
                        path: "banner/create",
                        component: () => import('../views/content/advertisementBannerCreate.vue'),
                        name: "ContentAdvertisementBannerCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementBannerCreate",
                            title: "광고 콘텐츠 등록",
                            authRequired: true,
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                            side: 'advertisement',
                            log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리->광고목록->상세"}
                        },
                    },
                    {
                        path: "banner/:idx/:type",
                        component: () => import('../views/content/advertisementBannerUpdate.vue'),
                        name: "ContentAdvertisementBannerUpdate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementBannerUpdate",
                            title: "광고 콘텐츠 상세",
                            authRequired: true,
                            side: 'advertisement',
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                        },
                    },
                    {
                        path: "fast/create",
                        component: () => import('../views/content/advertisementFastCreate.vue'),
                        name: "ContentAdvertisementFastCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementFastCreate",
                            title: "광고 콘텐츠 등록",
                            authRequired: true,
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                            side: 'advertisement',
                            log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리->광고목록->상세"}
                        },
                    },
                    {
                        path: "fast/:idx/:type",
                        component: () => import('../views/content/advertisementFastUpdate.vue'),
                        name: "ContentAdvertisementFastUpdate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementFastUpdate",
                            title: "광고 콘텐츠 상세",
                            authRequired: true,
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                            side: 'advertisement',
                        },
                    },
                    {
                        path: ":idx/pay",
                        component: () => import('../views/content/advertisementPayment.vue'),
                        name: "ContentAdvertisementPayment",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementPayment",
                            title: "광고 콘텐츠 결제",
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: false,
                            side: 'advertisement',
                            accessIdx: "CONTENT_ADCONTENT_WAITPAY_DETAIL_PGPAY"
                        },
                    },
                    {
                        path: "instream/:idx/meta",
                        component: () => import('../views/content/advertisementInstreamMeta.vue'),
                        name: "ContentAdvertisementInstreamMeta",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementInstreamMeta",
                            title: "광고 콘텐츠 메타데이터",
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: false,
                            side: 'advertisement',
                            log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리->상세->메타데이터"},
                            accessIdx: "CONTENT_ADCONTENT_META"
                        },
                    },
                    {
                        path: "popup/:idx/meta",
                        component: () => import('../views/content/advertisementPopupMeta.vue'),
                        name: "ContentAdvertisementPopupMeta",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementPopupMeta",
                            title: "광고 콘텐츠 메타데이터",
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: false,
                            side: 'advertisement',
                            log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리->상세->메타데이터"},
                            accessIdx: "CONTENT_ADCONTENT_META"
                        },
                    },
                    {
                        path: "banner/:idx/meta",
                        component: () => import('../views/content/advertisementBannerMeta.vue'),
                        name: "ContentAdvertisementBannerMeta",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentAdvertisementBannerMeta",
                            title: "광고 콘텐츠 메타데이터",
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: false,
                            side: 'advertisement',
                            log: {depth: 3, access: "콘텐츠관리->광고 콘텐츠 관리->상세->메타데이터"},
                            accessIdx: "CONTENT_ADCONTENT_META"
                        },
                    },
                ]
            },
            {
                path: "shopping",
                component: () => import('../views/content/ShoppingRouteView.vue'),
                name: "ContentShoppingMain",
                beforeEnter: storeSet,
                meta: {
                    name: "ContentShoppingMain",
                    title: "쇼핑 콘텐츠관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'shopping',
                    log: {depth: 3, access: "콘텐츠관리->쇼핑 콘텐츠관리->쇼핑목록"},
                    accessIdx: "CONTENT_SHOPCONTENT"
                },
                children: [
                    {
                        path: "manage",
                        component: () => import('../views/content/shopping.vue'),
                        name: "ContentShopping",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentShopping",
                            title: "쇼핑 콘텐츠관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'shopping',
                            log: {depth: 3, access: "콘텐츠관리->쇼핑 콘텐츠관리->쇼핑목록"},
                            accessIdx: "CONTENT_SHOPCONTENT_SHOPLIST"
                        }
                    },
                    {
                        path: "pending",
                        component: () => import('../views/content/shoppingPending.vue'),
                        name: "ContentShoppingPending",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentShoppingPending",
                            title: "쇼핑 콘텐츠관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'shopping',
                            log: {depth: 3, access: "콘텐츠관리->쇼핑 콘텐츠관리->승인대기쇼핑"},
                            accessIdx: "CONTENT_SHOPCONTENT_WAITSHOP"
                        }
                    },
                    {
                        path: "pending/:idx",
                        component: () => import('../views/content/shoppingPendingDetail.vue'),
                        name: "ContentShoppingPendingDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentShoppingPendingDetail",
                            title: "승인대기 쇼핑 콘텐츠 상세",
                            side: 'shopping',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->쇼핑 콘텐츠관리"},
                            accessIdx: "CONTENT_SHOPCONTENT_WAITSHOP_DETAIL"
                        },
                    },
                    {
                        path: "pending/meta/:idx",
                        component: () => import('../views/content/shoppingPendingMeta.vue'),
                        name: "ContentShoppingPendingMeta",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentShoppingPendingMeta",
                            title: "승인대기 쇼핑 콘텐츠 메타데이터",
                            side: 'shopping',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->쇼핑 콘텐츠관리->승인대기쇼핑->상세->메타데이터"},
                            accessIdx: "CONTENT_SHOPCONTENT_META"
                        },
                    },
                    {
                        path: "delete",
                        component: () => import('../views/content/shoppingDelete.vue'),
                        name: "ContentShoppingDelete",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentShoppingDelete",
                            title: "쇼핑 콘텐츠관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'shopping',
                            log: {depth: 3, access: "콘텐츠관리->쇼핑 콘텐츠관리->삭제쇼핑"},
                            accessIdx: "CONTENT_SHOPCONTENT_DELSHOP"
                        }
                    },
                    {
                        path: "create",
                        component: () => import('../views/content/shoppingCreate.vue'),
                        name: "ContentShoppingCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentShoppingCreate",
                            title: "쇼핑 콘텐츠생성",
                            side: 'shopping',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "CONTENT_SHOPCONTENT_SHOPLIST_DETAIL_EDIT"
                        },
                    },

                    {
                        path: "review/:idx",
                        component: () => import('../views/content/ShoppingReview.vue'),
                        name: "ContentShoppingReview",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentShoppingReview",
                            title: "쇼핑 콘텐츠 상세",
                            side: 'shopping',
                            storeConfig: { userInfo: true, checkAccess: true },
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->쇼핑 콘텐츠관리->리뷰"},
                            accessIdx: "CONTENT_SHOPCONTENT_SHOPLIST_DETAIL_REVIEW"
                        },
                    },
                    {
                        path: "review/detail/:idx",
                        component: () => import('../views/content/ShoppingReviewDetail.vue'),
                        name: "ContentShoppingReviewDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentShoppingReviewDetail",
                            title: "리뷰 상세",
                            side: 'shopping',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->쇼핑 콘텐츠관리->리뷰->상세"},
                            accessIdx: "CONTENT_SHOPCONTENT_SHOPLIST_DETAIL_REVIEW"
                        },
                    },

                    {
                        path: ":idx",
                        component: () => import('../views/content/shoppingDetail.vue'),
                        name: "ContentShoppingDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentShoppingDetail",
                            title: "쇼핑 콘텐츠 상세",
                            side: 'shopping',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->쇼핑 콘텐츠관리"},
                            accessIdx: "CONTENT_SHOPCONTENT_SHOPLIST_DETAIL_VIEW"
                        },
                    },
                    {
                        path: "meta/:idx",
                        component: () => import('../views/content/shoppingMeta.vue'),
                        name: "ContentShoppingMeta",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentShoppingMeta",
                            title: "쇼핑 콘텐츠 메타데이터",
                            side: 'shopping',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->쇼핑 콘텐츠관리->상세->메타데이터"},
                            accessIdx: "CONTENT_SHOPCONTENT_META"
                        },
                    },

                ]
            },
            {
                path: "fast", // FAST채널 콘텐츠 관리
                component: () => import('../views/content/FastMediaRouteView.vue'),
                name: "ContentFastMediaMain",
                beforeEnter: storeSet,
                meta: {
                    name: "ContentFastMediaMain",
                    title: "기타 콘텐츠 관리",
                    sideName: "기타 콘텐츠 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'fast',
                    log: {depth: 3, access: "콘텐츠관리->기타 콘텐츠 관리->영상목록->리스트"},
                    accessIdx: "CONTENT_LIVECONTENT"

                },
                children: [
                    {
                        path: "manage", // FAST채널 콘텐츠 관리
                        component: () => import('../views/content/FastMedia.vue'),
                        name: "ContentFastMedia",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentFastMedia",
                            title: "기타 콘텐츠 관리",
                            sideName: "기타 콘텐츠 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'fast',
                            log: {depth: 3, access: "콘텐츠관리->기타 콘텐츠 관리->영상목록->리스트"},
                            accessIdx: "CONTENT_LIVECONTENT_VIDEOLIST"

                        },
                    },
                    {
                        path: "create",
                        component: () => import('../views/content/FastMediaCreate.vue'),
                        name: "ContentFastMediaCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentFastMediaCreate",
                            title: "기타 콘텐츠 등록",
                            sideHidden: true,
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true},
                            side: 'fast',
                            log: {depth: 3, access: "콘텐츠관리->기타 콘텐츠 관리->영상리스트->상세"}
                        },
                    },
                    {
                        path: ":idx", // 광고 영상 상세
                        component: () => import('../views/content/FastMediaDetail.vue'),
                        name: "FastMediaDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "FastMediaDetail",
                            title: "기타 콘텐츠 상세",
                            sideHidden: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'fast',
                            log: {depth: 3, access: "콘텐츠관리->기타 콘텐츠 관리->영상리스트->리스트->상세"},
                            accessIdx: "CONTENT_LIVECONTENT_VIDEOLIST_DETAIL"
                        },
                    },
                    {
                        path: "delete",
                        component: () => import('../views/content/FastMediaDelete.vue'),
                        name: "FastMediaDelete",
                        beforeEnter: storeSet,
                        meta: {
                            name: "FastMediaDelete",
                            title: "기타 콘텐츠 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'fast',
                            log: {depth: 3, access: "콘텐츠관리->기타 콘텐츠 관리->삭제영상->리스트"},
                            accessIdx: "CONTENT_LIVECONTENT_DELVIDEO"
                        },
                    },
                ]
            },
            {
                path: "fastad", // FAST채널 광고 세트 관리
                component: () => import('../views/RouteView.vue'),
                name: "FastAdvertisementMain",
                beforeEnter: storeSet,
                meta: {
                    name: "FastAdvertisementMain",
                    title: "콘텐츠 라이브 광고 세트 관리",
                    sideName: "콘텐츠 라이브 광고 세트 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'adFast',
                    log: {depth: 3, access: "콘텐츠관리->콘텐츠 라이브 광고세트 관리"},
                    accessIdx: "CONTENT_LIVEADSET"
                },
                children: [
                    {
                        path: "", // FAST채널 광고 세트 관리
                        component: () => import('../views/fast/FastAdvertisement.vue'),
                        name: "FastAdvertisement",
                        beforeEnter: storeSet,
                        meta: {
                            name: "FastAdvertisement",
                            title: "콘텐츠 라이브 광고 세트 관리",
                            sideName: "콘텐츠 라이브 광고 세트 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'fastAd',
                            log: {depth: 3, access: "콘텐츠관리->콘텐츠 라이브 광고세트 관리"},
                            accessIdx: "CONTENT_LIVEADSET_LIST"
                        },
                    },
                    {
                        path: "create",
                        component: () => import('../views/fast/FastAdvertisementCreate.vue'),
                        name: "FastAdvertisementCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "FastAdvertisementCreate",
                            title: "콘텐츠 라이브 광고 세트 등록",
                            authRequired: true,
                            storeRequired: true,
                            side: 'fastAd',
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: false,
                            accessIdx: 'CONTENT_LIVEADSET_DETAIL_EDIT'
                        },
                    },
                    {
                        path: ":idx",
                        component: () => import('../views/fast/FastAdvertisementDetail.vue'),
                        name: "FastAdvertisementDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "FastAdvertisementDetail",
                            title: "콘텐츠 라이브 광고 세트 상세",
                            side: 'fastAd',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "CONTENT_LIVEADSET_DETAIL"
                        },
                    },
                ]
            },
            {
                path: "move", // FAST채널 광고 세트 관리
                component: () => import('../views/RouteView.vue'),
                name: "Move",
                beforeEnter: storeSet,
                meta: {
                    name: "Move",
                    title: "콘텐츠 이동",
                    sideName: "콘텐츠 이동",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    accessIdx: "CONTENT_CONTENTMOVE_EDIT"
                },
                children: [
                    {
                        path: ":originalType/:idx/:moveType/:channel",
                        component: () => import('../views/move/MoveMedia.vue'),
                        name: "MoveMedia",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MoveMedia",
                            title: "콘텐츠 이동",
                            // side: 'fastAd',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->영상 콘텐츠관리->영상목록->상세"},
                            accessIdx: "CONTENT_CONTENTMOVE_EDIT"
                        },
                    },
                    {
                        path: ":originalType/:idx/shop",
                        component: () => import('../views/move/MoveShop.vue'),
                        name: "MoveShop",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MoveShop",
                            title: "콘텐츠 이동",
                            // side: 'fastAd',
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->쇼핑 콘텐츠관리->쇼핑목록->상세"},
                            accessIdx: "CONTENT_CONTENTMOVE_EDIT"
                        },
                    },
                    {
                        path: ":originalType/:idx/fast",
                        component: () => import('../views/move/MoveFast.vue'),
                        name: "MoveFast",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MoveFast",
                            title: "콘텐츠 이동",
                            // sideName: "콘텐츠 라이브 광고 세트 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'fastAd',
                            log: {depth: 3, access: "콘텐츠관리->기타 콘텐츠 관리->영상목록->상세"},
                            accessIdx: "CONTENT_CONTENTMOVE"
                        },
                    },
                ]
            },
            {
                path: "live",
                component: () => import('../views/RouteView.vue'),
                name: "ContentLive",
                beforeEnter: storeSet,
                meta: {
                    name: "ContentLive",
                    title: "라이브채널 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'live',
                    accessIdx: "CONTENT_LIVECHANNEL_REALLIVE"
                },
                children: [
                    {
                        path: "",
                        component: () => import('../views/live/Live.vue'),
                        name: "Live",
                        beforeEnter: storeSet,
                        meta: {
                            name: "Live",
                            title: "실시간 라이브",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'live',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->실시간 라이브->리스트"},
                            accessIdx: "CONTENT_LIVECHANNEL_REALLIVE_LIST"
                        },

                    },
                    {
                        path: "create",
                        component: () => import('../views/live/LiveCreate.vue'),
                        name: "LiveCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "LiveCreate",
                            title: "실시간 라이브 등록",
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->실시간 라이브->리스트"},
                            side: 'live',
                        },
                    },
                    {
                        path: ":idx",
                        component: () => import('../views/live/LiveDetail.vue'),
                        name: "LiveDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "LiveDetail",
                            title: "실시간 라이브 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'live',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->실시간 라이브->상세->라이브 상세"},
                            accessIdx: "CONTENT_LIVECHANNEL_REALLIVE_DETAIL"
                        },
                    },
                    {
                        path: ":idx/schedule",
                        component: () => import('../views/live/LiveDetailSchedule.vue'),
                        name: "LiveDetailSchedule",
                        beforeEnter: storeSet,
                        meta: {
                            name: "LiveDetailSchedule",
                            title: "실시간 라이브 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'live',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->실시간 라이브->상세->편성표"},
                            accessIdx: "CONTENT_LIVECHANNEL_REALLIVE_DETAIL_SCHEDULE"
                        },
                    },
                    {
                        path: "genre",
                        component: () => import('../views/live/LiveGenre.vue'),
                        name: "LiveGenre",
                        beforeEnter: storeSet,
                        meta: {
                            name: "LiveGenre",
                            title: "라이브채널 장르관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'liveGenre',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->라이브채널 장르관리"},
                            accessIdx: "CONTENT_LIVECHANNEL_LIVEGENRE"
                        },

                    },
                    {
                        path: "city",
                        component: () => import('../views/live/CityLiveRouteView.vue'),
                        name: "LiveCity",
                        beforeEnter: storeSet,
                        meta: {
                            name: "LiveCity",
                            title: "우방 라이브",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'liveCity',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->우방 라이브->리스트"},
                            accessIdx: "CONTENT_LIVECHANNEL_WBLIVE"
                        },
                        children: [
                            {
                                path: "live",
                                component: () => import('../views/live/CityLive.vue'),
                                name: "LiveCityLive",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "LiveCityLive",
                                    title: "우방 라이브",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'liveCity',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->우방 라이브->리스트"},
                                    accessIdx: "CONTENT_LIVECHANNEL_WBLIVE_LIST"
                                },
                            },
                            {
                                path: "create",
                                component: () => import('../views/live/CityLiveCreate.vue'),
                                name: "CityLiveCreate",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "CityLiveCreate",
                                    title: "우방 라이브 등록",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'liveCity',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->우방 라이브->상세"},
                                    accessIdx: "CONTENT_LIVECHANNEL_WBLIVE_DETAIL_ADSETTING_EDIT"
                                },
                            },
                            {
                                path: "category",
                                component: () => import('../views/live/CityLiveCategory.vue'),
                                name: "LiveCityCategory",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "LiveCityCategory",
                                    title: "우방 라이브",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'liveCity',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->우방 라이브->카테고리"},
                                    accessIdx: "CONTENT_LIVECHANNEL_WBLIVE_CAT"
                                },
                            },
                            {
                                path: ":idx",
                                component: () => import('../views/live/CityLiveDetail.vue'),
                                name: "CityLiveUpdate",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "CityLiveUpdate",
                                    title: "우방 라이브 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'liveCity',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->우방 라이브->상세"},
                                    accessIdx: "CONTENT_LIVECHANNEL_WBLIVE_DETAIL"
                                },
                            },
                            {
                                path: ":idx/schedule",
                                component: () => import('../views/live/CityLiveDetailSchedule.vue'),
                                name: "CityLiveSchedule",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "CityLiveSchedule",
                                    title: "우방 라이브 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'liveCity',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->우방 라이브->상세->콘텐츠 편성"},
                                    accessIdx: "CONTENT_LIVECHANNEL_WBLIVE_DETAIL"
                                },
                            },
                            {
                                path: ":idx/ad",
                                component: () => import('../views/live/CityLiveDetailAdvertisement.vue'),
                                name: "CityLiveDetailAdvertisement",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "CityLiveDetailAdvertisement",
                                    title: "우방 라이브 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'liveCity',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->우방 라이브->상세->광고 설정"},
                                    accessIdx: "CONTENT_LIVECHANNEL_WBLIVE_DETAIL"
                                },
                            },
                        ]

                    },
                    {
                        path: "content",
                        component: () => import('../views/live/ContentLive.vue'),
                        name: "ContentLive",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentLive",
                            title: "콘텐츠 라이브",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'contentLive',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->콘텐츠 라이브->리스트"},
                            accessIdx: "CONTENT_LIVECHANNEL_CONTENTLIVE"
                        },
                    },
                    {
                        path: "content/create",
                        component: () => import('../views/live/ContentLiveCreate.vue'),
                        name: "ContentLiveCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentLiveCreate",
                            title: "콘텐츠 라이브 등록",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'contentLive',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->콘텐츠 라이브->상세->라이브 정보"},
                            accessIdx: "CONTENT_LIVECHANNEL_CONTENTLIVE_DETAIL_LIVEDETAIL_EDIT"
                        },
                    },
                    {
                        path: "content/:idx",
                        component: () => import('../views/live/ContentLiveDetail.vue'),
                        name: "ContentLiveUpdate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentLiveUpdate",
                            title: "콘텐츠 라이브 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'contentLive',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->콘텐츠 라이브->상세->라이브 정보"},
                            accessIdx: "CONTENT_LIVECHANNEL_CONTENTLIVE_DETAIL_LIVEDETAIL"
                        },
                    },
                    {
                        path: "content/:idx/schedule",
                        component: () => import('../views/live/ContentLiveDetailSchedule.vue'),
                        name: "ContentLiveSchedule",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentLiveSchedule",
                            title: "콘텐츠 라이브 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'contentLive',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->콘텐츠 라이브->상세->콘텐츠 편성"},
                            accessIdx: "CONTENT_LIVECHANNEL_CONTENTLIVE_DETAIL_ARRANGECONTENTS"
                        },
                    },
                    {
                        path: "content/:idx/ad",
                        component: () => import('../views/live/ContentLiveDetailAdvertisement.vue'),
                        name: "ContentLiveDetailAdvertisement",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ContentLiveDetailAdvertisement",
                            title: "콘텐츠 라이브 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'contentLive',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->콘텐츠 라이브->상세->광고 설정"},
                            accessIdx: "CONTENT_LIVECHANNEL_CONTENTLIVE_DETAIL_ADSETTING"
                        },
                    },

                    {
                        path: "alacarte",
                        component: () => import('../views/live/AlacarteRouteView.vue'),
                        name: "AlacarteLiveMain",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AlacarteLiveMain",
                            title: "케이블TV",
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: true,
                            side: 'alacarteLive',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->케이블TV"},
                            accessIdx: "CONTENT_LIVECHANNEL_RATCABLE"
                        },
                        children: [
                            {
                                path: "channel",
                                component: () => import('../views/RouteView.vue'),
                                name: "AlacarteLiveChannelMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "AlacarteLive",
                                    title: "케이블TV",
                                    authRequired: true,
                                    storeRequired: true,
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    sideMenu: false,
                                    side: 'alacarteLive',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->케이블TV->채널 리스트"},
                                    accessIdx: "CONTENT_LIVECHANNEL_RATCABLE_LIST"
                                },
                                children: [
                                    {
                                        path: "",
                                        component: () => import('../views/live/AlacarteLive.vue'),
                                        name: "AlacarteLive",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "AlacarteLive",
                                            title: "케이블TV",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true, checkAccess: true},
                                            sideMenu: false,
                                            side: 'alacarteLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->케이블TV->채널 리스트"},
                                            accessIdx: "CONTENT_LIVECHANNEL_RATCABLE_LIST"
                                        },
                                    },
                                    {
                                        path: "create",
                                        component: () => import('../views/live/AlacarteCreate.vue'),
                                        name: "AlacarteLiveCreate",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "AlacarteLiveCreate",
                                            title: "케이블TV 채널 등록",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true, checkAccess: true},
                                            sideMenu: false,
                                            side: 'alacarteLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->케이블TV->상세"},
                                            accessIdx: "CONTENT_LIVECHANNEL_RATCABLE_DETAIL_LIVEDETAIL_VIEW"
                                        },
                                    },
                                    {
                                        path: ":idx",
                                        component: () => import('../views/live/AlacarteDetail.vue'),
                                        name: "AlacarteLiveDetail",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "AlacarteLiveDetail",
                                            title: "케이블TV 채널 상세",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true},
                                            sideMenu: false,
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->케이블TV->상세->라이브상세"},
                                            side: 'alacarteLive',
                                                                                                           // accessIdx: "CONTENT_LIVECHANNEL_RATCABLE_DETAIL_LIVEDETAIL"
                                        },
                                    },
                                    {
                                        path: ":idx/schedule",
                                        component: () => import('../views/live/AlacarteDetailSchedule.vue'),
                                        name: "AlacarteLiveDetailSchedule",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "AlacarteLiveDetailSchedule",
                                            title: "케이블TV 채널 상세",
                                            storeConfig: {userInfo: true, checkAccess: true},
                                            authRequired: true,
                                            storeRequired: true,
                                            sideMenu: false,
                                            side: 'alacarteLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->케이블TV->상세->편성표"},
                                            accessIdx: "CONTENT_LIVECHANNEL_RATCABLE_DETAIL_SCHEDULE"
                                        },
                                    },
                                ]
                            },
                            {
                                path: "group",
                                component: () => import('../views/RouteView.vue'),
                                name: "AlacarteLiveGroup",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "AlacarteLiveGroup",
                                    title: "케이블TV",
                                    authRequired: true,
                                    storeRequired: true,
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    sideMenu: false,
                                    side: 'alacarteLive',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->케이블TV->가격별 그룹관리 리스트"},
                                    accessIdx: "CONTENT_LIVECHANNEL_RATCABLE_PRICEGROUPLIST"
                                },
                                children: [
                                    {
                                        path: "",
                                        component: () => import('../views/live/AlacarteLiveGroup.vue'),
                                        name: "AlacarteLiveGroup",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "AlacarteLiveGroup",
                                            title: "케이블TV",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true, checkAccess: true},
                                            sideMenu: false,
                                            side: 'alacarteLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->케이블TV->가격별 그룹관리 리스트"},
                                            accessIdx: "CONTENT_LIVECHANNEL_RATCABLE_PRICEGROUPLIST"
                                        },
                                    },
                                    {
                                        path: "create",
                                        component: () => import('../views/live/AlacarteGroupCreate.vue'),
                                        name: "AlacarteLiveGroupCreate",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "AlacarteLiveGroupCreate",
                                            title: "그룹 등록",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true, checkAccess: true},
                                            sideMenu: false,
                                            side: 'alacarteLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->케이블TV->가격별 그룹관리 리스트->상세"},
                                            accessIdx: 846
                                        },
                                    },
                                    {
                                        path: ":idx",
                                        component: () => import('../views/live/AlacarteGroupDetail.vue'),
                                        name: "AlacarteLiveGroupUpdate",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "AlacarteLiveGroupUpdate",
                                            title: "그룹 상세",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true, checkAccess: true},
                                            sideMenu: false,
                                            side: 'alacarteLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->케이블TV->가격별 그룹관리 리스트->상세"},
                                            accessIdx: "CONTENT_LIVECHANNEL_RATCABLE_DETAIL"
                                        },
                                    },
                                ]
                            },
                        ]

                    },
                    {
                        path: "paid",
                        component: () => import('../views/live/PaidChannelRouteView.vue'),
                        name: "PaidChannelMain",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PaidChannelMain",
                            title: "유료채널",
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: true,
                            side: 'paidLive',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->유료채널"},
                            accessIdx: "CONTENT_LIVECHANNEL_PAIDCHANNEL"
                        },
                        children: [
                            {
                                path: "channel",
                                component: () => import('../views/RouteView.vue'),
                                name: "PaidChannelMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PaidChannelMain",
                                    title: "유료채널",
                                    authRequired: true,
                                    storeRequired: true,
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    sideMenu: false,
                                    side: 'paidLive',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->유료채널->채널 리스트"},
                                    accessIdx: "CONTENT_LIVECHANNEL_PAIDCHANNEL_LIST"
                                },
                                children: [
                                    {
                                        path: "",
                                        component: () => import('../views/live/PaidChannel.vue'),
                                        name: "PaidChannel",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "PaidChannel",
                                            title: "유료채널",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true, checkAccess: true},
                                            sideMenu: true,
                                            side: 'paidLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->유료채널->채널 리스트"},
                                            accessIdx: "CONTENT_LIVECHANNEL_PAIDCHANNEL_LIST"

                                        },

                                    },
                                    {
                                        path: "create",
                                        component: () => import('../views/live/PaidChannelCreate.vue'),
                                        name: "PaidChannelCreate",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "PaidChannelCreate",
                                            title: "유료 채널 등록",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true, checkAccess: true},
                                            sideMenu: false,
                                            side: 'paidLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->유료채널->상세->라이브상세"},
                                            accessIdx: "CONTENT_LIVECHANNEL_PAIDCHANNEL_DETAIL_LIVEDETAIL_VIEW"
                                        },
                                    },
                                    {
                                        path: ":idx",
                                        component: () => import('../views/live/PaidChannelDetail.vue'),
                                        name: "PaidChannelDetail",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "PaidChannelDetail",
                                            title: "유료 채널 상세",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true, checkAccess: true},
                                            sideMenu: false,
                                            side: 'paidLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->유료채널->상세->라이브상세"},

                                        },
                                    },
                                    {
                                        path: ":idx/schedule",
                                        component: () => import('../views/live/PaidChannelDetailSchedule.vue'),
                                        name: "PaidChannelDetailSchedule",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "PaidChannelDetailSchedule",
                                            title: "유료 채널 상세",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true},
                                            sideMenu: false,
                                            side: 'paidLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->유료채널->상세->편성표"}
                                        },
                                    },
                                ]
                            },
                            {
                                path: "bundle",
                                component: () => import('../views/RouteView.vue'),
                                name: "PaidChannelBundleMain",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PaidChannelBundle",
                                    title: "유료채널",
                                    authRequired: true,
                                    storeRequired: true,
                                    storeConfig: {userInfo: true},
                                    sideMenu: false,
                                    side: 'paidLive',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->유료채널->묶음채널 수수료 관리"},
                                    accessIdx: "CONTENT_LIVECHANNEL_PAIDCHANNEL_BUNDLEFEEMGMT"
                                },
                                children: [
                                    {
                                        path: "",
                                        component: () => import('../views/live/PaidChannelBundle.vue'),
                                        name: "PaidChannelBundle",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "PaidChannelBundle",
                                            title: "유료채널",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true, checkAccess: true},
                                            sideMenu: false,
                                            side: 'paidLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->유료채널->묶음채널 수수료 관리"},
                                            accessIdx: "CONTENT_LIVECHANNEL_PAIDCHANNEL_BUNDLEFEEMGMT"
                                        },
                                    },
                                    {
                                        path: "create",
                                        component: () => import('../views/live/PaidGroupCreate.vue'),
                                        name: "PaidChannelBundleCreate",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "PaidChannelBundleCreate",
                                            title: "묶음채널 수수료 등록",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true, checkAccess: true},
                                            sideMenu: false,
                                            side: 'paidLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->유료채널->묶음채널 수수료 관리->상세"},
                                            accessIdx: 'CONTENT_LIVECHANNEL_PAIDCHANNEL_BUNDLEFEEMGMT'
                                        },
                                    },
                                    {
                                        path: ":idx",
                                        component: () => import('../views/live/PaidGroupDetail.vue'),
                                        name: "PaidChannelBundleDetail",
                                        beforeEnter: storeSet,
                                        meta: {
                                            name: "PaidChannelBundleDetail",
                                            title: "묶음채널 수수료 상세",
                                            authRequired: true,
                                            storeRequired: true,
                                            storeConfig: {userInfo: true, checkAccess: true},
                                            sideMenu: false,
                                            side: 'paidLive',
                                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->유료채널->묶음채널 수수료 관리->상세"},
                                            accessIdx: "CONTENT_LIVECHANNEL_PAIDCHANNEL_BUNDLEFEEMGMT_DETAIL"
                                        },
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        path: "monitoring",
                        component: () => import('../views/monitoring/MonitoringRouteView.vue'),
                        name: "MonitoringMain",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MonitoringMain",
                            title: "라이브채널 모니터링",
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: true,
                            side: 'liveMonitoring',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->라이브채널 모니터링"},
                            accessIdx: "CONTENT_LIVECHANNEL_LIVEMONITOR"
                        },
                        children: [
                            {
                                path: "live",
                                component: () => import('../views/monitoring/MonitoringLive.vue'),
                                name: "MonitoringLive",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "MonitoringLive",
                                    title: "라이브채널 모니터링",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'liveMonitoring',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->라이브채널 모니터링->실시간 라이브"},
                                    accessIdx: "CONTENT_LIVECHANNEL_LIVEMONITOR_REALLIVE"
                                },
                            },
                            {
                                path: "fast",
                                component: () => import('../views/monitoring/MonitoringLiveFast.vue'),
                                name: "MonitoringLiveFast",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "MonitoringLiveFast",
                                    title: "라이브채널 모니터링",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'liveMonitoring',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->라이브채널 모니터링->콘텐츠 라이브"},
                                    accessIdx: "CONTENT_LIVECHANNEL_LIVEMONITOR_CONTENTLIVE"
                                },
                            },
                            {
                                path: "alacarte",
                                component: () => import('../views/monitoring/MonitoringLiveAlacarte.vue'),
                                name: "MonitoringLiveAlacarte",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "MonitoringLiveAlacarte",
                                    title: "라이브채널 모니터링",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'liveMonitoring',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->라이브채널 모니터링->케이블TV"},
                                    accessIdx: "CONTENT_LIVECHANNEL_LIVEMONITOR_RATCABLE"
                                },
                            },
                            {
                                path: "paid",
                                component: () => import('../views/monitoring/MonitoringLivePaid.vue'),
                                name: "MonitoringLivePaid",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "MonitoringLivePaid",
                                    title: "라이브채널 모니터링",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'liveMonitoring',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->라이브채널 모니터링->유료 채널"},
                                    accessIdx: "CONTENT_LIVECHANNEL_LIVEMONITOR_PAIDCHANNEL"
                                },
                            },
                            {
                                path: "city",
                                component: () => import('../views/monitoring/MonitoringLiveCity.vue'),
                                name: "MonitoringLiveCity",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "MonitoringLiveCity",
                                    title: "라이브채널 모니터링",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'liveMonitoring',
                                    log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->라이브채널 모니터링->우방라이브"},
                                    accessIdx: "CONTENT_LIVECHANNEL_LIVEMONITOR_WBLIVE"
                                },
                            },

                        ]
                    },

                    {
                        path: "tab",
                        component: () => import('../views/live/LiveChannelTab.vue'),
                        name: "LiveChannelTab",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MonitoringMain",
                            title: "라이브채널 탭 관리",
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: true,
                            side: 'liveChannelTab',
                            log: {depth: 3, access: "콘텐츠관리->라이브 채널 관리->라이브채널 탭 관리"},
                            //TODO
                            accessIdx: "CONTENT_LIVECHANNEL_LIVECHANNELTABMGMT"
                        },
                    },
                ],
            },
            {
                path: "recommend",
                component: () => import('../views/recommend/RecommendRouteView.vue'),
                name: "RecommendRouteView",
                beforeEnter: storeSet,
                meta: {
                    name: "RecommendRouteView",
                    title: "콘텐츠 추천관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    log: {depth: 3, access: "콘텐츠관리->콘텐츠 추천 관리->나의 레인보우"},
                    accessIdx: "CONTENT_RECOMMENDCONTENT"
                },
                children: [
                    {
                        path: "rainbow",
                        component: () => import('../views/recommend/RecommendRainbow.vue'),
                        name: "RecommendRainbow",
                        beforeEnter: storeSet,
                        meta: {
                            name: "RecommendRouteView",
                            title: "콘텐츠 추천관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->콘텐츠 추천 관리->나의 레인보우리스트"},
                            accessIdx: "CONTENT_RECOMMENDCONTENT_MYRAINBOW"
                        },
                    },

                    {
                        path: "vod",
                        component: () => import('../views/recommend/RecommendVod.vue'),
                        name: "RecommendVod",
                        beforeEnter: storeSet,
                        meta: {
                            name: "RecommendVod",
                            title: "콘텐츠 추천관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->콘텐츠 추천 관리->VOD 리스트"},
                            accessIdx: "CONTENT_RECOMMENDCONTENT_VODLIST"
                        },
                    },

                    {
                        path: "class",
                        component: () => import('../views/recommend/RecommendClass.vue'),
                        name: "RecommendClass",
                        beforeEnter: storeSet,
                        meta: {
                            name: "RecommendClass",
                            title: "콘텐츠 추천관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            log: {depth: 3, access: "콘텐츠관리->콘텐츠 추천 관리->우클 리스트"},
                            accessIdx: "CONTENT_RECOMMENDCONTENT_WCLIST"
                        },
                    },

                    {
                        path: "rainbow/:idx",
                        component: () => import('../views/recommend/RecommendRainbowDetail.vue'),
                        name: "RecommendRainbowDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "RecommendRainbowDetail",
                            title: "나의 레인보우 콘텐츠 추천관리 상세",
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true},
                            log: {depth: 4, access: "콘텐츠관리->콘텐츠 추천 관리->나의 레인보우리스트->상세"},
                            sideMenu: false,
                        },
                    },
                    {
                        path: "vod/:idx",
                        component: () => import('../views/recommend/RecommendVodDetail.vue'),
                        name: "RecommendVodDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "RecommendVodDetail",
                            title: "VOD 콘텐츠 추천관리 상세",
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true},
                            log: {depth: 4, access: "콘텐츠관리->콘텐츠 추천 관리->VOD 리스트->상세"},
                            sideMenu: false,
                        },
                    },
                    {
                        path: "class/:idx",
                        component: () => import('../views/recommend/RecommendClassDetail.vue'),
                        name: "RecommendClassDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "RecommendClassDetail",
                            title: "우리동네 클래스 콘텐츠 추천관리 상세",
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true},
                            log: {depth: 4, access: "콘텐츠관리->콘텐츠 추천 관리->우클 리스트->상세"},
                            sideMenu: false,
                        },
                    },
                ]

            },

            {
                path: "lg-tv",
                component: () => import('../views/content/LgTvContent.vue'),
                name: "LgTvContent",
                beforeEnter: storeSet,
                meta: {
                    name: "LgTvContent",
                    title: "LG TV 연동 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    log: {depth: 3, access: "콘텐츠관리->LG TV 연동 관리->리스트"},
                    accessIdx: "CONTENT_LGTVLINK_LIST",

                },
            },

            /*{
                path: 'homeChoiceSetting',
                component: () => import('../views/content/HomeChoiceSetting.vue'),
                name: "HomeChoiceSetting",
                beforeEnter: storeSet,
                meta: {
                    name: "HomeChoiceSetting",
                    title: "홈초이스 연동관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'contentMenu',
                    log: {depth: 3, access: "콘텐츠관리->홈초이스 연동관리"},
                    isSuperOnly: true
                },
            },*/

            {
                path: "pick/vod",
                component: () => import('../views/content/PickVod.vue'),
                name: "PickVod",
                beforeEnter: storeSet,
                meta: {
                    name: "PickVod",
                    title: "쇼핑/코인몰 추천관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    log: {depth: 3, access: "콘텐츠관리->쇼핑/코인몰 추천관리->리스트"},
                    accessIdx: "CONTENT_SHOPRECOMMEND"

                },
            },
            {
                path: "pick/class",
                component: () => import('../views/content/PickClass.vue'),
                name: "PickClass",
                beforeEnter: storeSet,
                meta: {
                    name: "PickClass",
                    title: "쇼핑/코인몰 추천관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    log: {depth: 3, access: "콘텐츠관리->쇼핑/코인몰 추천관리->리스트"},
                    accessIdx: "CONTENT_SHOPRECOMMEND"
                },
            },
            {
                path: "pick/shopping",
                component: () => import('../views/content/PickShopping.vue'),
                name: "PickShopping",
                beforeEnter: storeSet,
                meta: {
                    name: "PickShopping",
                    title: "쇼핑/코인몰 추천관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    log: {depth: 3, access: "콘텐츠관리->쇼핑/코인몰 추천관리->리스트"},
                    accessIdx: "CONTENT_SHOPRECOMMEND"
                },
            },
        ],
    },
    {
        path: "/statistics",
        component: () => import('../views/RouteView.vue'),
        name: "Statistics",
        beforeEnter: storeSet,
        meta: {
            name: "Statistics",
            title: "BF데이터 관리",
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, checkAccess: true},
            sideMenu: true,
            accessIdx: "BF"
        },
        children: [

            {
                path: "static",
                component: () => import('../views/RouteView.vue'),
                name: "StatisticsStatic",
                beforeEnter: storeSet,
                meta: {
                    name: "StatisticsStatic",
                    title: "파라미터 BF데이터 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    accessIdx: 'BF_PARAMBF',
                },
                children: [
                    {
                        path: 'partner',
                        component: () => import('../views/bf/StaticNeighborPartner.vue'),
                        name: 'StaticNeighborPartner',
                        beforeEnter: storeSet,
                        meta: {
                            name: 'StaticNeighborPartner',
                            title: '이웃파트너 BF데이터',
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: true,
                            accessIdx: 'BF_PARAMBF_PARTNERBF'
                        }
                    },
                        {
                            path: 'content',
                            component: () => import('../views/bf/StaticVideoContent.vue'),
                            name: 'StaticVideoContent',
                            beforeEnter: storeSet,
                            meta: {
                                name: 'StaticVideoContent',
                                title: '영상 콘텐츠 BF데이터',
                                authRequired: true,
                                storeRequired: true,
                                storeConfig: {userInfo: true, checkAccess: true},
                                sideMenu: true,
                                accessIdx: 'BF_PARAMBF_VIDEOBF'
                            },
                        },
                    {
                        path: 'content/shopping',
                        component: () => import('../views/bf/StaticShoppingContent.vue'),
                        name: 'StaticShoppingContent',
                        beforeEnter: storeSet,
                        meta: {
                            name: 'StaticShoppingContent',
                            title: '쇼핑 콘텐츠 BF데이터',
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: true,
                            accessIdx: 'BF_PARAMBF_SHOPBF'
                        },
                    },
                    {
                        path: 'content/ad',
                        component: () => import('../views/bf/StaticAdContent.vue'),
                        name: 'StaticAdContent',
                        beforeEnter: storeSet,
                        meta: {
                            name: 'StaticAdContent',
                            title: '광고 콘텐츠 BF데이터',
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: true,
                            accessIdx: 'BF_PARAMBF_ADBF'
                        },
                    },
                    // {
                    //     path: 'partner',
                    //     component: () => import('../views/statistics/StaticPartner/StaticPartner.vue'),
                    //     name: 'StaticPartner',
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: 'StaticPartner',
                    //         title: '이웃파트너 BF데이터',
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         sideMenu: true,
                    //         accessIdx: 'BF_PARAMBF_PARTNERBF'
                    //     },
                    // },
                    // {
                    //     path: 'content',
                    //     component: () => import('../views/statistics/StaticVideoContent/StaticVideoContent.vue'),
                    //     name: 'StaticVideoContent',
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: 'StaticVideoContent',
                    //         title: '영상 콘텐츠 BF데이터',
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         sideMenu: true,
                    //         accessIdx: 'BF_PARAMBF_VIDEOBF'
                    //     },
                    // },
                    
                    // {
                    //     path: 'content/shopping',
                    //     component: () => import('../views/statistics/StaticShoppingContent/StaticShoppingContent.vue'),
                    //     name: 'StaticShoppingContent',
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: 'StaticShoppingContent',
                    //         title: '쇼핑 콘텐츠 BF데이터',
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         sideMenu: true,
                    //         accessIdx: 'BF_PARAMBF_SHOPBF'
                    //     },
                    // },
                    // {
                    //     path: 'content/ad',
                    //     component: () => import('../views/statistics/StaticAdContent/StaticAdContent.vue'),
                    //     name: 'StaticAdContent',
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: 'StaticAdContent',
                    //         title: '광고 콘텐츠 BF데이터',
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         sideMenu: true,
                    //         accessIdx: 'BF_PARAMBF_ADBF'
                    //     },
                    // },
                ]
            },
            // {
            //     path: "video",
            //     component: () => import('../views/statistics/VideoContent/VideoContent.vue'),
            //     name: "VideoContent",
            //     beforeEnter: storeSet,
            //     meta: {
            //         name: "VideoContent",
            //         title: "영상 콘텐츠 BF데이터",
            //         authRequired: true,
            //         storeRequired: true,
            //         side: 'statisticsVideo',
            //         storeConfig: {userInfo: true, checkAccess: true},
            //         sideMenu: true,
            //         accessIdx: "BF_VIDEOBF"
            //     },
            // },
            // {
            //     path: "shopping",
            //     component: () => import('../views/statistics/ShoppingContent/ShoppingContent.vue'),
            //     name: "ShoppingContent",
            //     beforeEnter: storeSet,
            //     meta: {
            //         name: "ShoppingContent",
            //         title: "쇼핑 콘텐츠 BF데이터",
            //         side: 'statisticsShopping',
            //         authRequired: true,
            //         storeRequired: true,
            //         storeConfig: {userInfo: true, checkAccess: true},
            //         sideMenu: true,
            //         accessIdx: "BF_SHOPBF"
            //     },
            // },
            // {
            //     path: "advertise",
            //     component: () => import('../views/statistics/AdContent/AdContent.vue'),
            //     name: "AdvertiseContent",
            //     beforeEnter: storeSet,
            //     meta: {
            //         name: "AdvertiseContent",
            //         title: "광고 콘텐츠 BF데이터",
            //         authRequired: true,
            //         storeRequired: true,
            //         side: 'statisticsAdvertisement',
            //         storeConfig: {userInfo: true, checkAccess: true},
            //         sideMenu: true,
            //         accessIdx: "BF_ADBF"
            //     },
            // },
            // {
            //     path: "live",
            //     component: () => import('../views/statistics/LiveChannel/LiveChannel.vue'),
            //     name: "LiveChannel",
            //     beforeEnter: storeSet,
            //     meta: {
            //         name: "LiveChannel",
            //         title: "라이브채널 BF데이터",
            //         authRequired: true,
            //         side: 'statisticsLive',
            //         storeConfig: {userInfo: true, checkAccess: true},
            //         sideMenu: true,
            //         accessIdx: "BF_LIVEBF"
            //     },
            // },
            //  {
            //     path: 'game',
            //     component: () => import('../views/statistics/Game/Game.vue'),
            //     name: 'GameBf',
            //     beforeEnter: storeSet,
            //     meta: {
            //         name: 'GameBf',
            //         title: '게임 BF데이터 ',
            //         authRequired: true,
            //         storeRequired: true,
            //         side: 'statisticsGame',
            //         storeConfig: { userInfo: true, checkAccess: true },
            //         sideMenu: true,
            //         accessIdx: "BF_GAMEBF"
            //     },
            // },
            // {
            //     path: 'neighbor/partner',
            //     component: () => import('../views/statistics/Partner/NeighborPartner.vue'),
            //     name: 'NeighborPartner',
            //     beforeEnter: storeSet,
            //     meta: {
            //         name: 'NeighborPartner',
            //         title: '이웃파트너 BF데이터',
            //         authRequired: true,
            //         storeRequired: true,
            //         side: 'statisticsParnter',
            //         storeConfig: {userInfo: true, checkAccess: true},
            //         sideMenu: true,
            //         accessIdx: "BF_PARTNERBF"
            //     },
            // },
            // {
            //     path: 'Comment',
            //     component: () => import('../views/statistics/Comment/Comment.vue'),
            //     name: 'Comment',
            //     beforeEnter: storeSet,
            //     meta: {
            //         name: 'Comment',
            //         title: '댓글/리뷰 BF데이터',
            //         authRequired: true,
            //         storeRequired: true,
            //         storeConfig: {userInfo: true, checkAccess: true},
            //         sideMenu: true,
            //         accessIdx: 'BF_COMMENTBF'
            //     },
            // },
            
            {
                path: "video",
                component: () => import('../views/bf/VideoContent.vue'),
                name: "VideoContent",
                beforeEnter: storeSet,
                meta: {
                    name: "VideoContent",
                    title: "영상 콘텐츠 BF데이터",
                    authRequired: true,
                    storeRequired: true,
                    side: 'statisticsVideo',
                    storeConfig: { userInfo: true, checkAccess: true },
                    sideMenu: true,
                    accessIdx: "BF_VIDEOBF"
                },
            },

            {
                path: "shopping",
                component: () => import('../views/bf/ShoppingContent.vue'),
                name: "ShoppingContent",
                beforeEnter: storeSet,
                meta: {
                    name: "ShoppingContent",
                    title: "쇼핑 콘텐츠 BF데이터",
                    authRequired: true,
                    storeRequired: true,
                    side: 'statisticsShopping',
                    storeConfig: {userInfo: true, checkAccess: true},
                    sideMenu: true,
                    accessIdx: "BF_SHOPBF"
                },
            },

            {
                path: "advertise",
                component: () => import('../views/bf/AdvertiseContent.vue'),
                name: "AdvertiseContent",
                beforeEnter: storeSet,
                meta: {
                    name: "AdvertiseContent",
                    title: "광고 콘텐츠 BF데이터",
                    authRequired: true,
                    storeRequired: true,
                    side: 'statisticsAdvertisement',
                    storeConfig: {userInfo: true, checkAccess: true},
                    sideMenu: true,
                    accessIdx: "BF_ADBF"
                },
            },

            {
                path: "live",
                component: () => import('../views/bf/LiveChannel.vue'),
                name: "LiveChannel",
                beforeEnter: storeSet,
                meta: {
                    name: "LiveChannel",
                    title: "라이브채널 BF데이터 ",
                    authRequired: true,
                    storeRequired: true,
                    side: 'statisticsLive',
                    storeConfig: {userInfo: true, checkAccess: true},
                    sideMenu: true,
                    accessIdx: "BF_LIVEBF"
                },
            },

            {
                path: 'game',
                component: () => import('../views/bf/GameBf.vue'),
                name: 'GameBf',
                beforeEnter: storeSet,
                meta: {
                    name: 'GameBf',
                    title: '게임 BF데이터 ',
                    authRequired: true,
                    storeRequired: true,
                    side: 'statisticsGame',
                    storeConfig: { userInfo: true, checkAccess: true },
                    sideMenu: true,
                    accessIdx: "BF_GAMEBF"
                },
            },
            
            {
                path: 'neighbor/partner',
                component: () => import('../views/bf/NeighborPartner.vue'),
                name: 'NeighborPartner',
                beforeEnter: storeSet,
                meta: {
                    name: 'NeighborPartner',
                    title: '이웃파트너 BF데이터 ',
                    authRequired: true,
                    storeRequired: true,
                    side: 'statisticsParnter',
                    storeConfig: { userInfo: true, checkAccess: true },
                    sideMenu: true,
                    accessIdx: "BF_PARTNERBF"
                },
            },

            {
                path: 'comment',
                component: () => import('../views/bf/Comment.vue'),
                name: 'comment',
                beforeEnter: storeSet,
                meta: {
                    name: 'comment',
                    title: '댓글/리뷰 BF데이터 ',
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: { userInfo: true, checkAccess: true },
                    sideMenu: true,
                    accessIdx: 'BF_COMMENTBF'
                },
            },
        ]
    },
    {
        path: "/operate",
        component: () => import('../views/RouteView.vue'),
        name: "Operate",
        beforeEnter: storeSet,
        meta: {
            name: "Operate",
            title: "운영관리",
            storeConfig: {userInfo: true, checkAccess: true},
            authRequired: true,
            storeRequired: true,
            sideMenu: true,
            accessIdx: "OPERATE"
        },
        children: [
            {
                path: "item",
                component: () => import('../views/item/ItemRouteView.vue'),
                name: "ItemMain",
                beforeEnter: storeSet,
                meta: {
                    name: "ItemMain",
                    title: "상품관리",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateAd',
                    log: {
                        depth: 4, access: "운영관리->상품관리"
                    },
                    accessIdx: "OPERATE_PRODUCT",
                },
                children: [
                    {
                        path: "advertisement",
                        component: () => import('../views/item/ItemAdvertisement.vue'),
                        name: "ItemAdvertisement",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ItemAdvertisement",
                            title: "상품관리",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateAd',
                            accessIdx: "OPERATE_PRODUCT_ADPRODUCT",
                            log: {
                                depth: 4, access: "운영관리->상품관리->광고"
                            }
                        },
                    },
                    {
                        path: "advertisement/:idx",
                        component: () => import('../views/item/ItemAdvertisementDetail.vue'),
                        name: "ItemAdvertisementDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ItemAdvertisementDetail",
                            title: "광고 상품 상세",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateAd',
                            accessIdx: "OPERATE_PRODUCT_ADPRODUCT_DETAIL",
                            log: {depth: 4, access: "운영관리->상품관리->광고->상세"}
                        },
                    },
                    {
                        path: "paid",
                        component: () => import('../views/item/ItemPaid.vue'),
                        name: "ItemPaid",
                        beforeEnter: storeSet,
                        meta: {
                            side: 'operateAd',
                            name: "ItemPaid", title: "상품관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "OPERATE_PRODUCT_PAIDCHANNEL",
                            log: {depth: 4, access: "운영관리->상품관리->유료채널"},

                        },
                    },
                    {
                        path: "paid/create",
                        component: () => import('../views/item/ItemPaidCreate.vue'),
                        name: "ItemPaidCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ItemPaidCreate",
                            title: "유료채널 상품 등록",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateAd',
                            accessIdx: "OPERATE_PRODUCT_PAIDCHANNEL_DETAIL",
                            log: {depth: 4, access: "운영관리->상품관리->유료채널->등록"}
                        },
                    },
                    {
                        path: "paid/:idx",
                        component: () => import('../views/item/ItemPaidDetail.vue'),
                        name: "ItemPaidDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ItemPaidDetail",
                            title: "유료채널 상품 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateAd',
                            accessIdx: "OPERATE_PRODUCT_PAIDCHANNEL_DETAIL",
                            log: {depth: 4, access: "운영관리->상품관리->유료채널->상세"}
                        },
                    },
                    {
                        path: "alacarte",
                        component: () => import('../views/item/ItemAlacarte.vue'),
                        name: "ItemAlacarte",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ItemAlacarte",
                            title: "상품관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateAd',
                            accessIdx: "OPERATE_PRODUCT_RATCABLE",
                            log: {depth: 4, access: "운영관리->상품관리->케이블TV->채널 리스트"}
                        },
                    },
                    {
                        path: "alacarte/create",
                        component: () => import('../views/item/ItemAlacarteCreate.vue'),
                        name: "ItemAlacarteCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ItemAlacarteCreate",
                            title: "케이블TV 상품 등록",
                            side: 'operateAd',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "OPERATE_PRODUCT_RATCABLE_DETAIL",
                            log: {depth: 4, access: "운영관리->상품관리->케이블TV->상세->라이브 상세"}
                        },
                    },
                    {
                        path: "alacarte/:idx",
                        component: () => import('../views/item/ItemAlacarteDetail.vue'),
                        name: "ItemAlacarteDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ItemAlacarteDetail",
                            title: "케이블TV 상품 상세",
                            side: 'operateAd',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "OPERATE_PRODUCT_RATCABLE_DETAIL",
                            log: {depth: 4, access: "운영관리->상품관리->케이블TV->상세->라이브 상세"}
                        },
                    },

                    // 1398
                    //
                    // 조회
                    //
                    // 등록
                    //
                    // 수정 1401
                    //
                    // 상세
                    //
                    // 수정 1403
                    {
                        path: "vod",
                        component: () => import('../views/item/ItemVod.vue'),
                        name: "ItemVod",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ItemVod",
                            title: "상품관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateAd',

                            accessIdx: "OPERATE_PRODUCT_VOD",
                            log: {depth: 4, access: "운영관리->상품관리->VOD->조회"}
                        },
                    },

                    {
                        path: "vod/create",
                        component: () => import('../views/item/ItemVodCreate.vue'),
                        name: "ItemVodCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ItemVodCreate",
                            title: "VOD 상품 등록",
                            side: 'operateAd',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "OPERATE_PRODUCT_VOD_REG",
                            log: {depth: 4, access: "운영관리->상품관리->VOD->등록"}
                        },
                    },
                    {
                        path: "vod/:idx",
                        component: () => import('../views/item/ItemVodDetail.vue'),
                        name: "ItemVodDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ItemVodDetail",
                            title: "VOD 상품 상세",
                            side: 'operateAd',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "OPERATE_PRODUCT_VOD_DETAIL",
                            log: {depth: 4, access: "운영관리->상품관리->vod->상세->조회"}
                        },
                    },
                ]
            },

            {
                path: 'content-provider',
                component: () => import('../views/contentProvider/ContentProvider.vue'),
                name: 'OperateContentProvider',
                beforeEnter: storeSet,
                meta: {
                    name: 'OperateContentProvider',
                    title: "콘텐츠 제공자 관리",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateCP',
                    log: {
                        depth: 4, access: "운영관리->콘텐츠 제공자"
                    },
                    accessIdx: "OPERATE_CONTENTPROVIDER",

                },
            },
            {
                path: 'content-provider/create',
                component: () => import('../views/contentProvider/ContentProviderCreate.vue'),
                name: 'OperateContentProviderCreate',
                beforeEnter: storeSet,
                meta: {
                    name: 'OperateContentProviderCreate',
                    title: "콘텐츠 제공자 관리 등록",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'operateCP',
                    log: {
                        depth: 4, access: "운영관리->콘텐츠 제공자->등록"
                    },
                    accessIdx: "OPERATE_CONTENTPROVIDER_DETAIL_EDIT",
                },
            },
            {
                path: 'content-provider/:idx',
                component: () => import('../views/contentProvider/ContentProviderDetail.vue'),
                name: 'ContentProviderDetail',
                beforeEnter: storeSet,
                meta: {
                    name: 'ContentProviderDetail',
                    title: "콘텐츠 제공자 관리 상세",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'operateCP',
                    log: {
                        depth: 4, access: "운영관리->콘텐츠 제공자->상세"
                    },
                    accessIdx: "OPERATE_CONTENTPROVIDER_DETAIL",
                },
            },
            {
                path: 'profile',
                component: () => import('../views/profile/ProfileList.vue'),
                name: 'ProfileList',
                beforeEnter: storeSet,
                meta: {
                    name: 'ProfileList',
                    title: "이웃 회원 프로필 관리",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateCP',
                    log: {
                        depth: 4, access: "운영관리->이웃 회원 프로필"
                    },
                    accessIdx: "OPERATE_CUSTOMERPROFILEMGMT_LIST",

                },
            },
            {
                path: 'profile/create',
                component: () => import('../views/profile/ProfileCreate.vue'),
                name: 'ProfileCreate',
                beforeEnter: storeSet,
                meta: {
                    name: 'ProfileCreate',
                    title: "이웃 회원 프로필 등록",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'operateCP',
                    log: {
                        depth: 4, access: "운영관리->이웃 회원 프로필->등록"
                    },
                    accessIdx: "OPERATE_CUSTOMERPROFILEMGMT_LIST_DETAIL_EDIT",
                },
            },
            {
                path: 'profile/:idx',
                component: () => import('../views/profile/ProfileDetail.vue'),
                name: 'ProfileDetail',
                beforeEnter: storeSet,
                meta: {
                    name: 'ProfileDetail',
                    title: "이웃 회원 프로필 상세",
                    storeConfig: {userInfo: true, checkAccess: true,},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'operateCP',
                    log: {
                        depth: 4, access: "운영관리->이웃 회원 프로필->상세"
                    },
                    accessIdx: "OPERATE_CUSTOMERPROFILEMGMT_LIST_DETAIL",
                },
            },
            {
                path: "subscript",
                component: () => import('../views/subscript/SubscriptRouteView.vue'),
                name: "SubscriptMain",
                beforeEnter: storeSet,
                meta: {
                    name: "SubscriptMain",
                    title: "상품 구성 변경 구독갱신관리",
                    side: 'subscript',
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    log: {
                        depth: 4, access: "운영관리->상품 구성 변경 구독갱신관리"
                    },
                    sideMenu: true,
                    accessIdx: "OPERATE_SUBSCRIPTION",
                },
                children: [
                    {
                        path: "manage",
                        component: () => import('../views/subscript/Subscript.vue'),
                        name: "SubscriptList",
                        beforeEnter: storeSet,
                        meta: {
                            name: "SubscriptList",
                            title: "상품 구성 변경 구독갱신관리",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'subscript',
                            log: {depth: 4, access: "운영관리->상품 구성 변경 구독갱신관리"},
                            accessIdx: "OPERATE_SUBSCRIPTION"
                        },
                    },
                    {
                        path: "create",
                        component: () => import('../views/subscript/SubscriptCreate.vue'),
                        name: "SubscriptCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "SubscriptCreate",
                            title: "상품 구성 변경 구독갱신관리 등록",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'subscript',
                            log: {depth: 3, access: "운영관리->상품 구성 변경 구독갱신관리 등록"},
                            accessIdx: "OPERATE_SUBSCRIPTION_DETAIL_EDIT"
                        },
                    },

                    {
                        path: "confirm/:idx",
                        component: () => import('../views/subscript/SubscriptConfirm.vue'),
                        name: "SubscriptConfirm",
                        beforeEnter: storeSet,
                        meta: {
                            name: "SubscriptConfirm",
                            title: "상품 구성 변경 구독갱신관리 상세 확인내역",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'subscript',
                            log: {depth: 3, access: "운영관리->상품 구성 변경 구독갱신관리 상세 확인내역"},
                            accessIdx: "OPERATE_SUBSCRIPTION_DETAIL_AGREEHISTORY"
                        },
                    },

                    {
                        path: ":idx",
                        component: () => import('../views/subscript/SubscriptDetail.vue'),
                        name: "SubscriptDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "SubscriptDetail",
                            title: "상품 구성 변경 구독갱신관리 상세",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'subscript',
                            log: {depth: 3, access: "운영관리->상품 구성 변경 구독갱신관리 상세"},
                            accessIdx: "OPERATE_SUBSCRIPTION_DETAIL"
                        },
                    },
                ],
            },

            {
                path: "dataBase",
                component: () => import('../views/RouteView.vue'),
                name: "DataBaseMain",
                beforeEnter: storeSet,
                meta: {
                    name: "DataBaseMain",
                    title: "고객DB 관리",
                    side: 'operateDataBase',
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    log: {
                        depth: 4, access: "운영관리->고객 DB관리"
                    },
                    sideMenu: true,
                    accessIdx: "OPERATE_USERDB",
                },
                children: [
                    {
                        path: "",
                        component: () => import('../views/operate/DataBase.vue'),
                        name: "DataBase",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DataBase",
                            title: "고객DB 관리",
                            side: 'operateDataBase',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            accessIdx: "OPERATE_USERDB",
                            log: {depth: 4, access: "운영관리->고객 DB관리"}
                        },
                    },
                    {
                        path: "create",
                        component: () => import('../views/operate/DataBaseCreate.vue'),
                        name: "DataBaseCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DataBaseCreate",
                            title: "고객DB 관리",
                            authRequired: true,
                            side: 'operateDataBase',
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: false,
                            accessIdx: 'OPERATE_USERDB_DETAIL_EDIT',
                            log: {depth: 4, access: "운영관리->고객 DB관리"}
                        },
                    },
                    {
                        path: "detail/:idx",
                        component: () => import('../views/operate/DataBaseDetail.vue'),
                        name: "DataBaseDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DataBaseDetail",
                            title: "고객DB 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateDataBase',
                            accessIdx: "OPERATE_USERDB_DETAIL",
                            log: {depth: 4, access: "운영관리->고객 DB관리"}
                        },
                    },
                    {
                        path: "approve",
                        component: () => import('../views/operate/DataBaseApprove.vue'),
                        name: "DataBaseApprove",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DataBaseApprove",
                            title: "고객DB 관리",
                            side: 'operateDataBase',
                            storeConfig: {userInfo: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "",
                            log: {depth: 4, access: "운영관리->고객 DB관리"}
                        },
                    },
                    {
                        path: "approve/detail/:idx",
                        component: () => import('../views/operate/DataBaseApproveDetail.vue'),
                        name: "DataBaseApproveDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "DataBaseApproveDetail",
                            title: "고객DB 관리",
                            storeConfig: {userInfo: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateDataBase',
                            accessIdx: "",
                            log: {depth: 4, access: "운영관리->고객 DB관리"}
                        },
                    },

                ]
            },
            {
                path: "dataBase/excel",
                component: () => import('../views/operate/DataBaseExcel.vue'),
                name: "DataBaseExcel",
                beforeEnter: storeSet,
                meta: {
                    name: "DataBaseExcel",
                    title: "DB 엑셀다운 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateDataBaseExcel',
                    accessIdx: "OPERATE_DBEXCEL",
                    log: {depth: 4, access: "운영관리->DB엑셀다운관리"}
                },
            },

            {
                path: "menu",
                component: () => import('../views/operate/MenuRouteView.vue'),
                name: "MenuMain",
                beforeEnter: storeSet,
                meta: {
                    name: "MenuMain",
                    title: "앱 메뉴 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateMenu',
                    log: {depth: 4, access: "운영관리->앱 메뉴관리"},
                    accessIdx: "OPERATE_APPMENU"
                },
                children: [
                    {
                        path: "normal",
                        component: () => import('../views/operate/MenuNormal.vue'),
                        name: "MenuNormal",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MenuNormal",
                            title: "앱 메뉴 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateMenu',
                            log: {depth: 4, access: "운영관리->앱 메뉴관리->일반카테고리형"},
                            accessIdx: "OPERATE_APPMENU_NORMALCAT"
                        },
                    },
                    {
                        path: "ott",
                        component: () => import('../views/operate/MenuOtt.vue'),
                        name: "MenuOtt",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MenuOtt",
                            title: "앱 메뉴 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateMenu',
                            log: {depth: 4, access: "운영관리->앱 메뉴관리->앱실행형"},
                            accessIdx: "OPERATE_APPMENU_RAINBOWOTT"
                        },
                    },
                    {
                        path: "game",
                        component: () => import('../views/operate/MenuGame.vue'),
                        name: "MenuGame",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MenuGame",
                            title: "앱 메뉴 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateMenu',
                            log: {depth: 4, access: "운영관리->앱 메뉴관리->게임형"},
                            accessIdx: "OPERATE_APPMENU_RAINBOWGAME"
                        },
                    },
                    {
                        path: "location",
                        component: () => import('../views/operate/MenuLocation.vue'),
                        name: "MenuLocation",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MenuLocation",
                            title: "앱 메뉴 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateMenu',
                            log: {depth: 4, access: "운영관리->앱 메뉴관리->우리동네클래스 지역메뉴"},
                            accessIdx: "OPERATE_APPMENU_WCLOCAL_LIST"
                        },
                    },
                    {
                        path: ":type/create",
                        component: () => import('../views/operate/MenuCreate.vue'),
                        name: "MenuCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MenuCreate",
                            title: "앱 메뉴 등록",
                            authRequired: true,
                            side: 'operateMenu',
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                        },
                    },
                    {
                        path: ":type/:idx",
                        component: () => import('../views/operate/MenuDetail.vue'),
                        name: "MenuDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "MenuDetail",
                            title: "앱 메뉴 상세",
                            authRequired: true,
                            storeConfig: {userInfo: true},
                            sideMenu: false,
                            side: 'operateMenu',
                            log: {depth: 4, access: "운영관리->앱 메뉴관리->일반카테고리형->상세"}
                        },
                    },
                ]
            },

            {
                path: 'newTagSetting',
                component: () => import('../views/operate/NewTagSetting.vue'),
                name: "NewTagSetting",
                beforeEnter: storeSet,
                meta: {
                    name: "NewTagSetting",
                    title: "NEW 태그 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateMenu',
                    log: {depth: 3, access: "운영관리->NEW 태그 관리->리스트"},
                    accessIdx: "OPERATE_NEWTAG",
                    writeAccessIdx: "OPERATE_NEWTAG_EDIT"
                },
            },

            {
                path: "history",
                component: () => import('../views/RouteView.vue'),
                name: "history",
                beforeEnter: storeSet,
                meta: {
                    name: "history",
                    title: "포인트&코인 관리",
                    side: 'operatePoint',
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    accessIdx: "OPERATE_POINTCOIN"
                },
                children: [
                    {
                        path: "gold",
                        component: () => import('../views/history/HistoryGold.vue'),
                        name: "OperateGold",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateGold",
                            title: "골드 코인 내역 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operateGold',
                            sideMenu: true,
                            log: {depth: 4, access: "운영관리->포인트&코인관리->골드 코인 내역 관리"},
                            accessIdx: "OPERATE_POINTCOIN_GOLDCOINHISTORY"
                        },
                    },
                    {
                        path: "event-mgmt",
                        component: () => import('../views/policy/PolicyEventMgmt.vue'),
                        name: "Event-MGMT",
                        beforeEnter: storeSet,
                        meta: {
                            name: "Event",
                            title: "이벤트 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'event-mgmt',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->이벤트 관리->리스트"},
                            accessIdx: "OPERATE_POINTCOIN_EVENTMGMT"
                        },
                    },
                    {
                        path: "event-mgmt/create",
                        component: () => import('../views/policy/PolicyEventMgmtCreate.vue'),
                        name: "Event-MGMT-Create",
                        beforeEnter: storeSet,
                        meta: {
                            name: "EventCreate",
                            title: "이벤트 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'event-mgmt',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->이벤트 관리->상세"},
                            accessIdx: "OPERATE_POINTCOIN_EVENTMGMT_LIST_DETAIL_EDIT"
                        },
                    },
                    {
                        path: "event-mgmt/:idx",
                        component: () => import('../views/policy/PolicyEventMgmtDetail.vue'),
                        name: "Event-MGMT-Detail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "EventDetail",
                            title: "이벤트 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'event-mgmt',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->이벤트 관리->상세"},
                            accessIdx: "OPERATE_POINTCOIN_EVENTMGMT_LIST_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/policy/PolicyEventMgmtDetailMain.vue'),
                                name: "Event-MGMT-Detail-Main",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "EventDetailMain",
                                    title: "이벤트 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'event-mgmt',
                                    log: {depth: 4, access: "운영관리->포인트&코인관리->이벤트 관리->상세->상세정보"},
                                    accessIdx: "OPERATE_POINTCOIN_EVENTMGMT_LIST_DETAIL"
                                },
                            },
                            {
                                path: "gift-history",
                                component: () => import('../views/policy/PolicyEventMgmtDetailGiftHistory.vue'),
                                name: "Event-MGMT-Detail-GiftHistory",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "EventDetailGiftHistory",
                                    title: "이벤트 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'event-mgmt',
                                    log: {depth: 4, access: "운영관리->포인트&코인관리->이벤트 관리->상세->선물상자 지급 내역"},
                                    accessIdx: "OPERATE_POINTCOIN_EVENTMGMT_LIST_DETAIL"
                                },
                            },
                        ],
                    },
                    {
                        path: "giftbox-mgmt",
                        component: () => import('../views/policy/PolicyGiftboxMgmt.vue'),
                        name: "Giftbox-MGMT",
                        beforeEnter: storeSet,
                        meta: {
                            name: "Giftbox",
                            title: "선물상자 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'giftbox-mgmt',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->선물상자 관리->리스트"},
                            accessIdx: "OPERATE_POINTCOIN_GIFTBOXMGMT"
                        },
                    },
                    {
                        path: "giftbox-mgmt/create",
                        component: () => import('../views/policy/PolicyGiftboxMgmtCreate.vue'),
                        name: "Giftbox-MGMT-Create",
                        beforeEnter: storeSet,
                        meta: {
                            name: "GiftboxCreate",
                            title: "선물상자 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'giftbox-mgmt',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->선물상자 관리->상세"},
                            accessIdx: "OPERATE_POINTCOIN_GIFTBOXMGMT_LIST_DETAIL_EDIT"
                        },
                    },
                    {
                        path: "giftbox-mgmt/:idx",
                        component: () => import('../views/policy/PolicyGiftboxMgmtDetail.vue'),
                        name: "Giftbox-MGMT-Detail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "GiftboxDetail",
                            title: "선물상자 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'giftbox-mgmt',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->선물상자 관리->상세"},
                            accessIdx: "OPERATE_POINTCOIN_GIFTBOXMGMT_LIST_DETAIL"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/policy/PolicyGiftboxMgmtDetailMain.vue'),
                                name: "Giftbox-MGMT-Detail-Main",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "GiftboxDetailMain",
                                    title: "선물상자 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'giftbox-mgmt',
                                    log: {depth: 4, access: "운영관리->포인트&코인관리->선물상자 관리->상세->상세정보"},
                                    accessIdx: "OPERATE_POINTCOIN_GIFTBOXMGMT_LIST_DETAIL"
                                },
                            },
                            {
                                path: "gift-history",
                                component: () => import('../views/policy/PolicyGiftboxMgmtDetailGiftHistory.vue'),
                                name: "Giftbox-MGMT-Detail-GiftHistory",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "GiftboxDetailGiftHistory",
                                    title: "선물상자 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'giftbox-mgmt',
                                    log: {depth: 4, access: "운영관리->포인트&코인관리->선물상자 관리->상세->선물상자 지급 내역"},
                                    accessIdx: "OPERATE_POINTCOIN_GIFTBOXMGMT_LIST_DETAIL"
                                },
                            },
                        ],
                    },


                    {
                        path: "giftbox-history-mgmt",
                        component: () => import('../views/policy/PolicyGiftboxHistoryMgmt.vue'),
                        name: "Giftbox-History-MGMT",
                        beforeEnter: storeSet,
                        meta: {
                            name: "GiftboxHistory",
                            title: "선물상자 지급내역 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'giftbox-history-mgmt',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->선물상자 지급 내역 관리->리스트"},
                            accessIdx: "OPERATE_POINTCOIN_GIFTHISTORYMGMT"
                        },
                    },
                    // {
                    //     path: 'policy',
                    //     component: () => import('../views/policy/PolicyRouteView.vue'),
                    //     name: 'OperateHistoryPolicy',
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: "OperateHistoryPolicy",
                    //         title: "포인트정책 관리",
                    //         storeConfig: {userInfo: true, checkAccess: false},
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         sideMenu: true,
                    //         side: 'operatePolicy',
                    //         log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리"},
                    //         accessIdx: "OPERATE_POINTCOIN_POINTPOLICY",
                    //     },
                    //     children: [
                    //         {
                    //             path: "daily",
                    //             component: () => import('../views/policy/PolicyPointDaily.vue'),
                    //             name: "OperateHistoryPolicyDaily",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyDaily",
                    //                 title: "포인트정책 관리",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->데일리 미션"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_DAILYMISSION",
                    //             },
                    //         },
                    //         {
                    //             path: "daily/create",
                    //             component: () => import('../views/policy/PolicyPointDailyCreate.vue'),
                    //             name: "OperateHistoryPolicyDailyCreate",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyDailyCreate",
                    //                 title: "포인트 정책 등록",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->데일리 미션->상세"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_DAILYMISSION_DETAIL_EDIT",
                    //             },
                    //         },
                    //         {
                    //             path: "daily/:idx",
                    //             component: () => import('../views/policy/PolicyPointDailyUpdate.vue'),
                    //             name: "OperateHistoryPolicyDailyUpdate",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyDailyUpdate",
                    //                 title: "포인트 정책 등록",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->데일리 미션->상세"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_DAILYMISSION_DETAIL",
                    //             },
                    //         },
                    //         {
                    //             path: 'roulette',
                    //             component: () => import('../views/policy/PolicyPointRoulette.vue'),
                    //             name: "OperateHistoryPolicyRoulette",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyRoulette",
                    //                 title: "포인트정책 관리",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->럭키룰렛"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_LUCKYROULETTE",
                    //             },
                    //         },
                    //         {
                    //             path: 'attendance',
                    //             component: () => import('../views/policy/PolicyPointAttendance.vue'),
                    //             name: "OperateHistoryPolicyAttendance",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyAttendance",
                    //                 title: "포인트정책 관리",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->연속출석 미션"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_ATTENDANCEMISSION",
                    //             },
                    //         },
                    //         {
                    //             path: 'media',
                    //             component: () => import('../views/policy/PolicyPointMedia.vue'),
                    //             name: "OperateHistoryPolicyMedia",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyMedia",
                    //                 title: "포인트정책 관리",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->영상 이웃파트너 미션"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_VIDEOPARTNERMISSION",
                    //             },
                    //         },
                    //         {
                    //             path: 'media/create',
                    //             component: () => import('../views/policy/PolicyPointMediaCreate.vue'),
                    //             name: "OperateHistoryPolicyMediaCreate",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyMediaCreate",
                    //                 title: "포인트정책 관리",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->영상 이웃파트너 미션->상세"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_VIDEOPARTNERMISSION_DETAIL_EDIT",
                    //             },
                    //         },
                    //         {
                    //             path: 'media/:idx',
                    //             component: () => import('../views/policy/PolicyPointMediaUpdate.vue'),
                    //             name: "OperateHistoryPolicyMediaUpdate",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyMediaUpdate",
                    //                 title: "포인트정책 관리",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->영상 이웃파트너 미션->상세"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_VIDEOPARTNERMISSION_DETAIL",
                    //             },
                    //         },
                    //         {
                    //             path: 'payreward',
                    //             component: () => import('../views/policy/PolicyPointPayReward.vue'),
                    //             name: "OperateHistoryPolicyPayReward",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyPayReward",
                    //                 title: "포인트정책 관리",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->유료상품 결제 리워드"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_PAIDREWARD",
                    //             },
                    //         },
                    //         {
                    //             path: 'payreward/create',
                    //             component: () => import('../views/policy/PolicyPointPayRewardCreate.vue'),
                    //             name: "OperateHistoryPolicyPayRewardCreate",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyPayRewardCreate",
                    //                 title: "포인트정책 관리",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->유료상품 결제 리워드->상세"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_PAIDREWARD_DETAIL_EDIT",
                    //             },
                    //         },
                    //         {
                    //             path: 'payreward/:idx',
                    //             component: () => import('../views/policy/PolicyPointPayRewardUpdate.vue'),
                    //             name: "OperateHistoryPolicyPayRewardUpdate",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyPayRewardUpdate",
                    //                 title: "포인트정책 관리",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->유료상품 결제 리워드->상세"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_PAIDREWARD_DETAIL",
                    //             },
                    //         },
                    //         {
                    //             path: 'extra',
                    //             component: () => import('../views/policy/PolicyPointExtra.vue'),
                    //             name: "OperateHistoryPolicyExtra",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyExtra",
                    //                 title: "포인트정책 관리",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->기타 포인트"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_ETCPOINT",
                    //             },
                    //         },
                    //         {
                    //             path: 'extra/create',
                    //             component: () => import('../views/policy/PolicyPointExtraCreate.vue'),
                    //             name: "OperateHistoryPolicyExtraCreate",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyExtraCreate",
                    //                 title: "포인트정책 관리",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->기타 포인트->상세"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_ETCPOINT_DETAIL_EDIT",
                    //             },
                    //         },
                    //         {
                    //             path: 'extra/:idx',
                    //             component: () => import('../views/policy/PolicyPointExtraUpdate.vue'),
                    //             name: "OperateHistoryPolicyExtraUpdate",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "OperateHistoryPolicyExtraUpdate",
                    //                 title: "포인트정책 관리",
                    //                 storeConfig: {userInfo: true, checkAccess: false},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operatePolicy',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->포인트정책 관리->기타 포인트->상세"},
                    //                 accessIdx: "OPERATE_POINTCOIN_POINTPOLICY_ETCPOINT_DETAIL",
                    //             },
                    //         },
                    //     ],
                    // },
                    
                    
                    {
                        path: "prize",
                        component: () => import('../views/history/HistoryPrize.vue'),
                        name: "OperatePrize",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperatePrizeCreate",
                            title: "코인몰 경품 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operatePrize',
                            sideMenu: true,
                            log: {depth: 4, access: "운영관리->포인트&코인관리->코인몰 경품 관리"},
                            accessIdx: "OPERATE_POINTCOIN_COINMALLGIFT"
                        },
                    },
                    {
                        path: "prize/:idx",
                        component: () => import('../views/history/HistoryDetail.vue'),
                        name: "OperatePrizeDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperatePrizeDetail",
                            title: "코인몰 경품 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operatePrize',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->코인몰 경품 관리->상세"},
                            accessIdx: "OPERATE_POINTCOIN_COINMALLGIFT_DETAIL"
                        },
                    },
                    {
                        path: "prize/create",
                        component: () => import('../views/history/HistoryPrizeCreate.vue'),
                        name: "OperatePrizeCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperatePrize",
                            title: "코인몰 경품 등록",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operatePrize',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->코인몰 경품 관리->등록"},
                            accessIdx: "OPERATE_POINTCOIN_COINMALLGIFT_DETAIL_EDIT"
                        },
                    },
                    {
                        path: "prize/category",
                        component: () => import('../views/history/HistoryPrizeCategory.vue'),
                        name: "OperatePrizeCategory",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperatePrizeCategory",
                            title: "코인몰 카테고리 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operatePrize',
                            sideMenu: true,
                            log: {depth: 4, access: "운영관리->포인트&코인관리->코인몰 카테고리 관리"},
                            accessIdx: "OPERATE_POINTCOIN_GIFTCATMGMT"
                        },
                    },
                    {
                        path: "prize/category/:idx",
                        component: () => import('../views/history/HistoryPrizeCategoryDetail.vue'),
                        name: "OperatePrizeCategoryDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperatePrizeCategoryDetail",
                            title: "코인몰 카테고리 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operatePrize',
                            sideMenu: false,
                            log: {depth: 4, access: "운영관리->포인트&코인관리->코인몰 카테고리 관리->상세"},

                            accessIdx: "OPERATE_POINTCOIN_GIFTCATMGMT_DETAIL"
                        },
                    },
                    {
                        path: "prize/category/create",
                        component: () => import('../views/history/HistoryPrizeCategoryCreate.vue'),
                        name: "OperatePrizeCategoryCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperatePrizeCategoryCreate",
                            title: "코인몰 카테고리 등록",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operatePrize',
                            sideMenu: false,
                            log: {depth: 4, access: "운영관리->포인트&코인관리->코인몰 카테고리 관리->등록"},

                            accessIdx: "OPERATE_POINTCOIN_GIFTCATMGMT_DETAIL"
                        },
                    },


                    {
                        path: "cmb",
                        component: () => import('../views/history/HistoryCmb.vue'),
                        name: "OperateHistoryCmb",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateHistoryCmb",
                            title: "코인몰 경품 교환 내역",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'operateHistoryTrade',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->코인몰 경품 교환 내역"},
                            accessIdx: "OPERATE_POINTCOIN_GIFTEXCHANGE"
                        },
                    },

                    // {
                    //     path: "affiliate",
                    //     component: () => import('../views/history/HistoryAffiliate.vue'),
                    //     name: "OperateHistoryAffiliate",
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: "OperateHistoryAffiliate",
                    //         title: "제휴상품 교환 내역",
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         sideMenu: true,
                    //         side: 'operateAffiliate',

                    //         log: {depth: 4, access: "운영관리->포인트&코인관리->제휴상품 교환 내역"},
                    //         accessIdx: "OPERATE_POINTCOIN_AFFILIATEEXCHANGE"
                    //     },
                    // },




                    // {
                    //     path: "affiliate/discount",
                    //     component: () => import('../views/history/HistoryAffiliateDiscount.vue'),
                    //     name: "OperateHistoryAffiliateDiscount",
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: "OperateHistoryAffiliateDiscount",
                    //         title: "제휴상품 교환 내역",
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         sideMenu: false,
                    //         side: 'operateAffiliate',
                    //         log: {depth: 4, access: "운영관리->포인트&코인관리->제휴상품 교환 내역"},
                    //         accessIdx: "OPERATE_POINTCOIN_AFFILIATEEXCHANGE"
                    //     },
                    // },

                    // {
                    //     path: "affiliate/:idx",
                    //     component: () => import('../views/history/HistoryAffiliateDetail.vue'),
                    //     name: "OperateHistoryAffiliateDetail",
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: "OperateHistoryAffiliateDetail",
                    //         title: "제휴상품 교환 내역",
                    //         storeConfig: {userInfo: true},
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         side: 'operateAffiliate',
                    //         log: {depth: 4, access: "운영관리->포인트&코인관리->제휴상품 교환 내역->상세"},
                    //         accessIdx: "OPERATE_POINTCOIN_AFFILIATEEXCHANGE_DETAIL"
                    //     },
                    // },

                    // {
                    //     path: "vod",
                    //     component: () => import('../views/history/HistoryVodRouteView.vue'),
                    //     name: "HistoryVodMain",
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: "HistoryVodMain",
                    //         title: "VOD 교환 내역",
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         sideMenu: true,
                    //         side: 'operateVod',
                    //         log: {depth: 4, access: "운영관리->포인트&코인관리->VOD 교환 내역"},
                    //         accessIdx: "OPERATE_POINTCOIN_VODEXCHANGE"
                    //     },
                    //     children: [
                    //         {
                    //             path: "vodList",
                    //             component: () => import('../views/history/HistoryVod.vue'),
                    //             name: "HistoryVod",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "HistoryVod",
                    //                 title: "VOD 교환 내역",
                    //                 storeConfig: {userInfo: true, checkAccess: true},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operateVod',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->VOD 교환 내역->VOD"},
                    //                 accessIdx: "OPERATE_POINTCOIN_VODEXCHANGE"
                    //             },
                    //         },

                    //         {
                    //             path: "vodList/:idx",
                    //             component: () => import('../views/history/HistoryVodDetail.vue'),
                    //             name: "HistoryVodDetail",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "HistoryVodDetail",
                    //                 title: "VOD 교환 내역",
                    //                 storeConfig: {userInfo: true},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 side: 'operateVod',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->VOD 교환 내역->VOD->상세"},
                    //                 accessIdx: "OPERATE_POINTCOIN_VODEXCHANGE_DETAIL"
                    //             },
                    //         },

                    //         {
                    //             path: "packageList",
                    //             component: () => import('../views/history/HistoryPackage.vue'),
                    //             name: "HistoryPackage",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "HistoryPackage",
                    //                 title: "VOD 패키지 교환 내역",
                    //                 storeConfig: {userInfo: true, checkAccess: true},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 sideMenu: false,
                    //                 side: 'operateVod',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->VOD 교환 내역->VOD 패키지"},
                    //                 accessIdx: 'OPERATE_POINTCOIN_VODEXCHANGE_VODPKLIST'
                    //             },
                    //         },

                    //         {
                    //             path: "packageList/:idx",
                    //             component: () => import('../views/history/HistoryPackageDetail.vue'),
                    //             name: "HistoryPackageDetail",
                    //             beforeEnter: storeSet,
                    //             meta: {
                    //                 name: "HistoryPackageDetail",
                    //                 title: "VOD 패키지 교환 내역",
                    //                 storeConfig: {userInfo: true},
                    //                 authRequired: true,
                    //                 storeRequired: true,
                    //                 side: 'operateVod',
                    //                 log: {depth: 4, access: "운영관리->포인트&코인관리->VOD 교환 내역->VOD 패키지->상세"},
                    //                 accessIdx: 'OPERATE_POINTCOIN_VODEXCHANGE_VODPKLIST_DETAIL'
                    //             },
                    //         },
                    //     ]
                    // },


                    // {
                    //     path: "rate",
                    //     component: () => import('../views/point/PointRate.vue'),
                    //     name: "PointRate",
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: "PointRate",
                    //         title: "포인트교환비율관리",
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         sideMenu: true,
                    //         side: 'pointRate',
                    //         log: {depth: 4, access: "운영관리->포인트&코인관리->포인트교환비율관리"},
                    //         accessIdx: "OPERATE_POINTCOIN_GIFTEXCHANGE"
                    //     },
                    // },
                    // {
                    //     path: "rate/create",
                    //     component: () => import('../views/point/PointRateCreate.vue'),
                    //     name: "PointRateCreate",
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: "PointRateCreate",
                    //         title: "포인트교환비율 등록",
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         sideMenu: false,
                    //         side: 'PointRateCreate',
                    //         log: {depth: 4, access: "운영관리->포인트&코인관리->포인트교환비율관리"},
                    //         accessIdx: "OPERATE_POINTCOIN_GIFTEXCHANGE"
                    //     },
                    // },
                    // {
                    //     path: "rate/update/:idx",
                    //     component: () => import('../views/point/PointRateUpdate.vue'),
                    //     name: "PointRateUpdate",
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: "PointRateUpdate",
                    //         title: "포인트교환비율 수정",
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         sideMenu: false,
                    //         side: 'PointRateUpdate',
                    //         log: {depth: 4, access: "운영관리->포인트&코인관리->포인트교환비율관리"},
                    //         accessIdx: "OPERATE_POINTCOIN_POINTRATE_DETAIL"
                    //     },
                    // },

                    {
                        path: "kakao",
                        component: () => import('../views/history/HistoryKakao.vue'),
                        name: "OperateHistoryKakao",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateHistoryKakao",
                            title: "경품 교환 내역",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operateHistoryTrade',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->경품 교환 내역"},
                            accessIdx: "OPERATE_POINTCOIN_GIFTEXCHANGE"
                        },
                    },
                    {
                        path: "trade/:idx",
                        component: () => import('../views/history/HistoryTradeDetail.vue'),
                        name: "OperateHistoryTradeDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateHistoryTradeDetail",
                            title: "코인몰 경품 교환 내역",
                            storeConfig: {userInfo: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operateHistoryTrade',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->코인몰 경품 교환 내역->상세"},
                            accessIdx: "OPERATE_POINTCOIN_GIFTEXCHANGE_DETAIL"
                        },
                    },
                    // {
                    //     path: "event",
                    //     component: () => import('../views/policy/PolicyEvent.vue'),
                    //     name: "Event",
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: "Event",
                    //         title: "이벤트탭관리",
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         sideMenu: true,
                    //         side: 'event',
                    //         isSuperOnly: true,
                    //         log: {depth: 4, access: "운영관리->포인트&코인관리->이벤트탭관리->리스트"},
                    //     },
                    // },

                    
                    



                    {
                        path: "again/prize",
                        component: () => import('../views/history/HistoryAgainPrize.vue'),
                        name: "OperateAgainPrize",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateAgainPrize",
                            title: "또바몰 경품 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operatePrize',
                            sideMenu: true,
                            log: {depth: 4, access: "운영관리->포인트&코인관리->또바몰 경품 관리"},
                            accessIdx: "OPERATE_POINTCOIN_AGAINPRIZEMGMT"
                        },
                    },
                    {
                        path: "again/prize/create",
                        component: () => import('../views/history/HistoryAgainPrizeCreate.vue'),
                        name: "OperateAgainPrizeCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateAgainPrizeCreate",
                            title: "또바몰 경품 등록",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operatePrize',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->또바몰 경품 관리->등록"},
                            accessIdx: "OPERATE_POINTCOIN_AGAINPRIZEMGMT_LIST_DETAIL_EDIT"
                        },
                    },
                    {
                        path: "again/prize/:idx",
                        component: () => import('../views/history/HistoryAgainPrizeDetail.vue'),
                        name: "OperateAgainPrizeDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateAgainPrizeDetail",
                            title: "또바몰 경품 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operatePrize',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->또바몰 경품 관리->상세"},
                            accessIdx: "OPERATE_POINTCOIN_AGAINPRIZEMGMT_LIST_DETAIL"
                        },
                    },
                    {
                        path: "again/category",
                        component: () => import('../views/history/HistoryAgainCategory.vue'),
                        name: "OperateAgainCategory",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateAgainCategory",
                            title: "또바몰 카테고리 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operatePrize',
                            sideMenu: true,
                            log: {depth: 4, access: "운영관리->포인트&코인관리->또바몰 카테고리 관리"},
                            accessIdx: "OPERATE_POINTCOIN_AGAINCATEGORYMGMT"
                        },
                    },
                    {
                        path: "again/category/create",
                        component: () => import('../views/history/HistoryAgainCategoryCreate.vue'),
                        name: "OperateAgainCategoryCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateAgainCategoryCreate",
                            title: "또바몰 카테고리 등록",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operatePrize',
                            sideMenu: false,
                            log: {depth: 4, access: "운영관리->포인트&코인관리->또바몰 카테고리 관리->등록"},

                            accessIdx: "OPERATE_POINTCOIN_AGAINCATEGORYMGMT_LIST_DETAIL_EDIT"
                        },
                    },
                    {
                        path: "again/category/:idx",
                        component: () => import('../views/history/HistoryAgainCategoryDetail.vue'),
                        name: "OperateAgainCategoryDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateAgainCategoryDetail",
                            title: "또바몰 카테고리 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'operatePrize',
                            sideMenu: false,
                            log: {depth: 4, access: "운영관리->포인트&코인관리->또바몰 카테고리 관리->상세"},

                            accessIdx: "OPERATE_POINTCOIN_AGAINCATEGORYMGMT_LIST_DETAIL"
                        },
                    },

                    {
                        path: "again",
                        component: () => import('../views/history/HistoryAgain.vue'),
                        name: "OperateHistoryAgain",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateHistoryAgain",
                            title: "또바몰 경품 교환 내역",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'OperateHistoryAgain',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->또바몰 경품 교환 내역"},
                            accessIdx: "OPERATE_POINTCOIN_AGAINEXCHANGEMGMT"
                        },
                    },
                    {
                        path: "again/:idx",
                        component: () => import('../views/history/HistoryAgainDetail.vue'),
                        name: "OperateHistoryAgainDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateHistoryAgainDetail",
                            title: "또바몰 경품 교환 내역",
                            storeConfig: {userInfo: true},
                            authRequired: true,
                            storeRequired: true,
                            side: 'OperateHistoryAgain',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->또바몰 경품 교환 내역->상세"},
                            accessIdx: "OPERATE_POINTCOIN_AGAINEXCHANGEMGMT_LIST_DETAIL"
                        },
                    },
                    {
                        path: "usage",
                        component: () => import('../views/history/UsageRouteView.vue'),
                        name: "OperateHistoryUsage",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateHistoryPoint",
                            title: "(구)포인트&코인 내역",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'operatePoint',
                            log: {depth: 4, access: "운영관리->포인트&코인관리->포인트 사용현황"},
                            accessIdx: "OPERATE_POINTCOIN_POINTCOINHISTORY"
                        },
                        children: [
                            {
                                path: "point",
                                component: () => import('../views/history/HistoryPoint.vue'),
                                name: "OperateHistoryPoint",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "OperateHistoryPoint",
                                    title: "포인트 사용현황",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operatePoint',
                                    log: {depth: 4, access: "운영관리->포인트&코인관리->포인트 사용현황"},
                                    accessIdx: "OPERATE_POINTCOIN_POINTCOINHISTORY_POINTUSAGE"
                                },
                            },
                            {
                                path: "coin",
                                component: () => import('../views/history/HistoryCoin.vue'),
                                name: "OperateHistoryCoin",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "OperateHistoryCoin",
                                    title: "코인 사용현황",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operatePoint',
                                    log: {depth: 4, access: "운영관리->포인트&코인관리->코인 사용현황"},
                                    accessIdx: "OPERATE_POINTCOIN_POINTCOINHISTORY_COINUSAGE"
                                },
                            },
                        ]
                    },
                ]
            },

            {
                path: "advManagement",
                component: () => import('../views/management/AdvManagementRouteView.vue'),
                name: "advFrequencyMain",
                beforeEnter: storeSet,
                meta: {
                    name: "advFrequencyMain",
                    title: "광고 운영 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateAdvFrequency',
                    log: {depth: 4, access: "운영관리->광고 운영 관리"},
                    accessIdx: "OPERATE_ADOPERATE"
                },
                children: [
                    {
                        path: "frequency",
                        component: () => import('../views/management/AdvFrequency.vue'),
                        name: "advFrequency",
                        beforeEnter: storeSet,
                        meta: {
                            name: "advFrequency",
                            title: "광고 운영 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateAdvFrequency',
                            log: {depth: 4, access: "운영관리->광고 운영 관리->노출빈도 관리"},
                            accessIdx: "OPERATE_ADOPERATE_FREQMGMT"
                        },
                    },
                    {
                        path: "order",
                        component: () => import('../views/management/AdvOrder.vue'),
                        name: "advOrder",
                        beforeEnter: storeSet,
                        meta: {
                            name: "advOrder",
                            title: "광고 운영 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateAdvFrequency',
                            log: {depth: 4, access: "운영관리->광고 운영 관리->노출순서 관리"},
                            accessIdx: "OPERATE_ADOPERATE_DISPLAYORDERMGMT"
                        },
                    },
                    {
                        path: "order/:type/:idx",
                        component: () => import('../views/management/AdvOrderDetail.vue'),
                        name: "advOrderDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "advOrderDetail",
                            title: "광고 노출 순서 관리",
                            authRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: false,
                            side: 'operateAdvFrequency',
                            log: {depth: 4, access: "운영관리->광고 운영 관리->노출순서 관리->상세"},
                            accessIdx: 'OPERATE_ADOPERATE_DISPLAYORDERMGMT_DETAIL'
                        },
                    },
                ]
            },


            {
                path: "shopping",
                component: () => import('../views/RouteView.vue'),
                name: "shopping",
                beforeEnter: storeSet,
                meta: {
                    name: "shopping",
                    title: "쇼핑 관리",
                    side: 'operateShopping',
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    accessIdx: "OPERATE_SHOPMGMT"
                },
                children: [
                    {
                        path: "deposit",
                        component: () => import('../views/shopping/ShoppingDeposit.vue'),
                        name: "ShoppingDeposit",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ShoppingDeposit",
                            title: "입금 관리",
                            authRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: true,
                            side: 'ShoppingDeposit',
                            log: {depth: 4, access: "운영관리->쇼핑 관리->입금 관리"},
                            accessIdx: "OPERATE_SHOPMGMT_DEPOSITMGMT"
                        },
                    },
                    {
                        path: "deposit/:idx",
                        component: () => import('../views/shopping/ShoppingDepositDetail.vue'),
                        name: "ShoppingDepositDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ShoppingDepositDetail",
                            title: "입금 관리 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'ShoppingDeposit',
                            log: {depth: 4, access: "운영관리->쇼핑 관리->입금 관리->상세"},
                            accessIdx: "OPERATE_SHOPMGMT_DEPOSITMGMT_DETAIL"
                        },
                    },
                    {
                        path: "order",
                        component: () => import('../views/shopping/ShoppingOrder.vue'),
                        name: "ShoppingOrder",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ShoppingOrder",
                            title: "주문관리",
                            authRequired: true,
                            storeConfig: {userInfo: true, checkAccess: true},
                            sideMenu: true,
                            side: 'ShoppingOrder',
                            log: {depth: 4, access: "운영관리->쇼핑 관리->주문관리"},
                            accessIdx: "OPERATE_SHOPMGMT_ORDERMGMT"
                        },
                    },
                    {
                        path: "order/:idx",
                        component: () => import('../views/shopping/ShoppingOrderDetail.vue'),
                        name: "ShoppingOrderDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ShoppingOrderDetail",
                            title: "쇼핑관리 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'ShoppingOrderDetail',
                            log: {depth: 4, access: "운영관리->쇼핑 관리->상세"},
                            accessIdx: "OPERATE_SHOPMGMT_ORDERMGMT_DETAIL"
                        },
                    },
                    {
                        path: "ready",
                        component: () => import('../views/shopping/ShoppingReady.vue'),
                        name: "ShoppingReady",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ShoppingReady",
                            title: "상품준비중 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'ShoppingReady',
                            log: {depth: 4, access: "운영관리->쇼핑 관리->상품준비중 관리"},
                            accessIdx: "OPERATE_SHOPMGMT_PREPRODMGMT"
                        },
                    },
                    {
                        path: "ready/:idx",
                        component: () => import('../views/shopping/ShoppingReadyDetail.vue'),
                        name: "ShoppingReadyDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ShoppingReadyDetail",
                            title: "상품준비중 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'ShoppingReadyDetail',
                            log: {depth: 4, access: "운영관리->쇼핑 관리->상품준비중관리->상세"},
                            accessIdx: "OPERATE_SHOPMGMT_PREPRODMGMT_DETAIL"
                        },
                    },
                    {
                        path: "wait",
                        component: () => import('../views/shopping/ShoppingWait.vue'),
                        name: "ShoppingWait",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ShoppingWait",
                            title: "배송대기 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'ShoppingWait',
                            log: {depth: 4, access: "운영관리->쇼핑 관리->배송대기 관리"},
                            accessIdx: "OPERATE_SHOPMGMT_WAITDELIVERY"
                        },
                    },
                    {
                        path: "wait/:idx",
                        component: () => import('../views/shopping/ShoppingWaitDetail.vue'),
                        name: "ShoppingWaitDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ShoppingWaitDetail",
                            title: "배송대기 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'ShoppingWaitDetail',
                            log: {depth: 4, access: "운영관리->쇼핑 관리->배송대기관리->상세"},
                            accessIdx: "OPERATE_SHOPMGMT_WAITDELIVERY_DETAIL"
                        },
                    },
                    {
                        path: "delivery",
                        component: () => import('../views/shopping/ShoppingDelivery.vue'),
                        name: "ShoppingDelivery",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ShoppingDelivery",
                            title: "배송중 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'ShoppingDelivery',
                            log: {depth: 4, access: "운영관리->쇼핑 관리->배송중 관리"},
                            accessIdx: "OPERATE_SHOPMGMT_INGDELIVERY"
                        },
                    },
                    {
                        path: "delivery/:idx",
                        component: () => import('../views/shopping/ShoppingDeliveryDetail.vue'),
                        name: "ShoppingDeliveryDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ShoppingDeliveryDetail",
                            title: "배송중 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'ShoppingDeliveryDetail',
                            log: {depth: 4, access: "운영관리->쇼핑 관리->배송중 관리->상세"},
                            accessIdx: "OPERATE_SHOPMGMT_INGDELIVERY_DETAIL"
                        },
                    },
                    {
                        path: "end",
                        component: () => import('../views/shopping/ShoppingEnd.vue'),
                        name: "ShoppingEnd",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ShoppingEnd",
                            title: "배송완료 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            side: 'ShoppingEnd',
                            log: {depth: 4, access: "운영관리->쇼핑 관리->배송완료 관리"},
                            accessIdx: "OPERATE_SHOPMGMT_COMPDELIVERY"
                        },
                    },
                    {
                        path: "end/:idx",
                        component: () => import('../views/shopping/ShoppingEndDetail.vue'),
                        name: "ShoppingEndDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ShoppingEndDetail",
                            title: "배송완료 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'ShoppingEndDetail',
                            log: {depth: 4, access: "운영관리->쇼핑 관리->배송완료 관리->상세"},
                            accessIdx: "OPERATE_SHOPMGMT_COMPDELIVERY_DETAIL"
                        },
                    },
                    {
                        path: "withdraw",
                        component: () => import('../views/RouteView.vue'),
                        name: "OperateWithdraw",
                        beforeEnter: storeSet,
                        meta: {
                            name: "OperateWithdraw",
                            title: "취소/반품/교환 관리",
                            side: 'OperateWithdraw',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: true,
                            accessIdx: "OPERATE_SHOPMGMT_CLAIMMGMT"
                        },
                        children: [
                            {
                                path: "cancel",
                                component: () => import('../views/shopping/ShoppingCancel.vue'),
                                name: "ShoppingCancel",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "ShoppingCancel",
                                    title: "주문취소 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: true,
                                    side: 'ShoppingCancel',
                                    log: {depth: 4, access: "운영관리->쇼핑 관리->주문취소 관리"},
                                    accessIdx: "OPERATE_SHOPMGMT_CLAIMMGMT_ORDERCANCELMGMT"
                                },
                            },

                            {
                                path: "cancel/:idx",
                                component: () => import('../views/shopping/ShoppingCancelDetail.vue'),
                                name: "ShoppingCancelDetail",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "ShoppingCancelDetail",
                                    title: "주문취소 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'ShoppingCancelDetail',
                                    log: {depth: 4, access: "운영관리->쇼핑 관리->주문취소 관리->->상세"},
                                    accessIdx: "OPERATE_SHOPMGMT_CLAIMMGMT_ORDERCANCELMGMT_DETAIL"
                                },
                            },

                            {
                                path: "refund",
                                component: () => import('../views/shopping/ShoppingRefundRequest.vue'),
                                name: "ShoppingRefundRequest",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "ShoppingRefundRequest",
                                    title: "반품 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: true,
                                    side: 'ShoppingRefundRequest',
                                    log: {depth: 4, access: "운영관리->쇼핑 관리->반품 관리"},
                                    accessIdx: "OPERATE_SHOPMGMT_CLAIMMGMT_RETURNMGMT"
                                },
                            },
                            {
                                path: "refund/accept",
                                component: () => import('../views/shopping/ShoppingRefundAccept.vue'),
                                name: "ShoppingRefundAccept",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "ShoppingRefundAccept",
                                    title: "반품 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'ShoppingRefundAccept',
                                    log: {depth: 4, access: "운영관리->쇼핑 관리->반품 관리"},
                                    accessIdx: "OPERATE_SHOPMGMT_CLAIMMGMT_RETURNMGMT"
                                },
                            },
                            {
                                path: "refund/reject",
                                component: () => import('../views/shopping/ShoppingRefundReject.vue'),
                                name: "ShoppingRefundReject",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "ShoppingRefundReject",
                                    title: "반품 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'ShoppingRefundReject',
                                    log: {depth: 4, access: "운영관리->쇼핑 관리->반품 관리"},
                                    accessIdx: "OPERATE_SHOPMGMT_CLAIMMGMT_RETURNMGMT"
                                },
                            },
                            {
                                path: "refund/:idx",
                                component: () => import('../views/shopping/ShoppingRefundDetail.vue'),
                                name: "ShoppingRefundDetail",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "ShoppingRefundDetail",
                                    title: "반품관리 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'ShoppingRefundDetail',
                                    log: {depth: 4, access: "운영관리->쇼핑관리->반품관리->상세"},
                                    accessIdx: "OPERATE_SHOPMGMT_CLAIMMGMT_RETURNMGMT_DETAIL"
                                },
                            },


                            {
                                path: "change",
                                component: () => import('../views/shopping/ShoppingChangeRequest.vue'),
                                name: "ShoppingChangeRequest",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "ShoppingChangeRequest",
                                    title: "교환 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: true,
                                    side: 'ShoppingChangeRequest',
                                    log: {depth: 4, access: "운영관리->쇼핑 관리->교환 관리"},
                                    accessIdx: "OPERATE_SHOPMGMT_CLAIMMGMT_EXCHANGEMGMT"
                                },
                            },
                            {
                                path: "change/accept",
                                component: () => import('../views/shopping/ShoppingChangeAccept.vue'),
                                name: "ShoppingChangeAccept",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "ShoppingChangeAccept",
                                    title: "교환 관리",
                                    storeConfig: {userInfo: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'ShoppingChangeAccept',
                                    log: {depth: 4, access: "운영관리->쇼핑 관리->교환 관리"},
                                    accessIdx: "OPERATE_SHOPMGMT_CLAIMMGMT_EXCHANGEMGMT"
                                },
                            },
                            {
                                path: "change/reject",
                                component: () => import('../views/shopping/ShoppingChangeReject.vue'),
                                name: "ShoppingChangeReject",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "ShoppingChangeReject",
                                    title: "교환 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'ShoppingChangeReject',
                                    log: {depth: 4, access: "운영관리->쇼핑 관리->교환 관리"},
                                    accessIdx: "OPERATE_SHOPMGMT_CLAIMMGMT_EXCHANGEMGMT"
                                },
                            },
                            {
                                path: "change/:idx",
                                component: () => import('../views/shopping/ShoppingChangeDetail.vue'),
                                name: "ShoppingChangeDetail",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "ShoppingChangeDetail",
                                    title: "교환관리 상세",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'ShoppingChangeDetail',
                                    log: {depth: 4, access: "운영관리->쇼핑 관리->교환관리->상세"},
                                    accessIdx: "OPERATE_SHOPMGMT_CLAIMMGMT_EXCHANGEMGMT_DETAIL"
                                },
                            },
                        ]
                    }
                ]
            },

            {
                path: "zone",
                component: () => import('../views/zone/ZoneRouteView.vue'),
                name: "Zone",
                beforeEnter: storeSet,
                meta: {
                    name: "Zone",
                    title: "이웃파트너존 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'zone',
                    log: {depth: 3, access: "콘텐츠관리->이웃파트너존관리"},
                    accessIdx: "OPERATE_PARTNERZONE"
                },
                children: [
                    {
                        path: "manage",
                        component: () => import('../views/zone/Zone.vue'),
                        name: "ZoneList",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ZoneList",
                            title: "이웃파트너존 관리",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'zone',
                            log: {depth: 3, access: "콘텐츠관리->이웃파트너존관리"},
                            accessIdx: "OPERATE_PARTNERZONE"
                        },
                    },
                    {
                        path: "comment/detail/:idx/:paidx",
                        component: () => import('../views/zone/ZoneCommentDetail.vue'),
                        name: "ZoneCommentDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ZoneCommentDetail",
                            title: "이웃파트너존 댓글 상세",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'zone',
                            log: {depth: 3, access: "콘텐츠관리->이웃파트너존관리->댓글->상세"},
                            accessIdx: "OPERATE_PARTNERZONE_LIST_DETAIL"

                        },
                    },

                    {
                        path: "comment/:idx",
                        component: () => import('../views/zone/ZoneComment.vue'),
                        name: "ZoneComment",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ZoneComment",
                            title: "이웃파트너존 댓글",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'zone',
                            log: {depth: 3, access: "콘텐츠관리->이웃파트너존관리->댓글"},
                            accessIdx: "OPERATE_PARTNERZONE_LIST_DETAIL"

                        },
                    },
                    {
                        path: ":idx",
                        component: () => import('../views/zone/ZoneDetail.vue'),
                        name: "ZoneDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ZoneDetail",
                            title: "이웃파트너존 상세",
                            storeConfig: {userInfo: true, checkAccess: true,},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'zone',
                            log: {depth: 3, access: "콘텐츠관리->이웃파트너존관리->상세"},
                            accessIdx: "OPERATE_PARTNERZONE_LIST_DETAIL"

                        },
                    },
                ],

            },

            {
                path: "forbidden",
                component: () => import('../views/forbidden/Forbidden.vue'),
                name: "Forbidden",
                beforeEnter: storeSet,
                meta: {
                    name: "Forbidden",
                    title: "금칙어 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'forbidden',
                    log: {depth: 3, access: "콘텐츠관리->금칙어관리"},
                    accessIdx: 'OPERATE_FORBIDDEN'
                },
            },
            {
                path: "comment",
                component: () => import('../views/comment/CommentBoard.vue'),
                name: "CommentBoard",
                beforeEnter: storeSet,
                meta: {
                    name: "CommentBoard",
                    title: "댓글/리뷰관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'comment',
                    log: {depth: 4, access: "운영관리->댓글/리뷰관리"},
                    accessIdx: 'OPERATE_COMMENTREVIEW'
                },
            },
            {
                path: "comment/content",
                component: () => import('../views/comment/CommentContent.vue'),
                name: "CommentContent",
                beforeEnter: storeSet,
                meta: {
                    name: "CommentContent",
                    title: "댓글/리뷰관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'comment',
                    log: {depth: 4, access: "운영관리->댓글/리뷰관리"},
                    accessIdx: 'OPERATE_COMMENTREVIEW'
                },
            },
            {
                path: "comment/shopping",
                component: () => import('../views/comment/CommentShopping.vue'),
                name: "CommentShopping",
                beforeEnter: storeSet,
                meta: {
                    name: "CommentShopping",
                    title: "댓글/리뷰관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'comment',
                    log: {depth: 4, access: "운영관리->댓글/리뷰관리"},
                    accessIdx: 'OPERATE_COMMENTREVIEW'
                },
            },
            {
                path: "comment/:idx",
                component: () => import('../views/comment/CommentDetail.vue'),
                name: "commentDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "commentDetail",
                    title: "댓글/리뷰관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'comment',
                    log: {depth: 4, access: "운영관리->댓글/리뷰관리->상세"}
                },
            },
            {
                path: "topten",
                component: () => import('../views/topten/ToptenApp.vue'),
                name: "Topten",
                beforeEnter: storeSet,
                meta: {
                    name: "Topten",
                    title: "Top10 카테고리 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'Topten',
                    log: {depth: 4, access: "운영관리->Top10 카테고리 관리->리스트"},
                    accessIdx: 'OPERATE_TOP10CATEGORY'
                },
            },
            {
                path: "topten/smart",
                component: () => import('../views/topten/ToptenSmart.vue'),
                name: "ToptenSmart",
                beforeEnter: storeSet,
                meta: {
                    name: "ToptenSmart",
                    title: "Top10 카테고리 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'Topten',
                    log: {depth: 4, access: "운영관리->Top10 카테고리 관리->리스트"},
                    accessIdx: 'OPERATE_TOP10CATEGORY'
                },
            },
            {
                path: "topten/settop",
                component: () => import('../views/topten/ToptenSettop.vue'),
                name: "ToptenSettop",
                beforeEnter: storeSet,
                meta: {
                    name: "ToptenSettop",
                    title: "Top10 카테고리 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'Topten',
                    log: {depth: 4, access: "운영관리->Top10 카테고리 관리->리스트"},
                    accessIdx: 'OPERATE_TOP10CATEGORY'
                },
            },
            {
                path: "topten/:idx",
                component: () => import('../views/topten/ToptenDetail.vue'),
                name: "ToptenDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "ToptenDetail",
                    title: "Top10 카테고리 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'Topten',
                    log: {depth: 4, access: "운영관리->Top10 카테고리 관리->상세"},
                    accessIdx: "OPERATE_TOP10CATEGORY_DETAIL"
                },
            },


            {
                path: "popup",
                component: () => import('../views/popup/PopupRouteView.vue'),
                name: "Popup",
                beforeEnter: storeSet,
                meta: {
                    name: "Popup",
                    title: "팝업 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operatePopup',
                    log: {depth: 4, access: "운영관리->팝업 관리"},
                    accessIdx: "OPERATE_POPUP"
                },
                children: [
                    {
                        path: "fixed",
                        component: () => import('../views/popup/Popup.vue'),
                        name: "Popup",
                        beforeEnter: storeSet,
                        meta: {
                            name: "Popup",
                            title: "팝업 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operatePopup',
                            log: {depth: 4, access: "운영관리->팝업 관리->고정형 팝업 리스트"},
                            accessIdx: "OPERATE_POPUP_FIXEDPOPUP"
                        },
                    },
                    {
                        path: "ai",
                        component: () => import('../views/popup/AiPopup.vue'),
                        name: "AiPopup",
                        beforeEnter: storeSet,
                        meta: {
                            name: "AiPopup",
                            title: "팝업 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operatePopup',
                            log: {depth: 4, access: "운영관리->팝업 관리->맞춤형 팝업 리스트"},
                            accessIdx: "OPERATE_POPUP_AIPOPUP"
                        },
                    },
                    {
                        path: "setting",
                        component: () => import('../views/popup/PopupSetting.vue'),
                        name: "PopupSetting",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PopupSetting",
                            title: "팝업 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operatePopup',
                            log: {depth: 4, access: "운영관리->팝업 관리->채널팝업 노출설정"},
                            accessIdx: "OPERATE_POPUP_POPUPSET"
                        },
                    },
                ],
            },
            // {
            //     path: "alarm",
            //     component: () => import('../views/operate/Alarm.vue'),
            //     name: "Alarm",
            //     beforeEnter: storeSet,
            //     meta: {
            //         name: "Alarm", title: "알림 관리",
            //         storeConfig: {userInfo: true, checkAccess: true},
            //         authRequired: true,
            //         storeRequired: true, sideMenu: true,
            //         side: 'operateAlarm',
            //         log: {depth: 4, access: "운영관리->알림 관리"},
            //         accessIdx: "OPERATE_ALARM"
            //     },
            // },
            {
                path: "webMain",
                component: () => import('../views/management/WebMain.vue'),
                name: "webMain",
                beforeEnter: storeSet,
                meta: {
                    name: "webMain",
                    title: "웹 메인 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateWebMain',
                    log: {depth: 4, access: "운영관리->웹 메인관리"},
                    accessIdx: "OPERATE_WEBMAIN"
                },
            },
            {
                path: "alarm/create",
                component: () => import('../views/operate/AlarmCreate.vue'),
                name: "AlarmCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "AlarmCreate",
                    title: "알림 관리",
                    side: 'operateAlarm',
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    accessIdx: "OPERATE_POPUP_FIXEDPOPUP_EDIT"
                },
            },
            {
                path: "alarm/:idx",
                component: () => import('../views/operate/AlarmDetail.vue'),
                name: "AlarmDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "AlarmDetail",
                    title: "알림 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'operateAlarm',
                    accessIdx: "OPERATE_POPUP_FIXEDPOPUP",
                    log: {depth: 4, access: "운영관리->알림관리->상세"}
                },
            },
            {
                path: "volume/setting",
                component: () => import('../views/operate/VolumeSetting.vue'),
                name: "VolumeSetting",
                beforeEnter: storeSet,
                meta: {
                    name: "VolumeSetting",
                    title: "모바일 업로드 용량 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateVolumeSetting',
                    log: {depth: 4, access: "운영관리->모바일 업로드 용량관리"},
                    accessIdx: "OPERATE_UPLOADLIMIT"
                },
            },
            {
                path: "ip",
                component: () => import('../views/ip/Ip.vue'),
                name: "Ip",
                beforeEnter: storeSet,
                meta: {
                    name: "Ip",
                    title: "CMS 허용 IP 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateIp',
                    log: {depth: 4, access: "운영관리->허용 IP 관리"},
                    accessIdx: "OPERATE_CMSIP"
                },
            },
            {
                path: "log",
                component: () => import('../views/log/Log.vue'),
                name: "Log",
                beforeEnter: storeSet,
                meta: {
                    name: "Log",
                    title: "로그 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateLog',
                    log: {depth: 4, access: "운영관리->로그 관리"},
                    accessIdx: "OPERATE_LOG"
                },
            },
            {
                path: "log/action",
                component: () => import('../views/operate/adminActionLog.vue'),
                name: "adminActionLog",
                beforeEnter: storeSet,
                meta: {
                    name: "adminActionLog",
                    title: "로그 관리",
                    authRequired: true,
                    storeConfig: {userInfo: true},
                    side: 'operateLog',
                    sideMenu: false,
                },
            },
            {
                path: "log/excl",
                component: () => import('../views/operate/LogExcl.vue'),
                name: "LogExcl",
                beforeEnter: storeSet,
                meta: {
                    name: "LogExcl",
                    title: "로그 관리",
                    authRequired: true,
                    side: 'operateLog',
                    storeConfig: {userInfo: true},
                    sideMenu: false,
                },
            },
            {
                path: "registerPath",
                component: () => import('../views/operate/RegisterPath.vue'),
                name: "RegisterPath",
                beforeEnter: storeSet,
                meta: {
                    name: "RegisterPath",
                    title: "가입경로 관리",
                    side: 'operateRegisterPath',
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    log: {depth: 4, access: "운영관리->가입 경로 관리"},
                    accessIdx: "OPERATE_JOINPATH"
                },
            },
            {
                path: "marketing",
                component: () => import('../views/operate/Marketing.vue'),
                name: "Marketing",
                beforeEnter: storeSet,
                meta: {
                    name: "Marketing",
                    title: "마케팅 수신 동의 현황",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateMarketing',
                    log: {depth: 4, access: "운영관리->마케팅 수신 동의 현황"},
                    accessIdx: "OPERATE_MARKETINGAGREE",
                },
            },

            {
                path: "terms",
                component: () => import('../views/operate/TermRouteView.vue'),
                name: "PolicyTermsMain",
                beforeEnter: storeSet,
                meta: {
                    name: "PolicyTermsMain",
                    title: "약관관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateTerms',
                    log: {depth: 4, access: "운영관리->약관관리"},
                    accessIdx: "OPERATE_TERM"
                },
                children: [
                    {
                        path: "use",
                        component: () => import('../views/RouteView.vue'),
                        name: "PolicyTerms",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PolicyTermsMain",
                            title: "약관관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateTerms',
                            log: {depth: 4, access: "운영관리->약관관리"},
                            accessIdx: "OPERATE_TERM_7"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/operate/Terms.vue'),
                                name: "PolicyTerms",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PolicyTerms",
                                    title: "약관관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                    log: {depth: 4, access: "운영관리->약관관리"},
                                    accessIdx: "OPERATE_TERM_7"
                                },
                            },
                            {
                                path: ":idx",
                                component: () => import('../views/operate/TermServiceDetail.vue'),
                                name: "TermsServiceDetail",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "TermsServiceDetail",
                                    title: "약관 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                    accessIdx: "OPERATE_TERM_7_DETAIL"
                                },
                            },
                            {
                                path: "create",
                                component: () => import('../views/operate/TermCreate.vue'),
                                name: "PolicyTermsCreate",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PolicyTermsCreate",
                                    title: "이용 약관",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                    accessIdx: "OPERATE_TERM_7_DETAIL_EDIT"
                                },
                            },
                        ]
                    },
                    {
                        path: "privacy",
                        component: () => import('../views/RouteView.vue'),
                        name: "PolicyTermsPrivacyMain",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PolicyTermsPrivacyMain",
                            title: "개인정보취급방침",
                            side: 'operateTerms',
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            accessIdx: "OPERATE_TERM_6"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/operate/TermPrivacy.vue'),
                                name: "PolicyTermsPrivacy",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PolicyTermsPrivacy",
                                    title: "개인정보취급방침",
                                    side: 'operateTerms',
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    accessIdx: "OPERATE_TERM_6"
                                },
                            },
                            {
                                path: "create",
                                component: () => import('../views/operate/TermPrivacyCreate.vue'),
                                name: "PolicyPrivacyCreate",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PolicyPrivacyCreate",
                                    title: "개인정보취급방침",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                    accessIdx: "OPERATE_TERM_6_DETAIL_EDIT"
                                },
                            },
                            {
                                path: ":idx",
                                component: () => import('../views/operate/TermPrivacyDetail.vue'),
                                name: "TermsPrivacyDetail",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "TermsPrivacyDetail",
                                    title: "약관 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                    accessIdx: "OPERATE_TERM_6_DETAIL"
                                },
                            },
                        ]
                    },
                    {
                        path: "leave",
                        component: () => import('../views/RouteView.vue'),
                        name: "PolicyTermsLeaveMain",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PolicyTermsLeaveMain",
                            title: "회원탈퇴",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateTerms',
                            accessIdx: "OPERATE_TERM_4"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/operate/TermLeave.vue'),
                                name: "PolicyTermsLeave",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PolicyTermsLeave",
                                    title: "탈퇴 약관",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                    accessIdx: "OPERATE_TERM_4"
                                },
                            },
                            {
                                path: "create",
                                component: () => import('../views/operate/TermLeaveCreate.vue'),
                                name: "PolicyLeaveCreate",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PolicyLeaveCreate",
                                    title: "탈퇴약관",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                    accessIdx: "OPERATE_TERM_4_DETAIL_EDIT"
                                },
                            },
                            {
                                path: ":idx",
                                component: () => import('../views/operate/TermLeaveDetail.vue'),
                                name: "TermsLeaveDetail",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "TermsLeaveDetail",
                                    title: "약관 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                    accessIdx: "OPERATE_TERM_4_DETAIL"
                                },
                            },
                        ]
                    },
                    {
                        path: "pay",
                        component: () => import('../views/RouteView.vue'),
                        name: "PolicyTermsPay",
                        beforeEnter: storeSet,
                        meta: {
                            name: "PolicyTermsPay",
                            title: "유료상품 이용약관",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateTerms',
                            accessIdx: "OPERATE_TERM_8"
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/operate/TermPay.vue'),
                                name: "PolicyTermsPay",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PolicyTermsPay",
                                    title: "유료상품 이용약관",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                    accessIdx: "OPERATE_TERM_8"
                                },
                            },
                            {
                                path: "create",
                                component: () => import('../views/operate/TermPayCreate.vue'),
                                name: "PolicyPayCreate",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "PolicyPayCreate",
                                    title: "유료상품 이용약관",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                    accessIdx: "OPERATE_TERM_8_DETAIL_EDIT"
                                },
                            },
                            {
                                path: ":idx",
                                component: () => import('../views/operate/TermPayDetail.vue'),
                                name: "TermsPayDetail",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "TermsPayDetail",
                                    title: "약관 관리",
                                    storeConfig: {userInfo: true, checkAccess: true},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                    accessIdx: "OPERATE_TERM_8_DETAIL"
                                },
                            },
                        ]
                    },


                    {
                        path: "management",
                        component: () => import('../views/operate/TermManagement.vue'),
                        name: "TermManagement",
                        beforeEnter: storeSet,
                        meta: {
                            name: "TermManagement",
                            title: "약관관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateTerms',
                            accessIdx: "OPERATE_TERM_TERMADD",
                            log: {
                                depth: 4, access: "운영관리->약관 관리->약관추가"
                            },
                        },
                    },

                    {
                        path: ":idx",
                        component: () => import('../views/RouteView.vue'),
                        name: "TermsCategoryRoute",
                        beforeEnter: storeSet,
                        meta: {
                            name: "TermsCategoryRoute",
                            title: "추가 약관",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateTerms',
                        },
                        children: [
                            {
                                path: "",
                                component: () => import('../views/operate/TermCategory.vue'),
                                name: "TermCategory",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "TermCategory",
                                    title: "약관관리",
                                    storeConfig: {userInfo: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'TermCategory',
                                },
                            },
                            {
                                path: "create",
                                component: () => import('../views/operate/TermCategoryCreate.vue'),
                                name: "TermCategoryCreate",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "TermCategoryCreate",
                                    title: "카테고리 약관",
                                    storeConfig: {userInfo: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                },
                            },
                            {
                                path: ":cidx",
                                component: () => import('../views/operate/TermCategoryDetail.vue'),
                                name: "TermCategoryDetail",
                                beforeEnter: storeSet,
                                meta: {
                                    name: "TermCategoryDetail",
                                    title: "약관 관리",
                                    storeConfig: {userInfo: true,},
                                    authRequired: true,
                                    storeRequired: true,
                                    sideMenu: false,
                                    side: 'operateTerms',
                                },
                            },
                        ]
                    },


                ]
            },

            {
                path: "report",
                component: () => import('../views/operate/ReportRouteView.vue'),
                name: "Report",
                beforeEnter: storeSet,
                meta: {
                    name: "Report",
                    title: "신고 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateReport',
                    accessIdx: "OPERATE_REPORT",
                },
                children: [
                    // {
                    //     path: 'media',
                    //     component: () => import('../views/operate/ReportMedia.vue'),
                    //     name: "ReportMedia",
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: "ReportMedia",
                    //         title: "신고 관리",
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         sideMenu: false,
                    //         side: 'operateReport',
                    //         log: {depth: 4, access: "운영관리->신고 관리->콘텐츠신고리스트"},
                    //         accessIdx: "OPERATE_REPORT_COMMENTREPORT",
                    //     },
                    // },
                    // {
                    //     path: "media/:idx",
                    //     component: () => import('../views/operate/ReportMediaDetail.vue'),
                    //     name: "ReportMediaDetail",
                    //     beforeEnter: storeSet,
                    //     meta: {
                    //         name: "ReportMediaDetail",
                    //         title: "신고 상세",
                    //         storeConfig: {userInfo: true, checkAccess: true},
                    //         authRequired: true,
                    //         storeRequired: true,
                    //         sideMenu: false,
                    //         side: 'operateReport',
                    //         log: {depth: 4, access: "운영관리->신고 관리->콘텐츠신고리스트->신고 상세"},
                    //         accessIdx: "OPERATE_REPORT_COMMENTREPORT_DETAIL_VIEW"
                    //     },
                    // },
                    {
                        path: 'board',
                        component: () => import('../views/operate/Report.vue'),
                        name: "ReportBoard",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ReportBoard",
                            title: "신고 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateReport',
                            log: {depth: 4, access: "운영관리->신고 관리->댓글/리뷰 신고리스트"},
                            accessIdx: "OPERATE_REPORT_COMMENTREPORT",
                        },
                    },
                    {
                        path: "board/:idx",
                        component: () => import('../views/operate/ReportDetail.vue'),
                        name: "ReportBoardDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "ReportDetail",
                            title: "신고 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateReport',
                            log: {depth: 4, access: "운영관리->신고 관리->댓글/리뷰 신고리스트->신고 상세"},
                            accessIdx: "OPERATE_REPORT_COMMENTREPORT_DETAIL_VIEW"
                        },
                    },
                ],
            },
            {
                path: "notice",
                component: () => import('../views/operate/Notice.vue'),
                name: "Notice",
                beforeEnter: storeSet,
                meta: {
                    name: "Notice",
                    title: "공지 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateNotice',
                    log: {depth: 4, access: "운영관리->공지 관리"},
                    accessIdx: "OPERATE_NOTICE"
                },
            },
            {
                path: "notice/create",
                component: () => import('../views/operate/NoticeCreate.vue'),
                name: "NoticeCreate",
                beforeEnter: storeSet,
                meta: {
                    name: "NoticeCreate",
                    title: "공지사항 등록",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'operateNotice',
                    log: {depth: 4, access: "운영관리->공지 관리->공지사항 등록"},
                    accessIdx: "OPERATE_NOTICE_DETAIL_EDIT"
                },
            },
            {
                path: "notice/:idx",
                component: () => import('../views/operate/NoticeDetail.vue'),
                name: "NoticeDetail",
                beforeEnter: storeSet,
                meta: {
                    name: "NoticeDetail",
                    title: "공지사항 상세",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'operateNotice',
                    log: {depth: 4, access: "운영관리->공지 관리->공지사항 상세"},
                    accessIdx: "OPERATE_NOTICE_DETAIL"
                },
            },
            {
                path: "faq",
                component: () => import('../views/operate/FaqRouteView.vue'),
                name: "FaqMain",
                beforeEnter: storeSet,
                meta: {
                    name: "FaqMain",
                    title: "FAQ 관리",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: true,
                    side: 'operateFaq',
                    log: {depth: 4, access: "운영관리->FAQ관리"},
                    accessIdx: "OPERATE_FAQ"
                },
                children: [
                    {
                        path: "manage",
                        component: () => import('../views/operate/Faq.vue'),
                        name: "Faq",
                        beforeEnter: storeSet,
                        meta: {
                            name: "Faq",
                            title: "FAQ 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateFaq',
                            log: {depth: 4, access: "운영관리->FAQ관리->FAQ 목록"},
                            accessIdx: "OPERATE_FAQ_FAQLIST"
                        },
                    },
                    {
                        path: "manage/create",
                        component: () => import('../views/operate/FaqCreate.vue'),
                        name: "FaqCreate",
                        beforeEnter: storeSet,
                        meta: {
                            name: "FaqCreate",
                            title: "FAQ 등록",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateFaq',
                            log: {depth: 4, access: "운영관리->FAQ관리->FAQ 목록->상세"},
                            accessIdx: "OPERATE_FAQ_FAQLIST_DETAIL_EDIT"
                        },
                    },
                    {
                        path: "category",
                        component: () => import('../views/operate/FaqCategory.vue'),
                        name: "FaqCategory",
                        beforeEnter: storeSet,
                        meta: {
                            name: "FaqCategory",
                            title: "FAQ 관리",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateFaq',
                            log: {depth: 4, access: "운영관리->FAQ관리->FAQ 카테고리 목록"},
                            accessIdx: "OPERATE_FAQ_CATMGMT"
                        },
                    },
                    {
                        path: ":idx",
                        component: () => import('../views/operate/FaqDetail.vue'),
                        name: "FaqDetail",
                        beforeEnter: storeSet,
                        meta: {
                            name: "FaqDetail",
                            title: "FAQ 상세",
                            storeConfig: {userInfo: true, checkAccess: true},
                            authRequired: true,
                            storeRequired: true,
                            sideMenu: false,
                            side: 'operateFaq',
                            log: {depth: 4, access: "운영관리->FAQ관리->FAQ 목록->상세"},
                            accessIdx: "OPERATE_FAQ_FAQLIST_DETAIL",
                        },
                    },
                ]
            },


            {
                path: "personal",
                component: () => import('../views/operate/Personal.vue'),
                name: "personal",
                beforeEnter: storeSet,
                meta: {
                    name: "personal",
                    title: "1:1문의관리",
                    authRequired: true,
                    storeConfig: {userInfo: true, checkAccess: true},
                    sideMenu: true,
                    side: 'operatePersonal',
                    accessIdx: "OPERATE_INQUIRY",
                    log: {depth: 4, access: "운영관리->1:1 문의관리"}
                },
            },
            {
                path: "personal/:idx",
                component: () => import('../views/operate/PersonalUpdate.vue'),
                name: "personalUpdate",
                beforeEnter: storeSet,
                meta: {
                    name: "personalUpdate",
                    title: "1:1문의 상세",
                    storeConfig: {userInfo: true, checkAccess: true},
                    authRequired: true,
                    storeRequired: true,
                    sideMenu: false,
                    side: 'operatePersonal',
                    accessIdx: "OPERATE_INQUIRY_DETAIL",
                    log: {depth: 4, access: "운영관리->1:1 문의관리->상세"}
                },
            },

        ],
    },


    {
        path: "/pay/result/success",
        component: () => import('../views/pay/PaySuccess.vue'),
        name: "PaySuccess",
        beforeEnter: storeSet,
        meta: {name: "PaySuccess", title: "결제", authRequired: true, storeConfig: {userInfo: true}, sideMenu: false,},
    },
    {
        path: "/pay/result/fail",
        component: () => import('../views/pay/PayFail.vue'),
        name: "PayFail",
        beforeEnter: storeSet,
        meta: {name: "PayFail", title: "결제", authRequired: true, storeConfig: {userInfo: true}, sideMenu: false,},
    },
    {
        path: "/myinfo",
        component: () => import('../views/RouteView.vue'),
        name: "OperateMyInfoUpdate",
        beforeEnter: storeSet,
        meta: {
            name: "OperateMyInfo",
            title: "내 정보",
            authRequired: true,
            storeRequired: true,
            side: 'info',
            storeConfig: {userInfo: true},
            sideMenu: true,

        },
        children: [
            {
                path: "",
                component: () => import('../views/operate/Myinfo.vue'),
                name: "myinfo",
                beforeEnter: storeSet,
                meta: {
                    name: "myinfo",
                    title: "내 정보",
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true,},
                    sideMenu: true,
                    side: 'info',
                    log: {depth: 6, access: "내정보->기본정보"},
                },
            },
            {
                path: "authority",
                component: () => import('../views/operate/MyAuthority.vue'),
                name: "myAuthority",
                beforeEnter: storeSet,
                meta: {
                    name: "myAuthority",
                    title: "내 정보",
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true},
                    sideMenu: false,
                    side: 'info',
                    log: {depth: 6, access: "내정보->권한"}
                },
            },
        ]
    },
    {
        path: "/stats",
        component: () => import('../views/RouteView.vue'),
        name: "stats",
        beforeEnter: storeSet,
        meta: {
            name: "stats",
            title: "통계관리",
            sideMenu: true,
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, checkAccess: true},
            side: 'stats',
            accessIdx: 'STATSMGMT'
        },
        redirect: "/stats/media",
        children: [
            {
                path: "media", // 통계 - 영상별
                component: () => import('../views/stats/StatisticsMedia.vue'),
                name: "StatisticsMedia",
                beforeEnter: storeSet,
                meta: {
                    name: "StatisticsMedia",
                    title: "통계 관리",
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, checkAccess: true},
                    sideMenu: true,
                    side: 'stats',
                    accessIdx: 'STATSMGMT'
                },
            },

        ]
    }
]
